webpackJsonp([1,2],{

/***/ 128:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 132:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 133:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 134:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 135:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 136:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404.e7afdfe.png";

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/storm_mode.ac16160.png";

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/0.b8984ec.png";

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAAAxCAIAAACJYEAwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAACGkSURBVHhe7Z17cBzHnd/nPTuz7wd28SBeBAgSFElLoijrZZuKZVssn3VnS3Es15XjclVUyeVyfyj54yp1rkuV/cdVJae6P+Jzlf2Pz3HZTs4+39lxeFFyEY+0ThZJSSTFJ0iCi9di3+/dec/k1zOL5QLYBRYgaIPc/lQTnJ7p6enpAX7f/nX39JDh1/8iJ2kEBoPBYDC9R1hgqcYmBoPBYDA9CRZCDAaDwfQ0WAgxGAwG09NgIcRgMBhMT4OFEIPBYDA9DRZCDAaDwfQ09/r6xO9Mj01GfDTZiAKGRdzKlv/ntXgj/huEpSk/z8a8QtgjeHheZFkXw8B+WdfrmlZVlFxVSlWkkqJphumcgsFgMJgmu9aK0hS1J+AbCvrCXpebZ2iS0U1NUvV8XV4q1RbzVV3XLMtqpN4KYYHdvhCC9nEM8R+OP3Z0Tx/VIoSmRby3mPkvpz5QdWI7hdoWPhc34HNDCIhcQOC9PAfPj6NpCHBUNQwIkqaVFbUoKcW6ulyuQSjLqnM6BoPB9Di71op6eA4kcF9/eDAYjPndfpF1sQxFUoZpqLpRkdVsVUoUKkuFwu1UsVCXdHNrCg1CSItPvwjnNXZsBRC/oIv65L6h8ZCXZ6hmcDEUFOX8fFICeW6kvV+QJOFiSHhyk32BI0N9hwYiIyFfyM270fOjaKTPUAQLNiDq5tmQxzXo9w763F4X7ICzLVXXwYXFYDCY3mSXW1GQ5P39kWf3jTw/vXckGhUEl05Qsk5KJqlbFMWwftE9GgxMD4T6PCIUR9KNugpSuAVRE1l6+0LIUMSQ1/XUyEDULdoVdTfkavLlZK5Yt/NtcRZ3FnhAAkMN+l0vHBg+MhSNekSGpAgQXwscXKN9sEzCohiKCntcIyFvv5fP1WqyZhrb86gxGAzmQWY3W1GQDoamHh+JvXBw4vHxPSTDpWv6pVTx/GL2vcXsxUTxRqYYL9UKsgpF9rtcMa9/bzRA0mSqUq/KSiOXLrgHIbRMljCmo6HHhqIh0dXYuQI4zjfSuWS5asC9QIvh/gB+6MFY4NMHxiJuL0uZpOU8J7gXq/H/mgBPCc0Ngi14lgZNEh5OHA/7ZHD2ZU3Bo4YYDKbH2M1WFFRwMhJ68fDUgaFYWSNOzWZ/fuXO1UQqWSgVq1K5KpWqUqZSncsWryaL1zJ1v0cMuV3gqroo+koy371TCEK4+RhhxOMyTLMig7fZ2IOwTDdtfvHRyRemRvu97sbOFZZK1b+/Hv/by7N1gyJArFcAJ9L2pqlsVW7s2i4BF3NksO8jQ9EI3DUJJYNGioWejkOnlklTlKFQSKEp06KyNfniYvrScqYo642jGMwKXz42/aUnDjQiNufiyW+cfKcRaeHrJ54+NtbfiBDEN0++czaebERagL/VN15+Hn7CdjOrNed2Sb4mv/7Tt+BnI27TNqtOZcb0MrvaioLECtxXnvrIo6NDVY18fyn/6ztL+WrF1A00DwXKadgXohkoA0lRPM/uCfifPzC6L+yrViunZ2b/95XbktZVYTaZLAP3KDLMielhqKZMTV4o1ufzlbykMDS5xy8+2u/7+N7B0YBf5NjGCSvUVG02V3p7LnFxubRYlnTDCgk8ONHDQbFPdEGVnbyxUFf17TnSUPEcQzw+BM8vNuT32u0Xe1oOPL/uM0SPz/5JMFCXS6XKhaXkB0vZ3+QEH8wDwZ9+9pn/9NlnGhGbX3x4+6Vv/6wRaeHn/+bznzs80YgQBKSBlI1IC4N+z7k//n34CdvNrNac2yWJUvXYn/0AfjpRaGW+9uyRf/Xckf2xkLOnyUy68MNz12DjR+euwbazE9Oz7H4rCrIyEQ197RPHvIJ4fjF7+uZiolAgdJ0wwBO1hRCcVygtTSOhgjKQJMNwj4wMfXxiaDLons9lvnPmg2SpqkH6zdhk0W2WpPZH/c9PDHzh8PgXH5t86dDYJ/cNPjnc9/RY7MUDw58/MjEW9OuqliuWcoUGsAFRQ9UmI/4vHJl4cXoEEsMpcCKcDh4kZPXPJgYOxvwsqr5tVJdFk9ZY0H1oINzvE233vKvnB3XFMZRX4KD1gOLNU+B0woCsDg9ExgJuyHyTjDC9xJNj/VPRYCOyu4l5xS88uu8/vvjUehUE4C5AziH8/kcPPih3hLlvbGJFKZIMiBzPoJkwG9E85T5YUR/PHYpF/C4xVVNvpYuJQgmpIFwO3EET9cqiRHAR0DlwDeGQpuuqemMpdSOZqxtGf8C/ry/k5tc6aZ3oOEYIIuvnuFeP7t0XhTqhRZYeDoiP7Qk/NhR5ZjT6SH+QIYlCubKQyCwmk+l0Kp9FJLPZTLFck1WapQJu4WB/6OhQ5MnR6NPjUTgdMqEogqOpAMtcWEzJBsj6xjW9FpKwvCz5mYPjAz4fS0MMGgib1zk8T4GlQ25hMOjLVyWz6Yo6z4s0KZJyMVzQxd1K51So6C2WCvOw8u1XP/XKY1ONyArzhcqbV+OyvrZL49Vj060i9KPz19v6Xshve+4I/IRtSADJYAN+paNesaKorUEzTAHa7TYVWc3VpDUJUuX6f3v3Sk3VILfPHZn43ldONNPLmp6u1p1kEOUZNAMe+MS+YdUw7UndO9SFhXnQ2NSKsgw1PRACrwt+A51uyI2Ao8hk7rAVBVn9+L6hwWDg/UTxWrJQqUlI/wDLcd7sMsEmksaVMhCmbpggPT43P+r3g0DeyRWL0ubDcEiYGpvr8HDMgajvyGDYx7LgNDeDj2VEhimX65dn4ouzcbmcY3S18cdne8gQhZ1wCBJAMkgMp7Tm4GHZA4Phw4MRL49swZYQOW60L9Ln8XEM3Ddk1xVhj3Bkz+Bjw0NwvQ4PR4cM+3y+0XBEZLdcKkxP8bGJoZN/+ErELTTiO8HrP33r2J/9YE2AnY3DBPGdty+tOQrhxH/9SRYMBEG89uyRN15+3knpcOb2UjMZnNvYa7M+Maan2NyKwm6DOLJn6PGRwZi3+9/zHbSiusiTI5EQqFqqWi/UW6aAQouOQjrTEm1sIjk39FS+Ek+X4cTRvpDIsEgmu6CjEIIgvzg97mU5arV2gHeVzhVm5xfUSknXVAvNzLGaKewNC3bCIUgAydLZAnX3OAIy9LLsianhAS945VvBMoIu5uhw1MVAjtBQsdsCnaFIkHrq4EDfoeH+wbAfWhLZSu2uO9jEblCQpAXZHt0TDfJMw+/GYFbI1+Svfv/k2fgybLtYJuYTUefGzgH5J0rVNaF1Fgx4hGuOQkhV6gZqehMeF+fMvnH44blrf/LzM81k3zlzsXWmDLiPrYkxvUUXVhSMZKZSgyP9Qf/0nn4woWBI0fuEG7CjVpSjaZHneJ6XdDIvaRVNXyXXUBL01wdaC8EWKJDDRpeHVZPlfE0yLNIr8ixLd3J91tD+jxncwbGA51B/gG2Z8+mQLZRTmWytXHYm7VQV9U6hci6RPz2fgQAbEIWdKKmhQ7JUNpstlVG0iWUxujEm0uM+PgD11TVQO0FBGPJ5acp21+2q74RtrTxTA33jsVDU5xVYVtH0bLXmGI5VOL8KlgXZDgW8QbfgrKSA6WVALf79J59oDqfJuv5/rs2B8DjRXcWXj00f3zfciNgq+N1fXWqdsDqTLvzg3at//g/nQU0buzC9SjdWFIwkmEowmDzDRjzevX2hg0P9YBvFlY73NuywFSUpEpqatG4Siq5rpmEQpE4wENBoGmgbSSIthECC1NlaiNQRnakbuqzIkm7QNMWzDNO517OVdoksgoXLGHqmXAYlbr4lCRtQNaCC1XKZtqCurHxdmclWzi8Xzizm/nE+CwE2ziUKMzk0uRQSQLJqpZzOZ5v5gLNoqIpSrebyRVrXebjQusfQHsv08FzEI/AMnENuoILQcvEL/FDQNxkL7+vv84sCQ1KGbiqKCo0Fuwm0DthnQt2SPEfCJTwch14axfQwXp57/YUnnDG/VLkOKgha6BwCXAzzqenR2Fa7NO4PX3riwPGpu0L44/PXT91caERWAC184/+ed8YLASj5pw6MQmPRiWJ6he6sKBhJMJWKphqGCcbTL4r7+2NT/ZE9QR+Y1o6u4c5ZUfBW7r6RCMKBxIPUSQaCQdANLQTtgoCE0NZCiKAoOsG0TA38NItgQE7hRrugnRCaRKEinb2z9MOzlxdyeUnVnO5EpHzFiipVCUOFgkmacWG5cGqhcClXL2imSlIQYOPDfB12XkgXZN1eakBXtVqtXKnAtgXlU6VyubiQTJ+OZ88v5VJlCT2MbjD1gIuOel0EobV/enYrgaUpD89MxUKHh/tHIiGOYkkTaa2qq5K66agpZKtF3a4AT8PlGvswPc/ZueWvfv9ka0dlyO363ldOPDk20IjvDqBxCpotdzELBkr+vX95Yv1SGJiHnC6s6AokGEwwm40Y6iYNHNzTPxULe10smNnO+rIzVhRpB5I/grRoAgJczu7/bGohOgaAgoHrSXEEwdoyCEIMXiDL0eDLWZquGd310LYTQrgeRVQk9eyt5f/85q9+fWfB6VExDCOZTYLXCdt1Xb9dLL+fq5QskuBEgvO0BLFkkh+kKwvlsmx3n9ZldSGZh8aFVq3Ui7nrS4nvvjfzy+uLmeoWVsEBvBwfFuyRW7i1dg8R2unDIf9Tk6OjsbAI7ZEWiQX/WtI2WjcAZWjXWNgteF28vQuDeZDIVqUT3/rJmdtLjTgGs45NragNKAoHrg6YzcYOwESzbPb2Rz6xf3Kyzy+27U7YISuqo1chFFVTOdbiecL++sUKoIUMo1KcRrANLQSQTKIyQ+AYDpxRN8WCd6ZqcAddiXE7IQTAaaZImaDm88pP3r3y9o04tA1An2VZNux1a8qqfq1Qq1uUybAE1AgE3oWCvQ07ayb1Ya5WUlAhQAEluQoKrxvm23dSP/zgzo28VLFIA4l5xyKsx8UQov364frnx1DoPWXwAqf3xIKimyMZ23m+C3inqkESNNTUqv2rsLOFS8CFML3Mk2P9bR2mb558x3nbYXdiWGaXHiGmZ9nAiq6CJlUDmc1G1AaMKkPSbp6fHIwd2tM/6HeD4V3LDlnRuqIl8kVDt8aDwZjHd3eaqI1FkSZFgRaqBAcOItoF9wRaSJN9PnEk6DZ1JZ5Od7/iaAcVoihQYYumVYK+lSsvFMogrHCDpm6i7luCkA0rUdcNcEhpnqBZ2zm1hy5hA6IMb9DcQl2X7HokLYtEPrKlmcZiSb6Rk2oW+Ls0Eno02mlfsQs4mhbYtQOw4KL7BX6sLzjZH94T8gcEgaGgPtYOPVqmaRpm63pvnYBL4MkyPU7M624OoZ2aWfjxividjSdvpPLONgbzINLWirYBfCEDWlarB67AqFrI5PpcwlDIPzUQ3RcNh9z8+n7Se7eipbp0eT6hybWDUS84oDzH6fbbeXc9GQq8NQqCQdLOPBo4Iri4vdHQvlhIUqUrC8lyFy8ROnQQBhAMCoSKAvfOoBkdKsUCf4qgVqoFBLFmkBakoUDMoAQr9wwb9h6LoWs66bypDyc6ag5apJMWZIgcR8gcTu9CmRC2qtEUxayrXHgEHhc7Gg70B3zC6u7QVaAV07vqLIZLNGbGr5ZSTG9y6uaCszjZeo49OOvOYDAbWNH2gMHsNNvFJMDYDgb9Y32hoItdP33m3q1ouS5fjC+lspmYi3yk3zsa8lhodJAx0QAh5Gxnbv8PWogGDkmapOixvsCBgXBY5BL5wpWFdKX1BcQNsbNrC0gU+HZwi+BfrdwoA5v2BsgPagVAfUJYUwtIMNH/FKRYOdSoDdjFUCRnZwiZd6mCgN2dvbIQ0Cosi1B0VdJUTdORw9oRKMqagrYHLgEXQtfpSjcxDxsbv2ZXldXmrJmvn3j61WPTzjYGs9vpbEU7sJHNBGMrKUpFrsuqak+mXMW9W1FJ0+YyufMz8XyhuC/ofmY86nWB2hEqAXLIWa2uIfyP/C/K7xaendwz1SfmCplzN+7A6ZvMC2lhYymCK6DOT4blGJaFm1JBfu2rszQVEqAh0LGa4FDIzbJ2FzKok2prIePycYKXYXh7VLPjue0xCEMztHU3ZlpmvlR571b8Unw+V1n9wmIrjvPaBXAJuBBWwZ5l44VXvvP2pdYFXzCYB4kOVrQ9qG+vo+8IxhZM7rlb8WSpYqxzHO/ZijIEySsm9daV27cWE4RanwqJn54edkYrdBRAWZxpog1cLP25Q5P7gx69Ll2dW3rzw+syaBUJWtOV2d9ICEHM/CL/+cMTz40PCQz62gXBgY+ITvGzzCMBD3rdsAMgko8EPZAMReAUFvw/UuDZj0+OvnxkKuJt0628CRShmEa7iQCkSbKKbi7kSxfii1fn5uqytP5LVDTNsExXC7DCJVTTHn/trv8A85DRukrLN06+0xwgdKi0eIQYzANGRyvaBgEcIHqtioBprcvy1bnEhXgCTC4YXoNcJUgO92pFIT+aNCmioumnr924eueOlzQeHwhMR4MeAaTEca4olWBNe6aohxcOREP7YwHKUD64fef09VkJHFKnO7M7nekohALL7A37fu/w+Kf3D0+E/QxFUSQV8gc5mgXnzs3Sk35h3CuI7d7bFxlq3CdMegW3vdQvx7KhYBAyYGhqLOR7YWrkpUfGp8K+9hNw2wIXoYi6qhaldn2+aESTkQ0rU63PJrNX5hLLhQI47I2jNixD86DiG3SdrlCU5BqcC9W3RaXGPHxM9gW/9MSBP/3sM62h9fOEx/cNv7r6a4W/RZxFAPCwJaY9G1vRNYDCcGhdlkbUBowqmNYrc0uzyTQYWzC5yGtsN8J1r1YUnQgyxpgMM5srXZhdXFxe7uOtx0dCAZGDoxZ6rwHKSBkEBd6hTxAeH+nzcsTtRBIpdLFKsJzzqcIuC9BeCHmGHgm6PzW153cfGZuMBByHlKapgVDY5RLhzsHhiwjMoyFx0suGeZK3qwsEGDYiPD3p5eFQxMVAMoukOJc4EA47Y6ccQ42GPL8zPfrCWHRvQBC7mb8E2MUsSWq22mGNK5KmaNYi6ZKizSRTNxOpxVyuVKs1XUO4I9Bdqou+8WxFggs1IpjeBkTO+XpRa/hyy7jg8anh5jDhuXhy00/9oSVdpkddq16M2jGcZeHafoZpDevXysE8/GxqRVsAU8mzDPgPThQMaakmLebyYFrBwJYU2SJJMLl3p0muZgesqC2EEGSTnknlL8bnKV0+GPXEPC43x4orAdwbF89GfML+aMDS5UtzS7czRZWAE1eEsDvaC6HfxTw6GPzC4RE/T69MlEE9pQGvKHh9NOeyCBJE7qCfPd7HHwuygwLlY6kQTw2L1BNB7nhEPOhlWdJ++Z91cW5fQBSbfaGQoY8lPzPiPxrzhIUtWASo2XRFssy7r1GuBbSW4wiGiudLF+MLM4uL5VpdtVd342jazTH2wkKdgYaGaaVLUqmGhbBHCbldICeNyBb5xsl3WueXts0KLenylRMbTMbZBvma3LqIaNvr2kvvivRK4339WjmYHmFzK2r7Y2AqwWCC2QTjqek6GNKZxeWL8QSYVjThH8ysMyl0PTtrRaEoLJOSpdl8XpPUCMdMBr1TfYGJSGAiHJiAjb7AdH9gKuL1c4wqqfO5fFaS7JmYbTpsN6D9zUCT4U46ny9VncXVWhkfiIUjEX1l4kmYZ56IiP9izPuvp7xfm/C+Mup9IsKHV5YUgGSxSGTfQKwRdzBNS1FqknwtVUyUt7CKMWhaoapWJdVaWV6nHdCOgAfIKwYxmyqcvnLj1vJi3V4Nh6EpDxrW7HAmcretalUt1NU6bin3Km+8/Pxrzx5pRO6NHcxqY17/6VutH1pqe1306ah/+0rEs5OfjsI8iHRjRdFURw/L2cNesqrOZ9Jnrs7MpjKKYYBp3WhZkh22osiYE1AMipE1MlmqGbr1wkTstWPjf/DRu+FrR8eP7+0zdCVZqspwCgPu4JbHJtsJoUmYmrWQrf7yw7ikrr0ZhqUH+yJjg4PO/BeoMp4k3STlpVCADYiiTE3wBVlIBonRtzBa0DU1X8y9PZdOliVDs5c/7wrGIui8JF9YzKjr5sKsBsSOtGhGp6iqpl5L5C7F5xP5LNRn1O2+6+GuQzXMC4lMHi3MDQW+L51XmF1O050Cbwl8ppe+/bO2oRt3CrJ67WMf+fqJpxtx+zMRf3LiqUZk51jvEa6/7jdfes7+dFTHX35Mb9CVFaUoMuQGW04k8oWL8cUPF1IVVdEptAqK7Uhs9Fu001aURMOQDAfZJUrF1PKd8nK8npitL928GxKzpcRccnl+LputGyYkRqdskQ5fqLdMTYNWgzwV83tdPEuhr03oiqzJNUWRWIoSXS4GDaVyuknqaM0WNBgHf2VouizFcC7R7/MHfO6g6KJIU9c1qD0KvT6PIlK9lsjm/+5GYrGmaKDE4GJ38+eJHoBlGBq0UMZCXp5F03cah9oC6eFJkmgRHFlWJFXVTIOh2Ey1vt7NhWRwNFurv3N7MS8pBpyISts4iOkdml+ZL0jyH//tmffmUzPpwvqQqUhfe+aQI5lgGniavrycVXW06AT8Zh4ejNiZoRUXh4Je+Hl8ahjCy49OPTsx5BwCTs0sfP/dKx8mso34OqAkzQHIUzcX/nHdNyWa7Ox1MQ8t3VlRaDDFfN5ivbaYLaSKlYquU7ZbZp/emftkRe0yg8gossRVcmQprRfTSiGtFDMrIVstZBPp3LlEPlFVwNXd4K2Ptogs3U4IUdFNw9AlRXYzdL9XdFOkIsvFUjmeTM8sp7OVGsUwkWBAENwkeiuB4XnO5RLcosAJguj2+ry+kM/jddHJQvHmcno+V5A1jQLvEe5HUTLF0vtLmVPzmRpclrbXZusGVCp4hIaiql6O8YuCi3WWzOsM0kIaBNgwrIokVRUFtktym9c/oeqKknI1kb62nFPBl4V67LJUmIeLphBWFPW7v7rU/G7RGkACX3vuiCOEoDeHhiJ/9esrkDieL4Mctr5l31QjCGNhf2MvWq1t+S9PX+i0Zo1D90II110olCH/Ib/H+QDbvVwX89DSnRUFw8nR1GK+kK/WdPAnGHtSzMYqeF+tqGWqqloqlUdoJUTJgqXQRmuQdbWeqtbeTlZq4Ioh9d3adTsIIWAvSAZOYCJTHfVxvKlk8vkb6eKbNxO/vDx7cSFTltSgwEcCvr6gLxYOxfoiEPoikVgkEg0HoaVhVMrJfO6t24lfXI6fubWQLpdN9EEMVVOkm+n8X19bKGm6vULbVgptURDA+0yVq30erx8eov03vznwPKC1omslSbLQ5dY+UVkz7mRKp2fmJB20Ezxr7A72HNAKjnrELx49MBEJQHRjIRQ55vc+si8o8o7qtCYeDfk+eWAUtuGXs+1HQQ3TAofy3/33f/i7S7cauzrQvRACS8Xqm1fjnzk43ixVK7Kmp6t1KNUf/Y//t+l1MQ8zXVhRy7JKtYqmG868zcbezbiPVtTWIxdLfGI6ONoXCPp9Hp+nNfB+UXUzF9KSCne3k0IIGZHoXQNoONRk+dz88t9fn/unufRCpSqZZs0w5wrl9+fTAY8Q9oAbuPpFdVOXpBo4jm/809WLqUJR1RWLSNWUi0u5d+KJ95cL13P1hbJkMPaC3VvqzIVqJaFQaMmCSl1yc0zM524c2hS4I0d32z2c68vZX88uZSXQZsdJxTLYc4AKnvzDV46OxNZr23pkXf/ZhZtHR/vXq2aiVPvBu1ch+vhIzDm6BlDBE9/6yXsLaX2Toe6tCSGwplStvHVz4bPf+hso1Y10YdPrYh5murKijj/HdHo7oi330Yo6Qkhbzw2LEVbkCZZGF7gboJx10zq7VFHMbQohGX79L3JSuxV3LAstra0rHsayDF3WDTQAQqC3+hGmKdDkZw7t/d1H94+E7na8AIamJPP5MzNzP7oYr+pWo0yoN1IDaQXppShGAseZodCo5hZLjDKCP2ND50lj0O85NBR9bE+EocG7306lQ6Gg0fPhYvLDRHKhWFUsqFL7gxjbyg3zQONimY9NDDmvzALgQp25vbTxGhxPjvXHvMiItE3cPLqGbnJ2iHnF5rd/Z9KFLj980fa6qUrtbDzZiGB6nQfNipo6oas+yviDJ8MTgk9Ar0asQrL021L1L8+myya9jckyYYHdQAidW9QJS0WCDDdFQjPBnjgLUdPgCAuq76tPH5la/QKvpsizyfQvLs++Fc/KzrglUjuoesjHXobVHrpDk1y76Hduj10qjiJiHuHwQGR/LOJzuxi4EGTeJfa4brEm30oVry6nk9WaDK1kcOfvz5vOGAwGs7t4gKyoLYRuU/vne/lJt+AGJ3A1kmncrkk/vq3UKHZ7QtihaxRAygf/gadJ2m9y2J4y3CHasI+TpIuijo70R1d71qamJfLl0/F0RjZMaBcwLQ0EOBfuAeVAoZ3bU0EA+d6kYRk1Wc2UZJpEnjNFkra7uVmeJGGYZlmWl4rlmVT+vXgyU69rsBeeHwnlbKTCYDCYh5kHyIrarhep62y9Uq9UC8VyLl/MF4rZQjFVKC0XKwuFylxBWlDRRwNXXK8t0HmMsAlkCKKFpMsOcKsAXAZpmAENiidHB/q9bqsFQ5Xjmfz/mk3I0LK4uwaP0+ncEpystgeUyn6KFkHKmjGbKWRKZcL+RBaItWkivxN5nhBsrYVSwT7YD+0X1dKLVfnaYvrd2wuXl3KySVqoKxzKab+GicFgML3AA2RFbSE0Db0kywuF+mK+ksqVMoViolCeLUg3SspM1VjSKQl9KH6bQti5a3RjoGSGQhnaH330wNH+UKsjCvX1fjL/52dvWKCCNL/1UcCtYKLPihCGRZM6S6I1gSJe13Aw1O/3BAWXh+dEe4J7XVarilqQ5GSpupDNZ2tyTdM10GwLHhv4u6wtzBgMBtN77H4rauqEoRKaQkoKqVRJTaIMnQRZRlJOmjRjsYLFeyyBJ1h74RtQ5a2w4RjhxlgW+MaErox7GD9DIa+acDKBRgFV1s3bVZ1goEyO73j/aIz6IvfUJCjL4hhTZDgXg1bJY2jKWekbvHjdMFUDfX+krquqQZlQKnQEz47BYDA9zq63ouhbwhqavKkohCKDIiLldsYy4ZqgwaB/vIvgeTQH03FMt8K9CKGthbpK6BIadEXi7MyCgxqxV3tjBHtS6PYmIm0RaC+gn8h9dp4lApXQ3nCAYjglcZ4c6p5FW1ttO2AwGMxDyK62oqbdB+kojk7o4L+2aBYIIQMBrcRmf4AQimSXqmvuQQgR4BTaHitUXOsgIyoGtBHs7trfhAyuYEEx0BJv9rYdUKmcklGoVM2nCEAJt/KKDAaDwTz87ForikoC/8Dpsp3XZiEBJDeOS2q7YVvXnHsUQhvkorbKoA1oMqj0bxGoJag09PxWOmzhGUIFYe3DYDCYbtilVlSz3dZGBIFcL/i3fcUBIYTz7w2QYnBI1wTkC/5WgUcFRXDe2UcBNrAKYjAYTNfsUisKbp9TnpWA3m6/V8W5ZyFsuMrrwy5hVxUGg8FgHjh2oUlfH+6JexdCDAaDwWAeWAji/wPN31r1bfwJ3QAAAABJRU5ErkJggg=="

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.4598eb3.png";

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/weighting.7db9bd3.svg";

/***/ }),

/***/ 145:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 146:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 147:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 148:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_snowflake.139f780.svg";

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(135)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(163),
  /* scopeId */
  "data-v-e8a4e726",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(128)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  "data-v-112126b1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(129)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  "data-v-54484697",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(132)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(161),
  /* scopeId */
  "data-v-d2880cda",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(130)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  "data-v-706eab1a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(131)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(160),
  /* scopeId */
  "data-v-829ec096",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(136)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(164),
  /* scopeId */
  "data-v-f42e1ea2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('v-container', {
    staticStyle: {
      "max-width": "1024px"
    }
  }, [_c('div', {
    staticClass: "elevation-2 content"
  }, [(_vm.viewedDevice.id !== 0) ? _c('div', [_c('div', {
    staticStyle: {
      "padding-top": "8px"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath
    }
  }, [_c('v-btn', {
    staticClass: "back-button",
    attrs: {
      "flat": ""
    }
  }, [_c('v-icon', [_vm._v("chevron_left")]), _vm._v(" " + _vm._s(_vm.lng.back) + "\n\t\t\t\t\t")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.viewedDevice.title))]), _vm._v(" "), (_vm.language === 'en') ? _c('div', [(_vm.viewedDevice.id === 0) ? _c('div', [_c('v-container', [_c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HAQCS-Monitor',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "haqcs-height no-shadow",
    attrs: {
      "src": "/static/img/offer/haqcs.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("HAQCS-Monitor")]), _vm._v(" "), _c('p', [_vm._v(" Air quality monitor and controller for decentralized ventilation and humidification. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Ambientika-AUTO',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/Ambientika+HAQCS.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "ambientika-auto-height no-shadow",
    attrs: {
      "src": "/static/img/offer/Ambientika+HAQCS.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Ambientika AUTO")]), _vm._v(" "), _c('p', [_vm._v("Ventilation unit for fully automatic, demand-oriented, decentralized ventilation systems. Through optimized control via the HAQCS monitor, it saves heating energy more effectively than when controlled by humans.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HRU-WALL-WI',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/HW_app_moni.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "hru-wall-wi-height no-shadow",
    attrs: {
      "src": "/static/img/offer/HW_app_moni.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("HRU-WALL-WI")]), _vm._v(" "), _c('p', [_vm._v("Ventilation unit that is factory-equipped with HAQCS compatibility and can also be manually controlled via a smartphone app.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Marley-MEnV-HAQCS-Edition',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/marley-MEnV-HAQCS-edition.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "marley-haqcs-edition-height no-shadow",
    attrs: {
      "src": "/static/img/offer/marley-MEnV-HAQCS-edition.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Marley MEnV HAQCS-Edition")]), _vm._v(" "), _c('p', [_vm._v(" Successor to the popular Marley MEnV 180 model. The HAQCS edition has HAQCS compatibility. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Upgrade-Marley-MEnV-180',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/upgrade-marley-MEnV180.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "upgrade-marley-menv-180-height",
    attrs: {
      "src": "/static/img/offer/upgrade-marley-MEnV180.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v(" Upgrade for Marley MEnV 180 to HAQCS ")]), _vm._v(" "), _c('p', [_vm._v(" Set of control boards for the popular ventilation units with heat recovery Marley MEnV 180. After replacing the boards, the devices become HAQCS-compatible and can be controlled automatically and automatically by the HAQCS-Monitor. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Upgrade-Prana-150-200',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/upgrade-prana150-200.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "upgrade-prana-150-200-height",
    attrs: {
      "src": "/static/img/offer/upgrade-prana150-200.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v(" Upgrade for Prana 150/200 ")]), _vm._v(" "), _c('p', [_vm._v(" Control board for the decentralized ventilation units with heat recovery Prana 150, 200C, 200G. After replacing the board, the devices become HAQCS-compatible and can be controlled automatically and automatically by the HAQCS-Monitor. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HAQCS-Unibox',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/Unibox.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "unibox-height",
    attrs: {
      "src": "/static/img/offer/Unibox.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("HAQCS-Unibox")]), _vm._v(" "), _c('p', [_vm._v(" Power controller for simple exhaust fans for 230 V, which do not have their own regulation and control. The power supply to the fan is looped through the Unibox. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0xa778) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": __webpack_require__(52)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v(" Air quality monitor and controller for decentralized ventilation and humidification. ")]), _vm._v(" "), _c('h2', [_vm._v(" Functions: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Measurement of air quality and indoor climate ")]), _vm._v(" "), _c('li', [_vm._v(" Display of current values ​​as numbers and graphically ")]), _vm._v(" "), _c('li', [_vm._v(" Display the trends of the last 3 or 12 hours ")]), _vm._v(" "), _c('li', [_vm._v(" Air quality can be read even when the screen is switched off ")]), _vm._v(" "), _c('li', [_vm._v(" Alarms at threshold values ​​of CO"), _c('sub', [_vm._v("2")]), _vm._v(" optically and acoustically ")]), _vm._v(" "), _c('li', [_vm._v(" Control of compatible ventilation units (up to 16 at a time), 3 automatic modes, night mode, intensive mode, manual control, automatic dehumidification mode, summer mode ")]), _vm._v(" "), _c('li', [_vm._v(" Control of compatible humidifiers ")]), _vm._v(" "), _c('li', [_vm._v(" Retains settings after a power failure ")]), _vm._v(" "), _c('li', [_vm._v(" Does not require a router as it works without being connected to the Internet ")]), _vm._v(" "), _c('li', [_vm._v(" Can hang on the wall or stand on horizontal surfaces ")]), _vm._v(" "), _c('li', [_vm._v(" Wireless communication with devices with WiFi technology (no IP protocol) ")]), _vm._v(" "), _c('li', [_vm._v(" Range corresponds to WiFi ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Technical data: ")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Internal sensors ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Carbon dioxide CO"), _c('sub', [_vm._v("2")])]), _vm._v(" "), _c('li', [_vm._v(" TVOC ")]), _vm._v(" "), _c('li', [_vm._v(" Temperature ")]), _vm._v(" "), _c('li', [_vm._v(" Relative humidity ")]), _vm._v(" "), _c('li', [_vm._v(" Light sensor ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Screen ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 3.5 inch color screen 480 x 320 pixels "), _c('br'), _vm._v(" touch sensitive ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" LED display ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 8 RGB LEDs ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Power supply ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 5 V USB power supply, micro-USB connections from below and from the side ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Colors ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" Bordeaux, dark green, gray ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Scope of delivery: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("HAQCS-Monitor")]), _vm._v(" "), _c('li', [_vm._v(" USB power supply ")]), _vm._v(" "), _c('li', [_vm._v("Micro-USB cable")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x1bcf) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/Ambientika+HAQCS-high-quality.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": __webpack_require__(49)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Upgrade of an Ambientika brand model to HAQCS compatibility. Together with the HAQCS monitor, it forms a fully automated, demand-oriented ventilation system that optimizes ventilation and thus saves heating energy, something humans cannot do.")]), _vm._v(" "), _c('p', {
    staticClass: "p-p",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("This makes it our top model.")]), _vm._v(" "), _c('h2', [_vm._v("Features:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Communicates with HAQCS monitor and is regulated by it")]), _vm._v(" "), _c('li', [_vm._v("Continuous control of ventilation intensity")]), _vm._v(" "), _c('li', [_vm._v("Automatically closes the air duct when not ventilating")]), _vm._v(" "), _c('li', [_vm._v("Displays current ventilation intensity with a colored LED")]), _vm._v(" "), _c('li', [_vm._v("Requires a HAQCS monitor for control")]), _vm._v(" "), _c('li', [_vm._v("Equipped with G3 filter")]), _vm._v(" "), _c('li', [_vm._v("All service activities can be performed from the inside")]), _vm._v(" "), _c('li', [_vm._v("Automatically adjusts the brightness of the display")])])]), _vm._v(" "), _c('h2', [_vm._v("Technical specifikations:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Airflow:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Continuously up to 60 m³/h")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Power consumption:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Below 7 Watts")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Noise level:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("30 dB(A) at maximum speed")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Heat recovery:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Up to 93%")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x0f43) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/HW_app_moni-high-quality.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": __webpack_require__(50)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Ventilation device from the Alnor brand, factory-equipped with HAQCS compatibility, thus ventilating fully automatically based on demand and optimally saving heating energy. For budget solutions, it can also be manually controlled via a smartphone app.")]), _vm._v(" "), _c('h2', [_vm._v("Advantages:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("HAQCS compatibility - retrofittable automatic demand-driven ventilation control based on measurements of indoor air quality in conjunction with the HAQCS monitor.")]), _vm._v(" "), _c('li', [_vm._v("Easy installation in exterior walls with minimal wiring.")]), _vm._v(" "), _c('li', [_vm._v("High delivery capacity: 20, 40, and 60 m³/h of air.")]), _vm._v(" "), _c('li', [_vm._v("Built-in humidity sensor for automatic dehumidification when needed.")]), _vm._v(" "), _c('li', [_vm._v("Quiet operation.")]), _vm._v(" "), _c('li', [_vm._v("Free app for control.")]), _vm._v(" "), _c('li', [_vm._v("Easy to clean.")])])]), _vm._v(" "), _c('h2', [_vm._v("Control:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Controlled by the HAQCS monitor based on data from its sensors. Always fresh air according to demand and energy savings. Automatic. Alternatively, manual control with the free WallAIR app.")]), _vm._v(" "), _c('h2', [_vm._v("Service:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("All service and maintenance tasks can be conveniently and affordably performed from the interior. No need for external scaffolding.")]), _vm._v(" "), _c('h2', [_vm._v("Technical Specifications:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("3 performance levels:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("20, 40, 60 m³/h")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Exterior wall thickness:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("200 – 560 mm")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Power consumption:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("1.4 – 3.8 watts")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Sound pressure level (3 m):")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("10 – 26 dB(A)")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Sound insulation from the outside:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("39 dB (equivalent to window class 3 according to VDI 2719)")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Heat recovery:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Max. 82%, Average 74.3%")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x7b90) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/marley-MEnV-HAQCS-edition.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": __webpack_require__(53)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v(" Successor to the popular Marley MEnV 180 model. The HAQCS edition has HAQCS compatibility. ")]), _vm._v(" "), _c('h2', [_vm._v(" Functions: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Communicates with and is regulated by the HAQCS monitor ")]), _vm._v(" "), _c('li', [_vm._v(" Shows current ventilation intensity with a colored LED ")]), _vm._v(" "), _c('li', [_vm._v(" Requires a HAQCS monitor for control ")]), _vm._v(" "), _c('li', [_vm._v(" Has G3 and G2 filters, optionally even F7 filters ")]), _vm._v(" "), _c('li', [_vm._v(" All service activities can be carried out from the inside ")]), _vm._v(" "), _c('li', [_vm._v(" Automatically controls the brightness of the display ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Technical data: ")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Air flow ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 16 - 25 or 37 m³ / h depending on the level ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Power consumption ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 3.5 - 5.0 - 7.5 watts depending on the level ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Volume ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 22 - 29 - 35 dB(A) depending on the level ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Heat recovery ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" Max 85%, average 79.1% ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Scope of delivery: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Marley MEnV HAQCS-Edition")]), _vm._v(" "), _c('li', [_vm._v(" Filter set for 2 years ")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x217d) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/upgrade-marley-MEnV180.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img",
    attrs: {
      "src": __webpack_require__(54)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v(" Set of control boards for the popular ventilation units with heat recovery Marley MEnV 180. After replacing the boards, the devices become HAQCS-compatible and can be controlled automatically and automatically by the HAQCS-Monitor. ")]), _vm._v(" "), _c('h2', [_vm._v(" Functions: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Communicates with HAQCS-Monitor ")]), _vm._v(" "), _c('li', [_vm._v(" Controls the fan and the indicator LED ")]), _vm._v(" "), _c('li', [_vm._v(" Monitors the operating time and reminds you to change the filter ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Technical data: ")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Power consumption ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("0,30  - 0,35 W during standby")])])]), _vm._v(" "), _c('h2', [_vm._v(" Scope of delivery: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Controls for 2 devices ")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id == 0xacdc) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/upgrade-prana150-200.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img",
    attrs: {
      "src": __webpack_require__(55)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v(" Control board for the decentralized ventilation units with heat recovery Prana 150, 200C, 200G. After replacing the board, the devices become HAQCS-compatible and can be controlled automatically and automatically by the HAQCS-Monitor. ")]), _vm._v(" "), _c('h2', [_vm._v(" Functions: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Communicates with HAQCS monitor or remote control ")]), _vm._v(" "), _c('li', [_vm._v(" Controls the fans ")]), _vm._v(" "), _c('li', [_vm._v(" Allows all automatic modes, manual control, night mode, intensive mode and summer mode ")]), _vm._v(" "), _c('li', [_vm._v(" Displays the ventilation intensity in 1% increments ")]), _vm._v(" "), _c('li', [_vm._v(" Automatically controls the brightness of the display ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Scope of delivery: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Control board for 1 device ")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id == 0x75ab) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/Unibox.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": __webpack_require__(51)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v(" Power controller for simple exhaust fans for 230 V, which do not have their own regulation and control. The power supply to the fan is looped through the Unibox.")]), _vm._v(" "), _c('h2', [_vm._v(" Functions: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Communicates with HAQCS-Monitor ")]), _vm._v(" "), _c('li', [_vm._v(" Controls the connected fans ")]), _vm._v(" "), _c('li', [_vm._v(" Displays current ventilation intensity in 1% increments ")]), _vm._v(" "), _c('li', [_vm._v(" Automatically controls the brightness of the display ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Technical data: ")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Control power ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Max:  150 W")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Input voltage ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 230 V, 110 V ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Frequency ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 50 Hz, 60 Hz ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Scope of delivery: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" HAQCS Unibox with mounting material ")])])])], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.language === 'de') ? _c('div', [(_vm.viewedDevice.id === 0) ? _c('div', [_c('v-container', [_c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HAQCS-Monitor',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "haqcs-height no-shadow",
    attrs: {
      "src": "/static/img/offer/haqcs.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("HAQCS-Monitor")]), _vm._v(" "), _c('p', [_vm._v("Luftqualitäts-Monitor und intelligente Lüftungssteuerung in einem Gerät. Seine Sensoren erfassen CO"), _c('sub', [_vm._v("2")]), _vm._v(", VOC und Klimawerte. Er zeigt die Luftqualität an, alarmiert und regelt bedarfsgerecht die dezentrale Lüftung.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Ambientika-AUTO',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/Ambientika+HAQCS.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "ambientika-auto-height no-shadow",
    attrs: {
      "src": "/static/img/offer/Ambientika+HAQCS.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Ambientika AUTO")]), _vm._v(" "), _c('p', [_vm._v("Lüftungsgerät für vollautomatische, bedarfsorientierte, dezentrale Lüftungssysteme. Durch optimierte Steuerung per HAQCS-Monitor spart Heizungswärme effektiver als bei Steuerung durch Menschen.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HRU-WALL-WI',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/HW_app_moni.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "hru-wall-wi-height no-shadow",
    attrs: {
      "src": "/static/img/offer/HW_app_moni.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("HRU-WALL-WI")]), _vm._v(" "), _c('p', [_vm._v("Lüftungsgerät das vom Werk aus HAQCS-kompatibel ist und auch manuell, per Smartphone-App gesteuert werden kann. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Marley-MEnV-HAQCS-Edition',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/marley-MEnV-HAQCS-edition.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "marley-haqcs-edition-height no-shadow",
    attrs: {
      "src": "/static/img/offer/marley-MEnV-HAQCS-edition.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Marley MEnV HAQCS-Edition")]), _vm._v(" "), _c('p', [_vm._v("Nachfolger des populären Modells Marley MEnV 180. Die HAQCS-Edition verfügt über HAQCS-kompatibilität.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Upgrade-Marley-MEnV-180',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/upgrade-marley-MEnV180.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "upgrade-marley-menv-180-height",
    attrs: {
      "src": "/static/img/offer/upgrade-marley-MEnV180.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Upgrade für Marley MEnV 180 auf HAQCS")]), _vm._v(" "), _c('p', [_vm._v("Satz Steuerplatinen für die populären Lüftungsgeräte mit Wärmerückgewinnung Marley MEnV 180. Nach Austausch der Platinen werden die Geräte HAQCS-kompatibel und lassen sich bedarfsgerecht und automatisch von HAQCS-Monitor regeln.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Upgrade-Prana-150-200',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/upgrade-prana150-200.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "upgrade-prana-150-200-height",
    attrs: {
      "src": "/static/img/offer/upgrade-prana150-200.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Upgrade für Prana 150 / 200")]), _vm._v(" "), _c('p', [_vm._v("Steuerplatine für die dezentralen Lüftungsgeräte mit Wärmerückgewinnung Prana 150, 200C, 200G. Nach Austausch der Platine werden die Geräte HAQCS-kompatibel und lassen sich bedarfsgerecht und automatisch von HAQCS-Monitor regeln.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HAQCS-Unibox',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/Unibox.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "unibox-height",
    attrs: {
      "src": "/static/img/offer/Unibox.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("HAQCS-Unibox")]), _vm._v(" "), _c('p', [_vm._v("Leistungsregler für einfache Abluftventilatoren für 230 V, die keine eigene Regelung und Steuerung besitzen. Die Stromversorgung zum Ventilator wird durch die Unibox durchgeschleift.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0xa778) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": __webpack_require__(52)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Luftqualitäts-Monitor und intelligente Lüftungssteuerung in einem Gerät. Seine Sensoren erfassen CO"), _c('sub', [_vm._v("2")]), _vm._v(", VOC und Klimawerte. Er zeigt die Luftqualität an, alarmiert und regelt bedarfsgerecht die dezentrale Lüftung. ")]), _vm._v(" "), _c('h2', [_vm._v("Funktionen:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Messung der Luftqualität und des Raumklimas")]), _vm._v(" "), _c('li', [_vm._v("Anzeige aktueller Werte als Zahlen und grafisch")]), _vm._v(" "), _c('li', [_vm._v("Anzeige der Trends der letzten 3 oder 12 Stunden")]), _vm._v(" "), _c('li', [_vm._v("Luftqualität auch beim abgeschalteten Bildschirm ablesbar")]), _vm._v(" "), _c('li', [_vm._v("Alarme bei Schwellenwerten von CO"), _c('sub', [_vm._v("2")]), _vm._v(" optisch und akustisch")]), _vm._v(" "), _c('li', [_vm._v("Regelung von kompatiblen Lüftungsgeräten (bis zu 16 gleichzeitig), 3 automatische Modi, Nachtmodus, Intensivmodus, manuelle Steuerung, Automatischer Entfeuchtungsmodus, Sommermodus")]), _vm._v(" "), _c('li', [_vm._v("Regelung von kompatiblen Luftbefeuchtern ")]), _vm._v(" "), _c('li', [_vm._v("Behält Einstellungen nach einem Stromausfall")]), _vm._v(" "), _c('li', [_vm._v("Benötigt keinen Router, keine Verbindung mit dem Internet")]), _vm._v(" "), _c('li', [_vm._v("Kann an der Wand hängen, oder auf waagerechten Flächen stehen")]), _vm._v(" "), _c('li', [_vm._v("Drahtlose Kommunikation mit den Geräten mit WiFi-Technik (kein IP-Protokoll)")]), _vm._v(" "), _c('li', [_vm._v("Reichweite entspricht WiFi")])])]), _vm._v(" "), _c('h2', [_vm._v("Technische Daten:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Interne Sensoren")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Kohlendioxid CO"), _c('sub', [_vm._v("2")])]), _vm._v(" "), _c('li', [_vm._v("TVOC")]), _vm._v(" "), _c('li', [_vm._v("Temperatur")]), _vm._v(" "), _c('li', [_vm._v("Relative Feuchte")]), _vm._v(" "), _c('li', [_vm._v("Lichtsensor")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Bildschirm")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("3,5 Zoll Farbbildschirm 480 x 320 Pixel"), _c('br'), _vm._v("Berührungssensitiv")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("LED-Anzeige")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("8 RGB Leuchtdioden")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Stromversorgung")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("5 V USB-Netzteil, Anschlüsse micro-USB von unten und seitlich")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Farben")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Bordeaux, dunkel grün, grau")])])]), _vm._v(" "), _c('h2', [_vm._v("Lieferumfang:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("HAQCS-Monitor")]), _vm._v(" "), _c('li', [_vm._v("USB-Netzteil")]), _vm._v(" "), _c('li', [_vm._v("Micro-USB Kabel")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x1bcf) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/Ambientika+HAQCS-high-quality.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": __webpack_require__(49)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Upgrade eines Models der Marke Ambientika zu HAQCS-Kompatibilität. Zusammen mit dem HAQCS-Monitor bildet vollautomatisches, bedarfsorientiertes  Lüftungssystem das optimiert die Lüftung und spart dadurch Heizungsenergie, was Menschen nicht können. ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Dadurch ist das unser Top-Model.")]), _vm._v(" "), _c('h2', [_vm._v("Funktionen:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Kommuniziert mit HAQCS-Monitor und wird von ihm geregelt")]), _vm._v(" "), _c('li', [_vm._v("Stufenlose Regelung der Lüftungsintensität")]), _vm._v(" "), _c('li', [_vm._v("Verschließt automatisch den Luftkanal wenn nicht gelüftet wird")]), _vm._v(" "), _c('li', [_vm._v("Zeigt aktuelle Lüftungsintensität mit einer Farbigen LED an")]), _vm._v(" "), _c('li', [_vm._v("Benötigt einen HAQCS-Monitor zur Steuerung")]), _vm._v(" "), _c('li', [_vm._v("Verfügt über G3 – Filter")]), _vm._v(" "), _c('li', [_vm._v("Alle Service-Tätigkeiten durchführbar von innen")]), _vm._v(" "), _c('li', [_vm._v("Regelt die Helligkeit der Anzeige automatisch")])])]), _vm._v(" "), _c('h2', [_vm._v("Technische Daten:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Luftdurchsatz")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Stufenlos bis 60 m³/h")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Stromverbrauch")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Unter 7 Watt")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Lautstärke")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("30 dB(A) bei max. Geschwindigkeit")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Wärmerückgewinnung")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("bis 93%")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x0f43) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/HW_app_moni-high-quality.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": __webpack_require__(50)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Lüftungsgerät der Marke Alnor, das vom Werk aus HAQCS-Kompatibel ist und daher vollautomatisch bedarfsgeführt lüftet und spart optimal die Heizwärme. Für Budgetlösungen kann es auch manuell per Smartphone-App gesteuert werden.")]), _vm._v(" "), _c('h2', [_vm._v("Vorteile:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_c('b', [_vm._v("HAQCS-Kompatibilität")]), _vm._v(" - nachrüstbare automatische bedarfsgerechte Regelung der Lüftung anhand von Messungen der Luftqualität im Raum in Verbindung mit HAQCS-Monitor")]), _vm._v(" "), _c('li', [_vm._v("Einfache Montage in den Außenwänden mit minimaler Verkabelung")]), _vm._v(" "), _c('li', [_vm._v("Große Förderleistung 20, 40 und 60 m³/h Luft")]), _vm._v(" "), _c('li', [_vm._v("eingebauter Feuchtesensor zur automatischen Entfeuchtung bei Bedarf.")]), _vm._v(" "), _c('li', [_vm._v("Leise")]), _vm._v(" "), _c('li', [_vm._v("kostenlose App zur Steuerung")]), _vm._v(" "), _c('li', [_vm._v("Leicht zu reinigen")])])]), _vm._v(" "), _c('h2', [_vm._v("Steuerung")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Steuerung durch den HAQCS-Monitor anhand der Daten aus seinen Sensoren. Immer frische Luft entsprechend dem Bedarf und Energieeinsparung. Automatisch.")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Alternativ manuelle Steuerung mit der kostenlosen App WallAIR.")]), _vm._v(" "), _c('h2', [_vm._v("Service von Innen")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Sämtliche Service- und Wartungsarbeiten lassen sich bequem und günstig vom Innenraum her durchführen. Es besteht keine Notwendigkeit für Außengerüste.")]), _vm._v(" "), _c('h2', [_vm._v("Technical Specifications:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("3 Leistungsstufen")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("20, 40, 60 m³/h")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Außenwandstärken:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("200 – 560 mm")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Leistungsaufnahme:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("1,4 –3,8 Watt")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Schalldruckpegel (3 m):")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("10 – 26 dB(A)")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Schalldämmung von außen:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("39 dB (entspricht Fensterklasse 3 nach VDI 2719)")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Wärmerückgewinnung:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Max. 82%, Mittel 74,3%")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x7b90) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/marley-MEnV-HAQCS-edition.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": __webpack_require__(53)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Nachfolger des populären Modells Marley MEnV 180. Die HAQCS-Edition verfügt über HAQCS-kompatibilität. ")]), _vm._v(" "), _c('h2', [_vm._v("Funktionen:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Kommuniziert mit HAQCS-Monitor und wird von ihm geregelt")]), _vm._v(" "), _c('li', [_vm._v("Zeigt aktuelle Lüftungsintensität mit einer Farbigen LED an")]), _vm._v(" "), _c('li', [_vm._v("Benötigt einen HAQCS-Monitor zur Steuerung")]), _vm._v(" "), _c('li', [_vm._v("Verfügt über G3 und G2 – Filter, optional sogar F7 – Filter")]), _vm._v(" "), _c('li', [_vm._v("Alle Service-Tätigkeiten durchführbar von innen")]), _vm._v(" "), _c('li', [_vm._v("Regelt die Helligkeit der Anzeige automatisch")])])]), _vm._v(" "), _c('h2', [_vm._v("Technische Daten:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Luftdurchsatz")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("16  -  25  oder 37 m³/h je nach Stufe")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Stromverbrauch")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("3,5  -   5,0  -  7,5 Watt je nach Stufe")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Lautstärke")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("22  -  29  -  35  dB(A) je nach Stufe")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Wärmerückgewinnung")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Max 85%,  Durchschnittlich 79,1%")])])]), _vm._v(" "), _c('h2', [_vm._v("Lieferumfang:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Marley MEnV HAQCS-Edition")]), _vm._v(" "), _c('li', [_vm._v("Filtersatz für 2 Jahre")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x217d) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/upgrade-marley-MEnV180.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img",
    attrs: {
      "src": __webpack_require__(54)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Satz Steuerplatinen für die populären Lüftungsgeräte mit Wärmerückgewinnung Marley MEnV 180. Nach Austausch der Platinen werden die Geräte HAQCS-kompatibel und lassen sich bedarfsgerecht und automatisch von HAQCS-Monitor regeln.")]), _vm._v(" "), _c('h2', [_vm._v("Funktionen:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Kommuniziert mit HAQCS-Monitor")]), _vm._v(" "), _c('li', [_vm._v("Steuert den Lüfter und die Anzeigen-LED")]), _vm._v(" "), _c('li', [_vm._v("Überwacht die Betriebszeit und erinnert an Filterwechsel")])])]), _vm._v(" "), _c('h2', [_vm._v("Technische Daten:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Stromverbrauch")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("0,30  - 0,35 W in Stand-by")])])]), _vm._v(" "), _c('h2', [_vm._v("Lieferumfang:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Steuerungen für 2 Geräte")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id == 0xacdc) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/upgrade-prana150-200.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img",
    attrs: {
      "src": __webpack_require__(55)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Steuerplatine für die dezentralen Lüftungsgeräte mit Wärmerückgewinnung Prana 150, 200C, 200G. Nach Austausch der Platine werden die Geräte HAQCS-kompatibel und lassen sich bedarfsgerecht und automatisch von HAQCS-Monitor regeln.")]), _vm._v(" "), _c('h2', [_vm._v("Funktionen:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Kommuniziert mit HAQCS-Monitor oder Fernbedienung")]), _vm._v(" "), _c('li', [_vm._v("Steuert die Lüfter")]), _vm._v(" "), _c('li', [_vm._v("Erlaubt alle Automatikmodi, manuelle Steuerung, Nachtmodus, Intensivmodus und Sommermodus")]), _vm._v(" "), _c('li', [_vm._v("Zeigt die Lüftungsintensität in 1%-Schritten an")]), _vm._v(" "), _c('li', [_vm._v("Regelt die Helligkeit der Anzeige automatisch")])])]), _vm._v(" "), _c('h2', [_vm._v("Lieferumfang:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Steuerung für 1 Gerät")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id == 0x75ab) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/Unibox.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": __webpack_require__(51)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Leistungsregler für einfache Abluftventilatoren für 230 V, die keine eigene Regelung und Steuerung besitzen. Die Stromversorgung zum Ventilator wird durch die Unibox durchgeschleift.")]), _vm._v(" "), _c('h2', [_vm._v("Funktionen:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Kommuniziert mit HAQCS-Monitor")]), _vm._v(" "), _c('li', [_vm._v("Steuert die angeschlossenen Ventilatoren")]), _vm._v(" "), _c('li', [_vm._v("Zeigt aktuelle Lüftungsintensität in 1%-Schritten an")]), _vm._v(" "), _c('li', [_vm._v("Regelt die Helligkeit der Anzeige automatisch")])])]), _vm._v(" "), _c('h2', [_vm._v("Technische Daten:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Regelleistung ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Max:  150 W")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Eingangspannung ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("230 V, 110 V")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Frequenz ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("50 Hz, 60 Hz")])])]), _vm._v(" "), _c('h2', [_vm._v("Lieferumfang:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("HAQCS-Unibox mit Montagematerial")])])])], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.language === 'pl') ? _c('div', [(_vm.viewedDevice.id === 0) ? _c('div', [_c('v-container', [_c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HAQCS-Monitor',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "haqcs-height no-shadow",
    attrs: {
      "src": "/static/img/offer/haqcs.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Monitor HAQCS")]), _vm._v(" "), _c('p', [_vm._v("Monitor jekości powietrza i automatyczny sterownik wentylacji i nawilżania.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Ambientika-AUTO',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/Ambientika+HAQCS.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "ambientika-auto-height no-shadow",
    attrs: {
      "src": "/static/img/offer/Ambientika+HAQCS.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Ambientika AUTO")]), _vm._v(" "), _c('p', [_vm._v("Urządzenie wentylacyjne do w pełni automatycznych, zdecentralizowanych systemów wentylacyjnych. Dzięki sterowaniu według aktualnego zapotrzebowania optymalizowanej za pomocą monitora HAQCS, oszczędza energię grzewczą bardziej efektywnie niż w przypadku sterowania przez ludzi.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HRU-WALL-WI',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/HW_app_moni.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "hru-wall-wi-height no-shadow",
    attrs: {
      "src": "/static/img/offer/HW_app_moni.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("HRU-WALL-WI")]), _vm._v(" "), _c('p', [_vm._v("Urządzenie wentylacyjne, które jest fabrycznie kompatybilne z systemem HAQCS i może być również sterowane ręcznie za pomocą aplikacji na smartfona.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Marley-MEnV-Edycja-HAQCS',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/marley-MEnV-HAQCS-edition.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "marley-haqcs-edition-height no-shadow",
    attrs: {
      "src": "/static/img/offer/marley-MEnV-HAQCS-edition.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Marley MEnV Edycja HAQCS")]), _vm._v(" "), _c('p', [_vm._v("Następca popularnego modelu Marley MEnV 180. Urządzenie jest kompatybilne z HAQCS.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Ulepszenie-Marley-MEnV-180',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/upgrade-marley-MEnV180.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "upgrade-marley-menv-180-height",
    attrs: {
      "src": "/static/img/offer/upgrade-marley-MEnV180.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Ulepszenie dla Marley MEnV 180 na HAQCS")]), _vm._v(" "), _c('p', [_vm._v("Zestaw płytek sterownika do popularnych urządzeń wentylacyjnych z odzyskiem ciepła Marley MEnV 180. Po wymianie płytek urządzenia stają się kompatybilne z HAQCS i mogą być sterowane automatycznie przez HAQCS-Monitor odpowiednio do rzeczywistych potrzeb.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/Ulepszenie-Prana-150-200',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/upgrade-prana150-200.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "upgrade-prana-150-200-height",
    attrs: {
      "src": "/static/img/offer/upgrade-prana150-200.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Ulepszenie dla Prana 150 / 200")]), _vm._v(" "), _c('p', [_vm._v("Centrala sterująca do zdecentralizowanych urządzeń wentylacyjnych z odzyskiem ciepła Prana 150, 200C, 200G. Po wymianie płytki urządzenia stają się kompatybilne z HAQCS i mogą być kontrolowane automatycznie w zależności od potrzeb przez HAQCS-Monitor.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.listPath + '/HAQCS-Unibox',
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/Unibox.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "unibox-height",
    attrs: {
      "src": "/static/img/offer/Unibox.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("HAQCS-Unibox")]), _vm._v(" "), _c('p', [_vm._v("Regulator wydajności dla prostych wentylatorów wyciągowych na 230 V, które nie mają własnej regulacji i sterowania. Unibox jest wpinany w przewód zasilający wentylatora.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0xa778) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": __webpack_require__(52)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Monitor jekości powietrza i automatyczny sterownik wentylacji i nawilżania.")]), _vm._v(" "), _c('h2', [_vm._v("Funkcje:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Pomiar jakości powietrza i klimatu w pomieszczeniu")]), _vm._v(" "), _c('li', [_vm._v("Wyświetlanie bieżących wartości jako liczb i graficznie")]), _vm._v(" "), _c('li', [_vm._v("Wyświetla trendy z ostatnich 3 lub 12 godzin")]), _vm._v(" "), _c('li', [_vm._v("Jakość powietrza można również odczytać, gdy ekran jest wyłączony")]), _vm._v(" "), _c('li', [_vm._v("Alarmy przy wartościach progowych CO"), _c('sub', [_vm._v("2")]), _vm._v(" optycznie i akustycznie")]), _vm._v(" "), _c('li', [_vm._v("Sterowanie kompatybilnymi urządzeniami wentylacyjnymi (do 16 jednocześnie), 3 tryby automatyczne, tryb nocny, tryb intensywny, sterowanie ręczne, tryb automatycznego osuszania, tryb letni")]), _vm._v(" "), _c('li', [_vm._v("Kontrola kompatybilnych nawilżaczy")]), _vm._v(" "), _c('li', [_vm._v("Zachowuje ustawienia po awarii zasilania")]), _vm._v(" "), _c('li', [_vm._v("Nie wymaga routera, nie ma połączenia z Internetem")]), _vm._v(" "), _c('li', [_vm._v("Może wisieć na ścianie lub stać na poziomych powierzchniach")]), _vm._v(" "), _c('li', [_vm._v("Bezprzewodowa komunikacja z urządzeniami z technologią WiFi (bez protokołu IP)")]), _vm._v(" "), _c('li', [_vm._v("Zasięg odpowiada Wi-Fi")])])]), _vm._v(" "), _c('h2', [_vm._v("Dane techniczne:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Czujniki wewnętrzne")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Dwutlenek węgla CO"), _c('sub', [_vm._v("2")])]), _vm._v(" "), _c('li', [_vm._v("TVOC")]), _vm._v(" "), _c('li', [_vm._v("Temperatura")]), _vm._v(" "), _c('li', [_vm._v("Wilgotność względna")]), _vm._v(" "), _c('li', [_vm._v("Czujnik światła")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Screen")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Kolorowy ekran 3,5 cala 480 x 320 pikseli "), _c('br'), _vm._v(" wrażliwy na dotyk")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Wyświetlacz LED")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("8 diody LED RGB")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Zasilacz")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Zasilacz USB 5 V, złącza micro-USB od dołu i z boku")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Kolory")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Bordeaux, ciemnozielony, szary")])])]), _vm._v(" "), _c('h2', [_vm._v("Zakres dostawy:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("HAQCS-Monitor")]), _vm._v(" "), _c('li', [_vm._v("Zasilacz USB")]), _vm._v(" "), _c('li', [_vm._v("Kabel Micro-USB")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x1bcf) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/Ambientika+HAQCS-high-quality.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": __webpack_require__(49)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Aktualizacja modelu marki Ambientika do zgodności z HAQCS. Razem z monitorem HAQCS tworzy w pełni zautomatyzowany, dostosowany do zapotrzebowania system wentylacji, który optymalizuje wentylację, co pozwala oszczędzać energię ogrzewania, czego ludzie sami nie są w stanie zrobić.")]), _vm._v(" "), _c('p', {
    staticClass: "p-p",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("To sprawia, że jest to nasz najlepszy model.")]), _vm._v(" "), _c('h2', [_vm._v("Funkcje:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Komunikuje się z monitorem HAQCS i jest przez niego regulowany")]), _vm._v(" "), _c('li', [_vm._v("Bezstopniowa regulacja intensywności wentylacji")]), _vm._v(" "), _c('li', [_vm._v("Automatycznie zamyka kanał powietrzny, gdy nie jest używany")]), _vm._v(" "), _c('li', [_vm._v("Wyświetla aktualną intensywność wentylacji za pomocą kolorowej diody LED")]), _vm._v(" "), _c('li', [_vm._v("Wymaga monitora HAQCS do sterowania")]), _vm._v(" "), _c('li', [_vm._v("Wyposażony w filtr G3")]), _vm._v(" "), _c('li', [_vm._v("Wszystkie czynności serwisowe możliwe do wykonania od wewnątrz")]), _vm._v(" "), _c('li', [_vm._v("Automatycznie reguluje jasność wyświetlacza")])])]), _vm._v(" "), _c('h2', [_vm._v("Dane techniczne:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Przepływ powietrza:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("bezstopniowy do 60 m³/h")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Zużycie energii:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("poniżej 7 watów")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Poziom hałasu:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("30 dB(A) przy maksymalnej prędkości")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Odzysk ciepła:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("do 93%")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x0f43) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/HW_app_moni-high-quality.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": __webpack_require__(50)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Urządzenie wentylacyjne marki Alnor, fabrycznie kompatybilne z HAQCS, dzięki czemu wentyluje w pełni automatycznie, zgodnie z zapotrzebowaniem i optymalnie oszczędza energię grzewczą. Dla rozwiązań budżetowych może być także sterowane ręcznie za pomocą aplikacji na smartfona.")]), _vm._v(" "), _c('h2', [_vm._v("Zalety:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Zgodność z HAQCS - automatyczna regulacja wentylacji na podstawie pomiarów jakości powietrza w pomieszczeniu, we współpracy z monitorem HAQCS.")]), _vm._v(" "), _c('li', [_vm._v("Łatwy montaż w ścianach zewnętrznych przy minimalnym okablowaniu.")]), _vm._v(" "), _c('li', [_vm._v("Wysoka wydajność: 20, 40 i 60 m³/h powietrza.")]), _vm._v(" "), _c('li', [_vm._v("Wbudowany czujnik wilgotności do automatycznego odwilgocania w razie potrzeby.")]), _vm._v(" "), _c('li', [_vm._v("Ciche działanie.")]), _vm._v(" "), _c('li', [_vm._v("Darmowa aplikacja do sterowania.")]), _vm._v(" "), _c('li', [_vm._v("Łatwe do czyszczenia.")])])]), _vm._v(" "), _c('h2', [_vm._v("Sterowanie")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Sterowane przez monitor HAQCS na podstawie danych z jego czujników. Zawsze świeże powietrze zgodnie z zapotrzebowaniem i oszczędność energii. Automatycznie.")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Alternatywnie, ręczne sterowanie za pomocą bezpłatnej aplikacji WallAIR..")]), _vm._v(" "), _c('h2', [_vm._v("Obsługa od wewnątrz")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Wszystkie prace serwisowe i konserwacyjne można łatwo i ekonomicznie wykonywać od wewnątrz. Nie ma potrzeby stosowania rusztowań zewnętrznych.")]), _vm._v(" "), _c('h2', [_vm._v("Dane techniczne")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Dane techniczne")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("20, 40, 60 m³/h")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Grubość ściany zewnętrznej:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("200 – 560 mm")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Zużycie energii:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("1,4 – 3,8 watów")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Poziom ciśnienia akustycznego (3 m):")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("10 – 26 dB(A)")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Izolacja dźwiękowa od zewnątrz:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("39 dB (odpowiada klasie okna 3 według VDI 2719)")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Odzysk ciepła:")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Max. 82%, Średnio 74,3%")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x7b90) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/marley-MEnV-HAQCS-edition.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": __webpack_require__(53)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Następca popularnego modelu Marley MEnV 180. Urządzenie jest kompatybilne z HAQCS. ")]), _vm._v(" "), _c('h2', [_vm._v("Funkcje:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Komunikuje się z monitorem HAQCS i jest regulowany przez ten monitor")]), _vm._v(" "), _c('li', [_vm._v("Pokazuje aktualną intensywność wentylacji za pomocą kolorowej diody LED")]), _vm._v(" "), _c('li', [_vm._v("Wymaga monitora HAQCS do kontroli")]), _vm._v(" "), _c('li', [_vm._v("Posiada filtry G3 i G2, opcjonalnie nawet filtry F7")]), _vm._v(" "), _c('li', [_vm._v("Wszystkie czynności serwisowe można wykonywać od wewnątrz")]), _vm._v(" "), _c('li', [_vm._v("Automatycznie kontroluje jasność wyświetlacza")])])]), _vm._v(" "), _c('h2', [_vm._v("Dane techniczne:")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Przepływ powietrza")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("16–25 lub 37 m³ / h w zależności od poziomu")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Pobór mocy")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("3,5 - 5,0 - 7,5 watów w zależności od poziomu")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Głośność")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("22 - 29 - 35 dB(A) w zależności od poziomu")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v("Odzysk ciepła")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Maks. 85%, średnio 79,1%")])])]), _vm._v(" "), _c('h2', [_vm._v("Zakres dostawy:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Marley MEnV Edycja HAQCS")]), _vm._v(" "), _c('li', [_vm._v("Zestaw filtrów na 2 lata")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x217d) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/upgrade-marley-MEnV180.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img",
    attrs: {
      "src": __webpack_require__(54)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v("Zestaw płytek sterownika do popularnych urządzeń wentylacyjnych z odzyskiem ciepła Marley MEnV 180. Po wymianie płytek urządzenia stają się kompatybilne z HAQCS i mogą być sterowane automatycznie przez HAQCS-Monitor odpowiednio do rzeczywistych potrzeb.")]), _vm._v(" "), _c('h2', [_vm._v("Funkcje:")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v("Komunikuje się z monitorem HAQCS")]), _vm._v(" "), _c('li', [_vm._v("Kontroluje diodę LED wentylatora i wskaźnika")]), _vm._v(" "), _c('li', [_vm._v("Monitoruje czas pracy i przypomina, aby zmienić filtr")])])]), _vm._v(" "), _c('h2', [_vm._v(" Dane techniczne: ")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Pobór mocy ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 0,30 - 0,35 W w trybie czuwania ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Zakres dostawy: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Sterowanie dla 2 urządzeń ")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0xacdc) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/upgrade-prana150-200.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img",
    attrs: {
      "src": __webpack_require__(55)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v(" Płyta sterująca do zdecentralizowanych urządzeń wentylacyjnych z odzyskiem ciepła Prana 150, 200C, 200G. Po wymianie płytki urządzenia stają się kompatybilne z HAQCS i mogą być kontrolowane automatycznie w zależności od potrzeb przez monitor HAQCS. ")]), _vm._v(" "), _c('h2', [_vm._v(" Funkcje: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Komunikuje się z monitorem HAQCS lub pilotem zdalnego sterowania ")]), _vm._v(" "), _c('li', [_vm._v(" Kontroluje wentylatory ")]), _vm._v(" "), _c('li', [_vm._v(" Umożliwia wszystkie tryby automatyczne, sterowanie ręczne, tryb nocny, tryb intensywny i tryb letni ")]), _vm._v(" "), _c('li', [_vm._v(" Wyświetla intensywność wentylacji w krokach co 1% ")]), _vm._v(" "), _c('li', [_vm._v(" Automatycznie kontroluje jasność wyświetlacza ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Zakres dostawy: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Sterowanie dla 1 urządzenia ")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewedDevice.id === 0x75ab) ? _c('div', [_c('v-container', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "../../static/img/offer/Unibox.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "p-img no-shadow",
    attrs: {
      "src": __webpack_require__(51)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_vm._v(" Sterownik mocy dla prostych wentylatorów wyciągowych na 230 V, które nie mają własnej regulacji i sterowania. Unibox jest wpinany w przewód zasilający wentylatora.")]), _vm._v(" "), _c('h2', [_vm._v(" Funkcje: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" Komunikuje się z monitorem HAQCS ")]), _vm._v(" "), _c('li', [_vm._v(" Kontroluje podłączone wentylatory ")]), _vm._v(" "), _c('li', [_vm._v(" Wyświetla aktualną intensywność wentylacji w krokach co 1% ")]), _vm._v(" "), _c('li', [_vm._v("Automatycznie kontroluje jasność wyświetlacza ")])])]), _vm._v(" "), _c('h2', [_vm._v(" Dane techniczne: ")]), _vm._v(" "), _c('div', {
    staticClass: "table-container_"
  }, [_c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Moc kontrolna ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" Max: 150 W ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-uneven"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Napięcie wejściowe ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" 230 V, 110 V ")])]), _vm._v(" "), _c('div', {
    staticClass: "table table-even"
  }, [_c('div', {
    staticClass: "parameter"
  }, [_vm._v(" Częstotliwość ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("50 Hz, 60 Hz")])])]), _vm._v(" "), _c('h2', [_vm._v(" Zakres dostawy: ")]), _vm._v(" "), _c('p', {
    staticClass: "p-p"
  }, [_c('ul', {
    staticClass: "narrow"
  }, [_c('li', [_vm._v(" HAQCS Unibox z materiałem montażowym ")])])])], 1)], 1) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50vh"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticStyle: {
      "max-width": "1024px"
    }
  }, [_c('div', {
    staticClass: "content elevation-2",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('h1', [_vm._v(_vm._s(this.lng.articlesHeading))]), _vm._v(" "), (_vm.language === 'en') ? _c('div', [_c('v-container', [_c('p', [_vm._v("We do currently not have any articles written in English.")])])], 1) : _vm._e(), _vm._v(" "), (_vm.language === 'de') ? _c('div', [_c('v-container', [_c('a', {
    attrs: {
      "href": "/static/articles/Sparen_LG_DE.pdf",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "tile noselect"
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/article-icons/Sparen-LG.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "haqcs-height elevation-1",
    attrs: {
      "src": "/static/img/article-icons/Sparen-LG.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Sparen Lüftungsgeräte wirklich Energie?")]), _vm._v(" "), _c('p', [_vm._v("Natürlich! Aber nicht immer so, wie der Benutzer denkt. Es hängt sehr viel davon ab, wie bewusst er die Lüftungsgeräte einsetzt.")]), _vm._v(" "), _c('p', [_vm._v("Wenn die Luft im Raum beheizt ist (und desto mehr, wenn gekühlt werden muss), geht beim Lüften Energie verloren. Aber es muss gelüftet werden. Deswegen sind ...")]), _vm._v(" "), _c('p', {
    staticClass: "article-date"
  }, [_vm._v("31. März 2022")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1)])], 1)])])], 1) : _vm._e(), _vm._v(" "), (_vm.language === 'pl') ? _c('div', [_c('v-container', [_c('a', {
    attrs: {
      "href": "/static/articles/Sparen_LG_PL.pdf",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "tile noselect"
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/article-icons/Sparen-LG.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "haqcs-height elevation-1",
    attrs: {
      "src": "/static/img/article-icons/Sparen-LG.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Czy rekuperatory oszczędzają rzeczywiście ciepło?")]), _vm._v(" "), _c('p', [_vm._v("Oczywiście! Ale nie zawsze w taki sposób, jak myśli użytkownik. Wiele zależy od tego, jak świadomie korzysta on z urządzeń wentylacyjnych.")]), _vm._v(" "), _c('p', [_vm._v("Jeśli powietrze w pomieszczeniu jest ogrzewane (a tym bardziej, jeśli wymaga schłodzenia), traci się energię podczas wentylacji. Ale wentylacja jest konieczna. Dlatego pojawiły się ...")]), _vm._v(" "), _c('p', {
    staticClass: "article-date"
  }, [_vm._v("31 marca 2022")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1)])], 1)])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "64px"
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(this.lng.manualsHeading))]), _vm._v(" "), (_vm.language === 'en') ? _c('div', [_c('v-container', [_c('router-link', {
    attrs: {
      "to": "docs/haqcs",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect"
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "haqcs-height no-shadow",
    attrs: {
      "src": "/static/img/offer/haqcs.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Manual for the HAQCS-Monitor")]), _vm._v(" "), _c('p', [_vm._v(" Air quality monitor and controller for decentralized ventilation and humidification. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.language === 'de') ? _c('div', [_c('v-container', [_c('router-link', {
    attrs: {
      "to": "dokumentation/haqcs",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect"
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "haqcs-height no-shadow",
    attrs: {
      "src": "/static/img/offer/haqcs.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Anleitung für den HAQCS-Monitor")]), _vm._v(" "), _c('p', [_vm._v("Luftqualitäts-Monitor und intelligente Lüftungssteuerung in einem Gerät. Seine Sensoren erfassen CO"), _c('sub', [_vm._v("2")]), _vm._v(", VOC und Klimawerte. Er zeigt die Luftqualität an, alarmiert und regelt bedarfsgerecht die dezentrale Lüftung.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.language === 'pl') ? _c('div', [_c('v-container', [_c('router-link', {
    attrs: {
      "to": "dokumentacja/haqcs",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "tile noselect"
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "/static/img/offer/haqcs.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "haqcs-height no-shadow",
    attrs: {
      "src": "/static/img/offer/haqcs.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "device-title"
  }, [_vm._v("Instrukcja dla HAQCS-Monitora")]), _vm._v(" "), _c('p', [_vm._v("Monitor jekości powietrza i automatyczny sterownik wentylacji i nawilżania.")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-container_"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1)])], 1)])], 1)], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50vh"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "viewport-size",
    staticStyle: {
      "background-color": "#F6F6F6",
      "position": "relative",
      "z-index": "-2"
    }
  }, [_c('div', {
    staticClass: "main-background-image-container_"
  }, [_c('picture', [_c('source', {
    staticClass: "main-background-image",
    attrs: {
      "media": "(min-width:600px)",
      "srcset": "static/img/main-background.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "main-background-image",
    attrs: {
      "media": "(min-width:600px)",
      "srcset": "static/img/main-background.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-background-image",
    attrs: {
      "src": "about:blank"
    }
  })])], 1), _vm._v(" "), _c('h1', {
    staticClass: "haqcs-heading-1"
  }, [_vm._v("HAQCS")]), _vm._v(" "), _c('h2', {
    staticClass: "haqcs-heading-2"
  }, [_vm._v("Hapla Air Quality Control System.")]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "main-image",
    attrs: {
      "media": "(min-width:600px)",
      "srcset": "static/haqcs-renderings/main.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "main-image",
    attrs: {
      "srcset": "static/haqcs-renderings/main_800px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "main-image",
    attrs: {
      "srcset": "static/haqcs-renderings/main.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-image",
    attrs: {
      "src": "static/haqcs-renderings/main.png"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "main-image"
  })], 1), _vm._v(" "), _c('div', {
    ref: "haqcs-is",
    staticClass: "haqcs-is"
  }, [_c('div', {
    staticClass: "container_ top"
  }, [_c('div', {
    class: [_vm.showBothModes ? 'both' : 'single', 'flex-container_']
  }, [_c('div', {
    staticClass: "content content-heading",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.lng.haqcsIs) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content content-as-controller"
  }, [_c('div', {
    staticClass: "tile controller"
  }, [_c('picture', [_c('source', {
    staticClass: "noselect haqcs",
    attrs: {
      "media": "(min-width:800px)",
      "srcset": "static/img/haqcs-renderings/gray-auto_1046px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect haqcs",
    attrs: {
      "srcset": "static/img/haqcs-renderings/gray-auto_400px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect haqcs",
    attrs: {
      "src": "static/img/haqcs-renderings/gray-auto_min.png"
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.lng.aController))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content content-as-monitor"
  }, [_c('div', {
    staticClass: "tile monitor"
  }, [_c('picture', [_c('source', {
    staticClass: "noselect haqcs",
    attrs: {
      "media": "(min-width:800px)",
      "srcset": "static/img/haqcs-renderings/display/webp_1046px/green-comfort.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect haqcs",
    attrs: {
      "srcset": "static/img/haqcs-renderings/display/webp_400px/green-comfort.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect haqcs",
    attrs: {
      "src": "static/img/haqcs-renderings/display/png/green-comfort.png"
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.lng.aMonitor))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#F6F6F6",
      "padding-bottom": "10vh"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "rgb(253, 253, 253)",
      "padding-bottom": "5vh"
    }
  }), _vm._v(" "), _c('div', {
    ref: "haqcs-as-a-monitor",
    attrs: {
      "id": "haqcs-as-a-monitor"
    }
  }, [_c('div', {
    class: ['header-bar', 'top', (_vm.headerBarStickingMonitor) ? 'header-bar-sticking' : 'header-bar-not-sticking']
  }, [_c('div', {
    staticClass: "header-bar-container_"
  }, [_c('h2', {
    staticClass: "hidden-sm-and-down",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "line-height": "5vh"
    }
  }, [_c('span', {
    staticClass: "top-heading"
  }, [_vm._v(_vm._s(_vm.lng.haqcsAsA))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#haqcs-as-a-monitor'),
      expression: "'#haqcs-as-a-monitor'"
    }],
    staticClass: "top-heading top-heading-item"
  }, [_vm._v(_vm._s(_vm.lng.measuringDevice))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#haqcs-as-a-controller'),
      expression: "'#haqcs-as-a-controller'"
    }],
    staticClass: "top-heading top-heading-item top-heading-inactive"
  }, [_vm._v(_vm._s(_vm.lng.controller))]), _c('span', {
    staticClass: "top-heading"
  }, [_vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-and-up"
  }, [_c('span', {
    staticClass: "top-heading"
  }, [_vm._v(_vm._s(_vm.lng.haqcsAsA) + " " + _vm._s(_vm.lng.measuringDevice) + ".")])]), _vm._v(" "), _c('p', {
    staticClass: "top-paragraph"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.lng.measuringDeviceTopParagraph) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    class: ['shadow', (_vm.headerBarStickingMonitor) ? 'shadow-visible' : 'shadow-invisible']
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "haqcs-as-a-monitor"
    }
  }, [_c('div', {
    staticClass: "vertical-dots-container_ top"
  }, [_c('div', {
    staticClass: "centered-dots-container_"
  }, _vm._l((3), function(i) {
    return _c('div', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ('#slide_' + String(i - 1)),
        expression: "'#slide_'+String(i-1)"
      }],
      key: i,
      class: ['single-dot-container_', (_vm.viewedSlide + 1) == i ? 'single-dot-container_-active' : '']
    }, [_c('span', {
      class: ['dot', (_vm.viewedSlide + 1) == i ? '' : 'dot-inactive']
    })])
  }))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "-100vh"
    }
  }), _vm._v(" "), _c('div', {
    ref: "haqcs-display",
    staticClass: "haqcs-display top",
    style: ({
      transform: 'translateY(' + _vm.haqcsOffset + 'vh)'
    })
  }, [_c('div', {
    staticClass: "container_"
  }, [_c('div', {
    staticClass: "img-container_"
  }, [_vm._l((['red', 'green', 'gray']), function(color) {
    return _c('div', {
      key: color
    }, _vm._l((['comfort', 'history']), function(display) {
      return _c('div', {
        key: display
      }, [_c('picture', [_c('source', {
        class: [(_vm.viewedHaqcsColor == color && _vm.viewedHaqcsDisplay == display) ? '' : 'inactive'],
        attrs: {
          "media": "(min-width:800px)",
          "srcset": 'static/img/haqcs-renderings/display/webp_1046px/' + color + '-' + display + '.webp',
          "type": "image/webp"
        }
      }), _vm._v(" "), _c('source', {
        class: [(_vm.viewedHaqcsColor == color && _vm.viewedHaqcsDisplay == display) ? '' : 'inactive'],
        attrs: {
          "srcset": 'static/img/haqcs-renderings/display/webp_400px/' + color + '-' + display + '.webp',
          "type": "image/webp"
        }
      }), _vm._v(" "), _c('img', {
        class: [(_vm.viewedHaqcsColor == color && _vm.viewedHaqcsDisplay == display) ? '' : 'inactive'],
        attrs: {
          "src": '../../static/img/haqcs-renderings/display/png/' + color + '-' + display + '.png'
        }
      })])], 1)
    }))
  }), _vm._v(" "), _c('picture', [_c('source', {
    staticStyle: {
      "opacity": "1.0",
      "position": "relative",
      "z-index": "-1"
    },
    attrs: {
      "media": "(min-width:800px)",
      "srcset": 'static/img/haqcs-renderings/display/webp_1046px/' + _vm.viewedHaqcsColor + '-' + _vm.viewedHaqcsDisplay + '.webp',
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticStyle: {
      "opacity": "1.0",
      "position": "relative",
      "z-index": "-1"
    },
    attrs: {
      "srcset": 'static/img/haqcs-renderings/display/webp_400px/' + _vm.viewedHaqcsColor + '-' + _vm.viewedHaqcsDisplay + '.webp',
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "opacity": "1.0",
      "position": "relative",
      "z-index": "-1"
    },
    attrs: {
      "src": '../../static/img/haqcs-renderings/display/png/' + _vm.viewedHaqcsColor + '-' + _vm.viewedHaqcsDisplay + '.png'
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "color-selector"
  }, _vm._l((_vm.colors), function(c) {
    return _c('span', {
      key: c[0],
      class: [(c[0] == _vm.selectedColor) ? 'active' : 'inactive'],
      on: {
        "click": function($event) {
          _vm.selectedColor = c[0]
        }
      }
    }, [_c('span', {
      staticClass: "bead",
      style: ({
        background: 'linear-gradient(to bottom,' + c[1] + ',' + c[c[0] == _vm.selectedColor ? 2 : 1] + ')'
      })
    }, [_c('span', {
      staticClass: "shiny",
      class: [c[0] == _vm.selectedColor ? '' : 'invisible']
    })])])
  })), _vm._v(" "), _c('p', {
    class: [_vm.viewedSlide == 2 ? 'invisible' : ''],
    staticStyle: {
      "position": "absolute"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.historyDisplay)
    }
  })]), _vm._v(" "), _c('p', {
    class: [_vm.viewedSlide == 2 ? '' : 'invisible']
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.comfortDisplay)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-down",
    staticStyle: {
      "margin-bottom": "-100vh"
    }
  }), _vm._v(" "), _c('div', {
    ref: "slide_0",
    staticClass: "slide slide0",
    attrs: {
      "id": "slide_0"
    }
  }, [_c('p', {
    ref: "slideText_0",
    class: ['text', (_vm.viewedSlide == 0) ? '' : 'text-not-viewed']
  }, [_c('b', [_vm._v(_vm._s(_vm.lng.slideText[0][0]))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.slideText[0][1])
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "slide_1",
    staticClass: "slide slide1",
    attrs: {
      "id": "slide_1"
    }
  }, [_c('p', {
    ref: "slideText_1",
    class: ['text', (_vm.viewedSlide == 1) ? '' : 'text-not-viewed']
  }, [_c('b', [_vm._v(_vm._s(_vm.lng.slideText[1][0]))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.slideText[1][1])
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "slide_2",
    staticClass: "slide slide2",
    attrs: {
      "id": "slide_2"
    }
  }, [_c('p', {
    ref: "slideText_2",
    class: ['text', (_vm.viewedSlide == 2) ? '' : 'text-not-viewed']
  }, [_c('b', [_vm._v(_vm._s(_vm.lng.slideText[2][0]))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.slideText[2][1])
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "slide_3",
    staticClass: "slide3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-slide"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('picture', [_c('source', {
    staticClass: "button-card-img noselect",
    attrs: {
      "media": "(min-width:600px)",
      "srcset": "static/img/haqcs-photos/leds_1024px.webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "button-card-img noselect",
    attrs: {
      "media": "(min-width:1024px)",
      "srcset": "static/img/haqcs-photos/leds_2000px.webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "button-card-img noselect",
    attrs: {
      "srcset": "static/img/haqcs-photos/leds_800px.webp",
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "button-card-img noselect",
    attrs: {
      "src": "static/img/haqcs-photos/leds.jpg",
      "loading": "lazy"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-background-fade"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.lng.photoTextLED) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "small-image hidden-md-and-up",
    attrs: {
      "media": "(max-width:800px)",
      "srcset": "static/img/haqcs-photos/leds_small_800px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "small-image hidden-md-and-up",
    attrs: {
      "media": "(max-width:1023px)",
      "srcset": "static/img/haqcs-photos/leds_small_1024px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "small-image hidden-md-and-up",
    attrs: {
      "srcset": "about:blank",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "small-image hidden-md-and-up",
    attrs: {
      "src": "static/img/haqcs-photos/leds.jpg"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "img-slide img-slide-dark"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('picture', [_c('source', {
    staticClass: "button-card-img noselect",
    attrs: {
      "media": "(min-width:600px)",
      "srcset": "static/img/haqcs-photos/alarms_1024px.webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "button-card-img noselect",
    attrs: {
      "media": "(min-width:1024px)",
      "srcset": "static/img/haqcs-photos/alarms_2000px.webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "button-card-img noselect",
    attrs: {
      "srcset": "static/img/haqcs-photos/alarms_800px.webp",
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "button-card-img noselect",
    attrs: {
      "src": "static/img/haqcs-photos/alarms.jpg",
      "loading": "lazy"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-background-fade"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.lng.photoTextAlarms) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "small-image hidden-md-and-up",
    attrs: {
      "media": "(max-width:800px)",
      "srcset": "static/img/haqcs-photos/alarms_small_800px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "small-image hidden-md-and-up",
    attrs: {
      "media": "(max-width:1023px)",
      "srcset": "static/img/haqcs-photos/alarms_small_1024px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "small-image hidden-md-and-up",
    attrs: {
      "srcset": "about:blank",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "small-image hidden-md-and-up",
    attrs: {
      "src": "static/img/haqcs-photos/alarms.jpg"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "rgb(253, 253, 253)",
      "padding-bottom": "15vh"
    }
  }), _vm._v(" "), _c('div', {
    ref: "haqcs-as-a-controller",
    attrs: {
      "id": "haqcs-as-a-controller"
    }
  }, [_c('div', {
    class: ['header-bar', 'top', (_vm.headerBarStickingController) ? 'header-bar-sticking' : 'header-bar-not-sticking']
  }, [_c('div', {
    staticClass: "header-bar-container_"
  }, [_c('h2', {
    staticClass: "hidden-sm-and-down",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "line-height": "5vh"
    }
  }, [_c('span', {
    staticClass: "top-heading"
  }, [_vm._v(_vm._s(_vm.lng.haqcsAsA))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#haqcs-as-a-monitor'),
      expression: "'#haqcs-as-a-monitor'"
    }],
    staticClass: "top-heading top-heading-item top-heading-inactive"
  }, [_vm._v(_vm._s(_vm.lng.measuringDevice))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#haqcs-as-a-controller'),
      expression: "'#haqcs-as-a-controller'"
    }],
    staticClass: "top-heading top-heading-item"
  }, [_vm._v(_vm._s(_vm.lng.controller))]), _c('span', {
    staticClass: "top-heading"
  }, [_vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-and-up"
  }, [_c('span', {
    staticClass: "top-heading"
  }, [_vm._v(_vm._s(_vm.lng.haqcsAsA) + " " + _vm._s(_vm.lng.controller) + ".")])]), _vm._v(" "), _c('p', {
    staticClass: "top-paragraph"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.lng.controllerTopParagraph) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    class: ['shadow', (_vm.headerBarStickingController) ? 'shadow-visible' : 'shadow-invisible']
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-of-haqcs"
  }, [_c('picture', [_c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/webp/0.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/jp2/0.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect dev0",
    attrs: {
      "src": "static/img/devices/webp/0.webp"
    }
  })]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/webp/1.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/jp2/1.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect dev1",
    attrs: {
      "src": "static/img/devices/webp/1.webp"
    }
  })]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/webp/2.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/jp2/2.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect dev2",
    attrs: {
      "src": "static/img/devices/webp/2.webp"
    }
  })]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "noselect haqcs",
    attrs: {
      "media": "(min-width:800px)",
      "srcset": "static/img/haqcs-renderings/gray-auto_1046px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect haqcs",
    attrs: {
      "srcset": "static/img/haqcs-renderings/gray-auto_400px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect haqcs",
    attrs: {
      "src": "static/img/haqcs-renderings/gray-auto_min.png"
    }
  })]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/webp/3.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/jp2/3.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect dev3",
    attrs: {
      "src": "static/img/devices/webp/3.webp"
    }
  })]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/webp/4.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/jp2/4.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect dev4",
    attrs: {
      "src": "static/img/devices/webp/4.webp"
    }
  })]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/webp/5.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/jp2/5.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect dev-2",
    attrs: {
      "src": "static/img/devices/webp/5.webp"
    }
  })]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/webp/6.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/jp2/6.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect dev-1",
    attrs: {
      "src": "static/img/devices/webp/6.webp"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "explanation"
  }, [_c('div', {
    staticClass: "tile tile0"
  }, [_c('img', {
    staticClass: "bg-icon",
    attrs: {
      "src": __webpack_require__(145),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tile-content"
  }, [_c('div', {
    staticClass: "container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.lng.explanationModes) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "tile tile1"
  }, [_c('img', {
    staticClass: "bg-icon",
    attrs: {
      "src": __webpack_require__(148),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tile-content"
  }, [_c('div', {
    staticClass: "container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.explanationWeighting)
    }
  })])]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "tile tile2"
  }, [_c('img', {
    staticClass: "bg-icon",
    attrs: {
      "src": __webpack_require__(147),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tile-content"
  }, [_c('div', {
    staticClass: "container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.lng.explanationStormMode) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "tile tile3"
  }, [_c('img', {
    staticClass: "bg-icon",
    attrs: {
      "src": __webpack_require__(149),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tile-content"
  }, [_c('div', {
    staticClass: "container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.lng.explanationSummerMode) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "static/img/haqcs-as-a-controller-images/Sommerbetrieb.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/img/haqcs-as-a-controller-images/Sommerbetrieb.jpg",
      "loading": "lazy"
    }
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "tile tile4"
  }, [_c('img', {
    staticClass: "bg-icon",
    attrs: {
      "src": __webpack_require__(146),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tile-content"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.lng.explanationHumidityThreshold) + "\n\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "paragraph-container_"
  }, [_c('p', {
    staticClass: "paragraph"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.lng.pCompatible) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (_vm.language === 'pl') ? _c('div', [_c('h3', {
    staticClass: "paragraph bold"
  }, [_vm._v("1. Marley MEnV HAQCS Edition")]), _vm._v(" "), _c('div', {
    staticClass: "paragraph"
  }, [_c('div', {
    staticClass: "flex-container_"
  }, [_c('div', [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width:3000px)",
      "srcset": "static/img/homepage-devices/marley-haqcs-edition_1041px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width:1024px)",
      "srcset": "static/img/homepage-devices/marley-haqcs-edition_1024px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "srcset": "static/img/homepage-devices/marley-haqcs-edition_800px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/img/homepage-devices/marley-haqcs-edition.jpg",
      "loading": "lazy"
    }
  })])], 1), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.marleyMEnV180IIHAQCSEditionString)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  })]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "paragraph bold"
  }, [_vm._v(_vm._s(_vm.language === 'pl' ? '2' : '1') + ". Alnor HRU-WALL-WI")]), _vm._v(" "), _c('div', {
    staticClass: "paragraph"
  }, [_c('div', {
    staticClass: "flex-container_"
  }, [_c('div', [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width:3000px)",
      "srcset": "static/img/homepage-devices/alnor-hru-wall-wi_1600px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width:1024px)",
      "srcset": "static/img/homepage-devices/alnor-hru-wall-wi_1024px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "srcset": "static/img/homepage-devices/alnor-hru-wall-wi_800px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/img/homepage-devices/alnor-hru-wall-wi.jpg",
      "loading": "lazy"
    }
  })])], 1), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.alnorHRUWALLString)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('h3', {
    staticClass: "paragraph bold"
  }, [_vm._v(_vm._s(_vm.language === 'pl' ? '3' : '2') + ". Marley MEnV 180")]), _vm._v(" "), _c('div', {
    staticClass: "paragraph"
  }, [_c('div', {
    staticClass: "flex-container_"
  }, [_c('div', [_c('picture', [_c('source', {
    staticClass: "elevation-2",
    attrs: {
      "media": "(min-width:3000px)",
      "srcset": "static/img/homepage-devices/marley-kit_1600px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "elevation-2",
    attrs: {
      "media": "(min-width:1024px)",
      "srcset": "static/img/homepage-devices/marley-kit_1024px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "elevation-2",
    attrs: {
      "srcset": "static/img/homepage-devices/marley-kit_800px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "elevation-2",
    attrs: {
      "src": "static/img/homepage-devices/marley-kit.jpg",
      "loading": "lazy"
    }
  })])], 1), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.marleyMEnV180String)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('h3', {
    staticClass: "paragraph bold"
  }, [_vm._v(_vm._s(_vm.language === 'pl' ? '4' : '3') + ". Prana 150 " + _vm._s(_vm.lng.and) + " 200 C / G")]), _vm._v(" "), _c('div', {
    staticClass: "paragraph"
  }, [_c('div', {
    staticClass: "flex-container_"
  }, [_c('div', [_c('picture', [_c('source', {
    staticClass: "elevation-2",
    attrs: {
      "media": "(min-width:3000px)",
      "srcset": "static/img/homepage-devices/prana-kit_1600px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "elevation-2",
    attrs: {
      "media": "(min-width:1024px)",
      "srcset": "static/img/homepage-devices/prana-kit_1024px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "elevation-2",
    attrs: {
      "srcset": "static/img/homepage-devices/prana-kit_800px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "elevation-2",
    attrs: {
      "src": "static/img/homepage-devices/prana-kit.jpg",
      "loading": "lazy"
    }
  })])], 1), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.prana150String)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('h3', {
    staticClass: "paragraph bold"
  }, [_vm._v(_vm._s(_vm.language === 'pl' ? '5' : '4') + ". " + _vm._s(_vm.lng.simpleFans))]), _vm._v(" "), _c('div', {
    staticClass: "paragraph"
  }, [_c('div', {
    staticClass: "flex-container_"
  }, [_c('div', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "static/img/homepage-devices/unibox.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/img/homepage-devices/unibox.jpg",
      "loading": "lazy"
    }
  })])], 1), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.lng.simpleString) + "\n\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  })])]), _vm._v(" "), _c('v-card', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "padding": "8px 64px"
    },
    attrs: {
      "tile": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "row-sm": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "124px"
    }
  }, [_c('div', {
    staticClass: "div-center"
  }, [_c('span', {
    staticClass: "span-center"
  }, [_c('p', {
    staticClass: "heading-big"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.lng.contact) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "heading-big grey--text text--darken-2",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.lng.areYouInterested) + "\n\t\t\t\t\t\t\t\t")])])])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "height": "124px"
    }
  }, [_c('div', {
    staticClass: "div-center-124 heading-big grey--text text--darken-2 hidden-xs-only"
  }, [_c('span', {
    staticClass: "span-center"
  }, [_c('v-icon', [_vm._v("phone")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("+49 1522 8619 710")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "div-center-124 heading grey--text text--darken-2 hidden-sm-and-up"
  }, [_c('span', {
    staticClass: "span-center"
  }, [_c('v-icon', [_vm._v("phone")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("+49 1522 8619 710")])], 1)])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "height": "124px"
    }
  }, [_c('div', {
    staticClass: "div-center-124 heading-big grey--text text--darken-2 hidden-xs-only"
  }, [_c('a', {
    staticClass: "a-nocolor",
    attrs: {
      "href": "mailto:info@hapla.eu"
    }
  }, [_c('span', {
    staticClass: "span-center"
  }, [_c('v-icon', [_vm._v("mail")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("info@hapla.eu")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "div-center-124 heading grey--text text--darken-2 hidden-sm-and-up"
  }, [_c('a', {
    staticClass: "a-nocolor",
    attrs: {
      "href": "mailto:info@hapla.eu"
    }
  }, [_c('span', {
    staticClass: "span-center"
  }, [_c('v-icon', [_vm._v("mail")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("info@hapla.eu")])], 1)])])])])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "grey lighten-2",
    staticStyle: {
      "padding": "8px 64px"
    },
    attrs: {
      "tile": ""
    },
    on: {
      "mouseover": function($event) {
        _vm.showProps = true
      },
      "touchmove": function($event) {
        _vm.showProps = true
      }
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "75px"
    }
  }, [_c('div', {
    staticClass: "grey--text text--darken-2"
  }, [_c('div', {
    staticClass: "heading hidden-xs-only"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.lng.contactFormNotice) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "heading-small hidden-sm-and-up"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.lng.contactFormNotice) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.lng.linkContact
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "block": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mail")]), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.lng.openContactFormButton) + "\n\t\t\t\t\t\t\t")], 1)], 1)], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content content-seperator"
  }, [_c('div', {
    staticClass: "tile separator-line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "images"
  }, [_c('img', {
    staticClass: "img0",
    attrs: {
      "src": __webpack_require__(139),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img1",
    attrs: {
      "src": __webpack_require__(140),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img2",
    attrs: {
      "src": __webpack_require__(141),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img3",
    attrs: {
      "src": __webpack_require__(142),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img4",
    attrs: {
      "src": __webpack_require__(143),
      "loading": "lazy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "images"
  }, [_c('img', {
    staticClass: "no-shadow",
    attrs: {
      "src": __webpack_require__(144),
      "loading": "lazy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(138),
      "loading": "lazy"
    }
  })])
}]}

/***/ }),

/***/ 160:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticStyle: {
      "max-width": "1024px"
    }
  }, [_c('v-card', {
    staticStyle: {
      "padding-left": "16px",
      "padding-right": "16px",
      "padding-top": "8px",
      "padding-bottom": "8px"
    }
  }, [(_vm.showSuccessAlert) ? _c('div', [_c('v-alert', {
    attrs: {
      "success": "",
      "value": _vm.showSuccessAlert,
      "transition": "scale-transition"
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.successAlert) + "\n\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "heading-small",
    staticStyle: {
      "padding-top": "32px"
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(this.lng.yourMessage) + "\n\t\t\t\t")]), _vm._v(" "), _c('v-card', {
    staticStyle: {
      "padding-left": "32px",
      "padding-right": "32px",
      "padding-top": "16px",
      "padding-bottom": "16px",
      "margin-bottom": "16px"
    }
  }, [_c('v-layout', {
    attrs: {
      "row-sm": "",
      "column": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(this.lng.name) + ":")]), _vm._v(" "), _c('v-flex', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "8px"
    },
    attrs: {
      "xs12": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(this.lng.mail) + ":")]), _vm._v(" "), _c('v-flex', [_vm._v(_vm._s(_vm.mail))]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "8px"
    },
    attrs: {
      "xs12": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(this.lng.phonenumber) + ":")]), _vm._v(" "), _c('v-flex', [_vm._v(_vm._s(_vm.tel))]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "8px"
    },
    attrs: {
      "xs12": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(this.lng.prefContact) + ":")]), _vm._v(" "), _c('v-flex', [_vm._v(_vm._s(_vm.pref))]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "8px"
    },
    attrs: {
      "xs12": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.message) + "\n\t\t\t\t\t")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.showSuccessAlert) ? _c('div', [_c('v-layout', {
    attrs: {
      "row-md": "",
      "column": ""
    }
  }, [_c('v-flex', {
    staticClass: "long-text grey--text text--darken-1",
    attrs: {
      "md4": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('h1', {
    staticClass: "heading-big grey--text text--darken-1"
  }, [_vm._v(_vm._s(this.lng.contact))]), _vm._v("\n\t\t\t\t\t\t\t\tHaplabit UG (haftungsbeschränkt)"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\tEchterstraße 8a"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\tD-97209 Veitshöchheim"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\tTel.: +49 1522 8619 710"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\tEmail:  info@hapla.eu"), _c('br')]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "spacing-32 hidden-sm-and-down"
  }), _vm._v(" "), _c('div', {
    staticClass: "spacing-32 hidden-sm-and-up"
  }), _vm._v(" "), _c('div', {
    staticClass: "heading",
    staticStyle: {
      "padding-bottom": "8px"
    }
  }, [_vm._v(_vm._s(this.lng.imprint))]), _vm._v("\n\t\t\t\t\t\t\t\tAmtsgericht Würzburg. HRB 15269"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\tGeschäftsführung: Dipl. – Ing. Harald Samoticha"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\tUSt.-ID: DE338177997"), _c('br')])], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-and-up",
    staticStyle: {
      "padding-top": "64px"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md8": "",
      "sm12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-0",
    staticStyle: {
      "padding-left": "16px",
      "padding-right": "16px",
      "padding-top": "16px",
      "padding-bottom": "16px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": this.lng.name,
      "prepend-icon": "person",
      "required": "",
      "rules": [_vm.nameErr]
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": this.lng.mail,
      "prepend-icon": "mail",
      "rules": [_vm.mailErr]
    },
    model: {
      value: (_vm.mail),
      callback: function($$v) {
        _vm.mail = $$v
      },
      expression: "mail"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": this.lng.phonenumber,
      "prepend-icon": "phone",
      "rules": [_vm.telErr]
    },
    model: {
      value: (_vm.tel),
      callback: function($$v) {
        _vm.tel = $$v
      },
      expression: "tel"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row-sm": "",
      "column": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticClass: "grey--text text--darken-1"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(this.lng.preference) + "\n\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', [_c('v-radio', {
    attrs: {
      "label": this.lng.phone,
      "value": "Rückruf (Telefon)",
      "color": "primary"
    },
    model: {
      value: (_vm.pref),
      callback: function($$v) {
        _vm.pref = $$v
      },
      expression: "pref"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-radio', {
    attrs: {
      "label": this.lng.mail,
      "value": "E-Mail",
      "color": "primary"
    },
    model: {
      value: (_vm.pref),
      callback: function($$v) {
        _vm.pref = $$v
      },
      expression: "pref"
    }
  })], 1)], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.lng.message,
      "multi-line": "",
      "required": "",
      "rules": [_vm.messageErr]
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.send()
      }
    }
  }, [_vm._v(_vm._s(this.lng.send))])], 1)], 1)], 1)], 1) : _vm._e()])], 1), _vm._v(" "), (!_vm.showSuccessAlert) ? _c('div', {
    staticClass: "spacing-128"
  }) : _vm._e(), _vm._v(" "), (_vm.showSuccessAlert) ? _c('div', {
    staticStyle: {
      "height": "1200px"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticStyle: {
      "max-width": "1024px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "8px"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.lng.backRoute
    }
  }, [_c('v-btn', {
    staticClass: "back-button",
    attrs: {
      "flat": ""
    }
  }, [_c('v-icon', [_vm._v("chevron_left")]), _vm._v(" " + _vm._s(_vm.lng.back) + "\n\t\t\t")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs-only top",
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    staticClass: "content"
  }, _vm._l((_vm.headings), function(heading) {
    return _c('div', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ('#' + heading.id),
        expression: "'#' + heading.id"
      }],
      key: heading.id
    }, [_c('a', {
      class: (heading.id == _vm.viewedHeading ? 'viewed-heading-' : 'unviewed-heading-') + heading.nodeName
    }, [_vm._v(_vm._s(heading.text))])])
  }))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    staticClass: "content elevation-2"
  }, [(_vm.language == 'en') ? _c('div', [_c('v-container', {
    ref: "mainDoc",
    attrs: {
      "id": "mainDoc"
    }
  }, [_c('h1', [_vm._v("HAQCS — Hapla Air Quality Control System")]), _vm._v(" "), _c('h2', {
    ref: "heading_0",
    attrs: {
      "id": "heading_0"
    }
  }, [_vm._v("Purpose")]), _vm._v(" "), _c('div', [_vm._v("The Hapla Air Quality Control System monitor (HAQCS monitor) fulfills two functions:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("It is an air quality indicator and warning device. It also shows the room climate on a comfort diagram. Alarms are triggered if the limits for healthy climate and good breathing air quality are exceeded. This acts as a reminder to ventilate.")]), _vm._v(" "), _c('li', [_vm._v("In conjunction with devices that can influence the air quality (such as ventilation devices or fans) or improve the indoor climate (humidifiers), it controls these devices as required.")])]), _vm._v(" "), _c('p', [_vm._v("The HAQCS monitor is a guardian of the good air properties in the home, at work and at school. Wherever people spend a long time and, above all, have to stay focused. Good air quality is a prerequisite for this.")]), _vm._v(" "), _c('h2', {
    ref: "heading_1",
    attrs: {
      "id": "heading_1"
    }
  }, [_vm._v("Installation")]), _vm._v(" "), _c('p', [_vm._v(" The device is intended for wall mounting. It can also be placed on flat surfaces such as a desk, a sideboard and the like. It should not be placed in close proximity to people, but rather a little off. This space should have the same air quality as the rest of the room (no unventilated corners), but it should also not be exposed to direct drafts. ")]), _vm._v(" "), _c('p', [_vm._v(" The device should not be exposed to direct sunlight as the CO"), _c('sub', [_vm._v("2")]), _vm._v(" sensor, which is based on the optical principle, could be disturbed. ")]), _vm._v(" "), _c('p', [_vm._v(" The power is supplied by cable from a 5V USB power supply. There are 2 micro USB sockets on the HAQCS monitor. This way it is possible to connect devices hanging on the wall from below, while the other socket is on the side and is intended to be used for that are placed using the pedestal. ")]), _vm._v(" "), _c('h2', {
    ref: "heading_2",
    attrs: {
      "id": "heading_2"
    }
  }, [_vm._v("Usage as an air quality monitor")]), _vm._v(" "), _c('div', {
    staticClass: "between-headings"
  }), _vm._v(" "), _c('h3', {
    ref: "heading_3",
    attrs: {
      "id": "heading_3"
    }
  }, [_vm._v("Internal sensors")]), _vm._v(" "), _c('div', [_vm._v(" The device uses its internal sensors to measure the following indoor air parameters: ")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "narrow"
  }, [_vm._v(" Temperature ")]), _vm._v(" "), _c('li', {
    staticClass: "narrow"
  }, [_vm._v(" Relative humidity ")]), _vm._v(" "), _c('li', {
    staticClass: "narrow"
  }, [_vm._v(" CO"), _c('sub', [_vm._v("2")]), _vm._v(" level ")]), _vm._v(" "), _c('li', {
    staticClass: "narrow"
  }, [_vm._v(" VOC level as CO"), _c('sub', [_vm._v("2")]), _vm._v(" equivalent ")])]), _vm._v(" "), _c('p', [_vm._v(" The first two sizes have an impact on the well-being of people in rooms. Low humidity can lead to health problems due to the mucous membranes drynig out, while moisture that is too high becomes a danger to the building structure. If the humidity is too high, mold can form, thus posing a health hazard for humans. Hygienists recommend a relative humidity in the range of 40 - 60%. ")]), _vm._v(" "), _c('p', [_vm._v(" The "), _c('b', [_vm._v("CO"), _c('sub', [_vm._v("2")]), _vm._v(" level")]), _vm._v(" shows how used up the air is. In living and working spaces, the CO"), _c('sub', [_vm._v("2")]), _vm._v(" comes from people's breath. The concentration, which is approximately 400 ppm in fresh air, increases when people are present. The concentration of 1500 ppm is the upper limit for intellectual work and learning because it already leads to concentration problems. Exceeding the second threshold of 2500 ppm leads to headaches and other health problems with prolonged exposure. ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v(" VOC or TVOC – (Total) Volatile Organic Compounds ")]), _vm._v(" is a generic term for organic substances in the air. They arise in part through evaporation of the human body, but can have a different origin. E.g. Kitchen smells, exudation of furniture and varnishes count among them. ")]), _vm._v(" "), _c('h3', {
    ref: "heading_4",
    attrs: {
      "id": "heading_4"
    }
  }, [_vm._v(" Weighting of CO"), _c('sub', [_vm._v("2")]), _vm._v(" and TVOC ")]), _vm._v(" "), _c('p', [_vm._v(" The result of the air quality measurement is a number. The CO"), _c('sub', [_vm._v("2")]), _vm._v(" concentration is measured in ppm ("), _c('b', [_vm._v("p")]), _vm._v("arts "), _c('b', [_vm._v("p")]), _vm._v("er "), _c('b', [_vm._v("m")]), _vm._v("illion). The value of 400 ppm corresponds to the clean, fresh air. ")]), _vm._v(" "), _c('p', [_vm._v(" The TVOC concentration is converted into a CO"), _c('sub', [_vm._v("2")]), _vm._v(" equivalent after the measurement. The device enables the two sizes to be weighted according to personal priorities. The display and alarms are based on the weighted size. Settings from 100% CO"), _c('sub', [_vm._v("2")]), _vm._v(", 0% TVOC to 50% CO"), _c('sub', [_vm._v("2")]), _vm._v(", 50% TVOC are possible. The CO"), _c('sub', [_vm._v("2")]), _vm._v(" concentration, as the more important variable, is taken into account with at least 50%. ")]), _vm._v(" "), _c('p', [_vm._v(" Read about the setting of the weighting between CO"), _c('sub', [_vm._v("2")]), _vm._v(" and TVOC under "), _c('span', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#heading_11'),
      expression: "'#heading_11'"
    }],
    staticClass: "link"
  }, [_vm._v(" mode")]), _vm._v(". ")]), _vm._v(" "), _c('h3', {
    ref: "heading_5",
    attrs: {
      "id": "heading_5"
    }
  }, [_vm._v("Display")]), _vm._v(" "), _c('p', [_vm._v(" The screen turns on when it is pressed. In addition, the device has a light display above the screen. ")]), _vm._v(" "), _c('p', [_vm._v(" After 35 seconds of inactivity the screen darkens and then goes out. If you'd like to prevent this, click on the symbol in the top right corner. Clicking this icon again turns the screen off. ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(17)
    }
  }), _vm._v(" "), _c('p', [_vm._v("After 2 hours, the screen turns off even when the icon is lit.")]), _vm._v(" "), _c('h4', {
    ref: "heading_6",
    attrs: {
      "id": "heading_6"
    }
  }, [_vm._v("Current air quality")]), _vm._v(" "), _c('p', [_vm._v(" The temperature and relative humidity are shown on the left edge of the screen. ")]), _vm._v(" "), _c('p', [_vm._v(" That includes the air quality as a number in ppm, which is the weighted value (see "), _c('span', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#heading_4'),
      expression: "'#heading_4'"
    }],
    staticClass: "link"
  }, [_vm._v(" Weighting of CO"), _c('sub', [_vm._v("2")]), _vm._v(" and TVOC")]), _vm._v("). At the bottom this number is shown in the form of a graph on a colored scale. Additionally, the air quality can be recognized even when the screen is switched off, by the color and the position of the lights on the display above the screen. The displayed value is a moving average from the last 2 minutes. ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(45)
    }
  }), _vm._v(" "), _c('h4', {
    ref: "heading_7",
    attrs: {
      "id": "heading_7"
    }
  }, [_vm._v("Current indoor climate")]), _vm._v(" "), _c('p', [_vm._v("Clicking on the \"comfort\" button calls up the comfort graph, on which the current values of temperature and relative humidity are marked. The yellow field marks the conditions that are most optimal for the average person. The blue area shows the still acceptable conditions. Outside, most people complain that the indoor climate is too extreme.")]), _vm._v(" "), _c('h4', {
    ref: "heading_8",
    attrs: {
      "id": "heading_8"
    }
  }, [_vm._v("History")]), _vm._v(" "), _c('p', [_vm._v(" By clicking on the \"CO"), _c('sub', [_vm._v("2")]), _vm._v(" history\" button, the course of the air quality in recent times is shown. ")]), _vm._v(" "), _c('p', [_vm._v(" \"Short history\" shows as a colored area the course of CO"), _c('sub', [_vm._v("2")]), _vm._v(" concentration in ppm within the last 3 hours. The black line represents the TVOC concentration as a CO"), _c('sub', [_vm._v("2")]), _vm._v(" equivalent in ppm. ")]), _vm._v(" "), _c('p', [_vm._v(" The current values are on the left edge of the screen. ")]), _vm._v(" "), _c('p', [_vm._v("\"Long history\" shows the same sizes within the last 12 hours.")]), _vm._v(" "), _c('h3', {
    ref: "heading_9",
    attrs: {
      "id": "heading_9"
    }
  }, [_vm._v("Alarms")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("currently undocumented")]), _vm._v(" "), _c('h3', {
    ref: "heading_10",
    attrs: {
      "id": "heading_10"
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('p', [_vm._v("The HAQCS monitor features a number of settings that may be tweaked by the user. The settings menu can be opened by clicking the gear icon in the top left corner of the screen.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(17)
    }
  }), _vm._v(" "), _c('p', [_vm._v("The following subject areas are available:")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(48)
    }
  }), _vm._v(" "), _c('h4', {
    ref: "heading_11",
    attrs: {
      "id": "heading_11"
    }
  }, [_vm._v("mode")]), _vm._v(" "), _c('p', [_vm._v("The weighting between CO"), _c('sub', [_vm._v("2")]), _vm._v(" and TVOC can be carried out here. The displayed air quality, whether as a number or as the color and position of the chain of lights above the screen, is based on this setting.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(47)
    }
  }), _vm._v(" "), _c('p', [_vm._v("Move the marker to the desired position on the slider. On the far left only CO"), _c('sub', [_vm._v("2")]), _vm._v(" is taken into account. The most-right position represents a weighting of 50:50.")]), _vm._v(" "), _c('h4', {
    ref: "heading_12",
    attrs: {
      "id": "heading_12"
    }
  }, [_vm._v("brightness")]), _vm._v(" "), _c('p', [_vm._v("Here the brightness of the LED bar above the screen can be adjusted.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(44)
    }
  }), _vm._v(" "), _c('p', [_c('i', [_vm._v("„Enable CO"), _c('sub', [_vm._v("2")]), _vm._v(" indicator lights“")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\t\tAllows the LED display to be switched off if it were to be bothersome.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("„LED strip brightness")]), _vm._v("“"), _c('br'), _vm._v("\n\t\t\t\t\t\t\tLets the brightness be adjusted to personal preferences. Allows you to change the automatically calculated brightness in the range of 50% - 200%.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("„Adjust LED strip brightness automatically")]), _vm._v("“"), _c('br'), _vm._v("\n\t\t\t\t\t\t\tToggles the automatic adjustment of the brightness to the ambient light.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("„Disable CO"), _c('sub', [_vm._v("2")]), _vm._v(" indicator lights in the dark")]), _vm._v("“"), _c('br'), _vm._v("\n\t\t\t\t\t\t\tThis automatically switches off the LED display in dark surroundings so that it does not light up during the night.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('h4', {
    ref: "heading_13",
    attrs: {
      "id": "heading_13"
    }
  }, [_vm._v("devices")]), _vm._v(" "), _c('p', [_vm._v("This menu enables ventilation units to be connected and manages the connected units. This menu has no meaning when using the HAQCS monitor only as an air quality monitor.")]), _vm._v(" "), _c('h3', {
    ref: "heading_14",
    attrs: {
      "id": "heading_14"
    }
  }, [_vm._v("Compatible devices")]), _vm._v(" "), _c('p', [_vm._v("You can find a list of compatible devices on the Internet at:")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.hapla.eu/offer",
      "target": "_blank"
    }
  }, [_vm._v("www.hapla.eu/offer")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Even simple 230 V fans, possibly already in use, can be controlled with the HAQCS monitor. For this purpose UniBox devices are connected to the power supply of the fans. Then they receive the control commands and use their internal power controller to adjust the speed of the fans and switch them on and off accordingly.")]), _vm._v(" "), _c('h3', {
    ref: "heading_15",
    attrs: {
      "id": "heading_15"
    }
  }, [_vm._v("Connect to devices")]), _vm._v(" "), _c('p', [_vm._v(" The HAQCS monitor is equipped with internal sensors and measures the air quality in the area in which it was installed. Therefore, it should control ventilation devices that ensure air quality in this area. It should not control ventilation in other areas because it lacks the measurement data for other rooms. ")]), _vm._v(" "), _c('p', [_vm._v(" If the ventilation of several areas of a house is to be controlled automatically, a HAQCS monitor must be set up in each of these areas. ")]), _vm._v(" "), _c('p', [_vm._v(" A HAQCS monitor can also capture large rooms and control several devices (up to 16) at the same time. The ventilation of a restaurant or an open-plan office can therefore be controlled by a HAQCS monitor. ")]), _vm._v(" "), _c('p', [_vm._v(" In order for the ventilation units to be controlled, they must be connected to the HAQCS monitor. To establish the connection, proceed as follows: ")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v(" Activate the ventilation unit to connect. To do this, follow the instructions of your ventilation unit. ")]), _vm._v(" "), _c('li', [_vm._v(" In HAQCS-Monitor go to the settings (button with the gear symbol in the upper left corner) and then to \"devices\" ")]), _vm._v(" "), _c('li', [_vm._v(" You will see a (probably still empty) list of connected devices. To add a new device click on the blue \"+\" symbol. ")]), _vm._v(" "), _c('li', [_vm._v(" A list of the devices that can be connected appears. The devices have a serial number that is shown in the list. Select the device you'd like to connect. ")]), _vm._v(" "), _c('li', [_vm._v(" You may have to enter a password to establish the connection. ")])]), _vm._v(" "), _c('p', [_vm._v(" Repeat this for all devices that are to be controlled by the HAQCS monitor. ")]), _vm._v(" "), _c('p', [_vm._v(" You can also remove devices from the list. To do this, click on the device in the list (gear symbol) and follow the instructions. ")]), _vm._v(" "), _c('h3', {
    ref: "heading_16",
    attrs: {
      "id": "heading_16"
    }
  }, [_vm._v("Operation and mode selection")]), _vm._v(" "), _c('p', [_vm._v(" The ventilation units can work in 3 automatic modes, be controlled manually by the user, be particularly quiet in the night mode or ventilate intensively in the \"storm mode\". A cooling effect is achieved when the devices are running in the summer mode. The targeted ventilation during periods of high humidity prevents mold growth. ")]), _vm._v(" "), _c('p', [_vm._v(" The operating mode is selected in the upper screen bar by scrolling left or right with the directional arrows. ")]), _vm._v(" "), _c('h4', {
    ref: "heading_17",
    attrs: {
      "id": "heading_17"
    }
  }, [_vm._v("Automatic mode")]), _vm._v(" "), _c('p', [_vm._v("There are 3 automatic modes. The control of the fan speed depends on the pollutant concentration as follows:")]), _vm._v(" "), _c('img', {
    staticClass: "no-shadow",
    attrs: {
      "src": __webpack_require__(43)
    }
  }), _vm._v(" "), _c('p', [_vm._v(" If the air quality is good, the ventilation units are switched off as ventilation is not necessary. If the threshold concentration C1, C2 or C3 is exceeded, the ventilation units start at minimum speed. Then there is a range in which the speed depends linearly on the pollutant concentration. At even higher concentrations, the speed remains at maximum. ")]), _vm._v(" "), _c('p', [_vm._v(" \"AUTO (fresh)\" is designed for maximum ventilation, \"AUTO (silent)\" for quiet operation with drawbacks in the air flow. \"AUTO\" is a compromise between the two. For a given average concentration, the speed difference between the levels is 10%, i.e. between \"fresh\" and \"silent\" 20%. ")]), _vm._v(" "), _c('p', [_vm._v(" Devices that do not support a stepless speed control switch the speed in stages and simulate the curves as best they can. ")]), _vm._v(" "), _c('h4', {
    ref: "heading_18",
    attrs: {
      "id": "heading_18"
    }
  }, [_vm._v("Manual control")]), _vm._v(" "), _c('p', [_vm._v(" The manual control enables the user to control the speed of the ventilation units between 0% (the minimum speed of the specific model) and 100% (maximum speed) in steps of 10%. The devices then operate in an uncontrolled manner. The control takes place with the help of the \"+\" and \"–\" buttons. ")]), _vm._v(" "), _c('h4', {
    ref: "heading_19",
    attrs: {
      "id": "heading_19"
    }
  }, [_vm._v("Night mode")]), _vm._v(" "), _c('p', [_vm._v("The night mode focuses on the smooth running of the ventilation units. They run constantly at the minimum speed and are therefore uncontrolled.")]), _vm._v(" "), _c('h4', {
    ref: "heading_20",
    attrs: {
      "id": "heading_20"
    }
  }, [_vm._v("Intensive mode")]), _vm._v(" "), _c('p', [_vm._v(" The intensive mode (a.k.a. the \"storm mode\") is used to ventilate rooms intensively. The connected ventilation units then operate at full power for a certain amount of time (which can be one of 10, 20 or 30 minutes) and then return to the previous mode. ")]), _vm._v(" "), _c('p', [_vm._v(" It is advisable to activate the intensive mode for a break at school or during meetings, during the lunch break. Or at home when you leave the house, after cooking, etc. ")]), _vm._v(" "), _c('h4', {
    ref: "heading_21",
    attrs: {
      "id": "heading_21"
    }
  }, [_vm._v("Summer mode")]), _vm._v(" "), _c('p', [_vm._v(" The summer mode enables ventilation without heat recovery. The idea is to let the fresh air flow into the rooms from the cooler side of the house and discharge them in other directions. For this purpose either two ventilation units or a single ventilation unit and a partially open window are utilized. This creates a certain natural cooling effect. ")]), _vm._v(" "), _c('p', {
    staticClass: "message"
  }, [_c('b', [_vm._v(" Attention: ")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\t\tDo not use if you are using air conditioning. "), _c('br'), _vm._v("\n\t\t\t\t\t\t\tThen the cold recovery is mandatory.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v(" Ventilation units that normally change their conveying direction periodically only work in one direction in summer mode (the direction can be set on the unit). For ventilation units that are equipped with 2 fans and normally supply air and extract air at the same time, one of the fans is switched off (selection on the unit). ")]), _vm._v(" "), _c('h4', {
    ref: "heading_22",
    attrs: {
      "id": "heading_22"
    }
  }, [_vm._v("Dehumidification")]), _vm._v(" "), _c('p', [_vm._v(" The ventilation removes the excess moisture from the rooms. However, situations are possible in which the air quality requires little or no ventilation, but the humidity requires more intensive ventilation. The HAQCS monitor automatically increases the air volume when the set threshold humidity is exceeded. The ventilation units are informed that they are working in dehumidification mode so that they can react accordingly.")]), _vm._v(" "), _c('p', [_vm._v(" The regulation follows the following algorithm: ")]), _vm._v(" "), _c('p', [_vm._v(" If the set threshold for humidity \"F\" is reached, the dehumidification mode is activated automatically. The controller calculates the appropriate speed based on the relative humidity. If this results in a higher speed than the quality measurement, this higher speed is transmitted to the ventilation units. ")]), _vm._v(" "), _c('img', {
    staticClass: "no-shadow",
    attrs: {
      "src": __webpack_require__(46)
    }
  }), _vm._v(" "), _c('h4', {
    ref: "heading_23",
    attrs: {
      "id": "heading_23"
    }
  }, [_vm._v("Power failure")]), _vm._v(" "), _c('p', [_vm._v("After changing the mode, the new setting is saved permanently after 5 minutes. If the power supply is interrupted, the HAQCS monitor then starts with the saved settings and the operating mode is retained.")])])], 1) : _vm._e(), _vm._v(" "), (_vm.language == 'de') ? _c('div', [_c('v-container', {
    ref: "mainDoc",
    attrs: {
      "id": "mainDoc"
    }
  }, [_c('h1', [_vm._v("HAQCS — Hapla Air Quality Control System")]), _vm._v(" "), _c('h2', {
    ref: "heading_0",
    attrs: {
      "id": "heading_0"
    }
  }, [_vm._v("Bestimmung")]), _vm._v(" "), _c('div', [_vm._v("Der Monitor vom Hapla Air Quality Control System (HAQCS-Monitor) erfüllt zwei Funktionen:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Er ist ein Luftqualitäts-Anzeiger und -Warner. Er zeigt zudem das Raumklima auf einem Behaglichkeitsdiagram an. Bei Überschreitung der Grenzwerte für gesundes Klima und gute Atemluftqualität werden Alarme ausgelöst. Damit wird an das Lüften erinnert.")]), _vm._v(" "), _c('li', [_vm._v("In Verbindung mit Geräten, die die Luftqualität beeinflussen können (Lüftungsgeräte, Ventilatoren) oder das Raumklima verbessern können (Luftbefeuchter) steuert er diese Geräte bedarfsgerecht.")])]), _vm._v(" "), _c('p', [_vm._v("Der HAQCS-Monitor ist ein Bewacher der guten Lufteigenschaften in der Wohnung, am Arbeitsplatz und in der Schule. Überall dort, wo Menschen längere Zeit verbringen und vor Allem konzentriert bleiben müssen. Gute Luftqualität ist dafür Voraussetzung.")]), _vm._v(" "), _c('h2', {
    ref: "heading_1",
    attrs: {
      "id": "heading_1"
    }
  }, [_vm._v("Aufstellung")]), _vm._v(" "), _c('p', [_vm._v("Das Gerät ist für die Wandmontage vorgesehen. Außerdem kann es auf ebenen Flächen, wie einem Schreibtisch, einem Sideboard und Ähnlichem aufgestellt werden. Es soll nicht in direkter Nachbarkeit der Personen, sondern etwas abseits sein. Dieser Platz soll die gleiche Luftqualität aufweisen, wie der Rest des Raumes (keine ungelüfteten Ecken), aber auch nicht dem direkten Luftzug ausgesetzt sein.")]), _vm._v(" "), _c('p', [_vm._v("Das Gerät soll nicht direkten Sonnenstrahlen ausgesetzt sein – der CO"), _c('sub', [_vm._v("2")]), _vm._v("-Sensor, der auf optischem Prinzip basiert, könnte dadurch gestört sein.")]), _vm._v(" "), _c('p', [_vm._v("Die Stromversorgung erfolgt per Kabel von einem 5V USB-Netzgerät. Am HAQCS-Monitor befinden sich 2 Mikro-USB-Buchsen. So ist es möglich an der Wand hängende Geräte von unten anzuschließen, während die andere Buchse sich an der Seite befindet und bei aufgestellten Geräten verwendet wird.")]), _vm._v(" "), _c('h2', {
    ref: "heading_2",
    attrs: {
      "id": "heading_2"
    }
  }, [_vm._v("Verwendung als Luftqualitätsmonitor")]), _vm._v(" "), _c('div', {
    staticClass: "between-headings"
  }), _vm._v(" "), _c('h3', {
    ref: "heading_3",
    attrs: {
      "id": "heading_3"
    }
  }, [_vm._v("Interne Sensoren")]), _vm._v(" "), _c('div', [_vm._v("Das Gerät misst mit seinen internen Sensoren die folgenden Parameter der Raumluft:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "narrow"
  }, [_vm._v("Temperatur")]), _vm._v(" "), _c('li', {
    staticClass: "narrow"
  }, [_vm._v("Relative Feuchte")]), _vm._v(" "), _c('li', {
    staticClass: "narrow"
  }, [_vm._v("CO"), _c('sub', [_vm._v("2")]), _vm._v("-Pegel")]), _vm._v(" "), _c('li', {
    staticClass: "narrow"
  }, [_vm._v("VOC-Pegel als CO"), _c('sub', [_vm._v("2")]), _vm._v("-Äquivalent")])]), _vm._v(" "), _c('p', [_vm._v("Die zwei ersten Größen haben Einfluss auf das Wohlbefinden der Menschen in Räumen. Zu niedrige Feuchte kann zu gesundheitlichen Problemen führen, weil die Schleimhäute austrocknen, während eine zu hohe Feuchte zur Gefahr für die Bausubstanz wird. Bei zu hoher Feuchte können sich Schimmel bilden, was ebenfalls gesundheitsgefährdend für den Menschen ist. Hygieniker empfehlen eine relative Feuchte im Bereich 40 – 60%.")]), _vm._v(" "), _c('p', [_vm._v("Der "), _c('b', [_vm._v("CO"), _c('sub', [_vm._v("2")]), _vm._v("-Pegel")]), _vm._v(" zeigt wie verbraucht die Luft ist. In Wohn- und Arbeitsräumen stammt das CO"), _c('sub', [_vm._v("2")]), _vm._v(" aus dem Atem der Menschen. Die Konzentration, die in frischer Luft ca. 400 ppm beträgt, steigt bei Anwesenheit von Menschen. Die Konzentration von 1500 ppm gilt als Obergrenze für geistige Arbeit und das Lernen, weil sie bereits zu Konzentrationsstörungen führt. Die Überschreitung der zweiten Schwelle von 2500 ppm führt bei längerer Exposition zu Kopfschmerzen und anderen gesundheitlichen Beeinträchtigungen.")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("VOC oder TVOC – (Total) Volatile Organic Compounds")]), _vm._v(" ist ein Oberbegriff für organische Substanzen in der Luft. Sie entstehen z.T. durch Ausdunstungen des menschlichen Körpers, können aber einen anderen Ursprung haben. Z.B. Küchengerüche, Absonderungen der Möbel und Lacke zählen dazu. ")]), _vm._v(" "), _c('h3', {
    ref: "heading_4",
    attrs: {
      "id": "heading_4"
    }
  }, [_vm._v("Gewichtung von CO"), _c('sub', [_vm._v("2")]), _vm._v(" und TVOC")]), _vm._v(" "), _c('p', [_vm._v("Das Ergebnis der Luftqualitätsmessung ist eine Zahl. Die CO"), _c('sub', [_vm._v("2")]), _vm._v("-Konzentration wird in ppm ("), _c('b', [_vm._v("p")]), _vm._v("arts "), _c('b', [_vm._v("p")]), _vm._v("er "), _c('b', [_vm._v("m")]), _vm._v("illion) gemessen. Der Wert von 400 ppm entspricht der sauberen, frischen Luft.")]), _vm._v(" "), _c('p', [_vm._v("Die TVOC-Konzentration wird nach der Messung in ein CO"), _c('sub', [_vm._v("2")]), _vm._v("-Äquivalent umgerechnet. Das Gerät ermöglicht es die beiden Größen entsprechend den persönlichen Prioritäten zu gewichten. Die Anzeige und die Alarme basieren auf der gewichteten Größe. Möglich sind Einstellungen von 100% CO"), _c('sub', [_vm._v("2")]), _vm._v(", 0% TVOC bis 50% CO"), _c('sub', [_vm._v("2")]), _vm._v(", 50% TVOC. Die CO"), _c('sub', [_vm._v("2")]), _vm._v("-Konzentration, als die wichtigere Größe wird mit mindestens 50% berücksichtigt.")]), _vm._v(" "), _c('p', [_vm._v("Über die Einstellung der Gewichtung zwischen CO"), _c('sub', [_vm._v("2")]), _vm._v(" und TVOC lesen Sie unter "), _c('span', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#heading_11'),
      expression: "'#heading_11'"
    }],
    staticClass: "link"
  }, [_vm._v("Arbeitsmodus (mode)")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    ref: "heading_5",
    attrs: {
      "id": "heading_5"
    }
  }, [_vm._v("Anzeige")]), _vm._v(" "), _c('p', [_vm._v("Der Bildschirm schaltet sich nach einem Anklicken an. Darüber hinaus verfügt das Gerät über eine Lichtanzeige über dem Bildschirm.")]), _vm._v(" "), _c('p', [_vm._v("Nach 35 Sekunden verdunkelt sich der Bildschirm und geht danach aus. Will man das verhindern, soll das Symbol in der rechten oberen Ecke angeklickt werden. Das wiederholte Anklicken dieses Symbols schaltet den Bildschirm aus.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(17)
    }
  }), _vm._v(" "), _c('p', [_vm._v("Nach 2 Stunden wird der Bildschirm auch dann ausgeschaltet, wenn das Symbol leuchtet.")]), _vm._v(" "), _c('h4', {
    ref: "heading_6",
    attrs: {
      "id": "heading_6"
    }
  }, [_vm._v("Aktuelle Luftqualität")]), _vm._v(" "), _c('p', [_vm._v("An dem linken Rand des Bildschirms sind die Temperatur und die relative Feuchte angegeben.")]), _vm._v(" "), _c('p', [_vm._v("Darunter die Luftqualität als Zahl in ppm, wobei das der gewichtete Wert ist (siehe "), _c('span', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#heading_4'),
      expression: "'#heading_4'"
    }],
    staticClass: "link"
  }, [_vm._v("Gewichtung von CO"), _c('sub', [_vm._v("2")]), _vm._v(" und TVOC")]), _vm._v("). Am unteren Rand ist diese Zahl in Form von einem Graf auf farbiger Skala dargestellt. Außerdem ist die Luftqualität auch bei ausgeschaltetem Bildschirm, an der Farbe und der Position der Lichter auf der Anzeige oberhalb des Bildschirms erkennbar. Der angezeigte Wert ist ein gleitender Durchschnitt aus den letzten 2 Minuten.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(45)
    }
  }), _vm._v(" "), _c('h4', {
    ref: "heading_7",
    attrs: {
      "id": "heading_7"
    }
  }, [_vm._v("Aktuelles Raumklima")]), _vm._v(" "), _c('p', [_vm._v("Durch klicken auf die Schaltfläche „comfort“ wird der Behaglichkeitsgraf aufgerufen, auf dem die aktuellen Werte von Temperatur und relativer Feuchte eingetragen sind. Das gelbe Feld markiert die optimalen Bedingungen für die Menschen. Die blaue Fläche zeigt den noch akzeptablen Zustand. Außerhalb klagen die meisten Menschen über zu extremes Raumklima.")]), _vm._v(" "), _c('h4', {
    ref: "heading_8",
    attrs: {
      "id": "heading_8"
    }
  }, [_vm._v("Geschichte")]), _vm._v(" "), _c('p', [_vm._v("Durch klicken auf die Schaltfläche „CO"), _c('sub', [_vm._v("2")]), _vm._v(" history“ wird der Verlauf der Luftqualität in der letzten Zeit dargestellt.")]), _vm._v(" "), _c('p', [_vm._v("„Short history“ zeigt als eine farbige Fläche den Verlauf von CO"), _c('sub', [_vm._v("2")]), _vm._v("-Konzentration in ppm innerhalb der letzten 3 Stunden an. Die schwarze Linie soll die TVOC-Konzentration als CO"), _c('sub', [_vm._v("2")]), _vm._v("-Äquivalent in ppm darstellen.")]), _vm._v(" "), _c('p', [_vm._v("Am linken Bildrand sind die aktuellen Werte.")]), _vm._v(" "), _c('p', [_vm._v("„Long history“ zeigt die gleichen Größen in den letzten 12 Stunden.")]), _vm._v(" "), _c('h3', {
    ref: "heading_9",
    attrs: {
      "id": "heading_9"
    }
  }, [_vm._v("Alarme")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("momentan undokumentiert")]), _vm._v(" "), _c('h3', {
    ref: "heading_10",
    attrs: {
      "id": "heading_10"
    }
  }, [_vm._v("Einstellungen")]), _vm._v(" "), _c('p', [_vm._v("Um Einstellungen vorzunehmen klicken Sie auf das Zahnrad in der linken oberen Ecke des Bildschirms.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(17)
    }
  }), _vm._v(" "), _c('p', [_vm._v("Folgende Themenbereiche Stehen zur Verfügung:")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(48)
    }
  }), _vm._v(" "), _c('h4', {
    ref: "heading_11",
    attrs: {
      "id": "heading_11"
    }
  }, [_vm._v("Arbeitsmodus (mode)")]), _vm._v(" "), _c('p', [_vm._v("Hier kann die Gewichtung zwischen CO"), _c('sub', [_vm._v("2")]), _vm._v(" und TVOC vorgenommen werden. Die angezeigte Luftqualität, ob als Zahl oder als Farbe und Position der Lichterkette oberhalb des Bildschirms, basiert auf dieser Einstellung.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(47)
    }
  }), _vm._v(" "), _c('p', [_vm._v("Verschieben Sie den Marker an dem Schieber in die gewünschte Position. Ganz links wird nur CO"), _c('sub', [_vm._v("2")]), _vm._v(" berücksichtigt. Rechte Position bedeutet Gewichtung 50:50.")]), _vm._v(" "), _c('h4', {
    ref: "heading_12",
    attrs: {
      "id": "heading_12"
    }
  }, [_vm._v("Helligkeit (brightness)")]), _vm._v(" "), _c('p', [_vm._v("Hier kann die Helligkeit der LED-Leiste über dem Bildschirm angepasst werden.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(44)
    }
  }), _vm._v(" "), _c('p', [_c('i', [_vm._v("„Enable CO"), _c('sub', [_vm._v("2")]), _vm._v(" indicator lights“")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\t\tErmöglicht die LED-Anzeige auszuschalten, wenn sie stören sollte.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("„LED strip brightness")]), _vm._v("“"), _c('br'), _vm._v("\n\t\t\t\t\t\t\tAnpassung der Helligkeit an die persönlichen Präferenzen. Ermöglicht die automatisch berechnete Helligkeit im Bereich 50% - 200% zu ändern.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("„Adjust LED strip brightness automatically")]), _vm._v("“"), _c('br'), _vm._v("\n\t\t\t\t\t\t\tSchaltet die automatische Anpassung der Helligkeit an das Umgebungslicht.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("„Disable CO"), _c('sub', [_vm._v("2")]), _vm._v(" indicator lights in the dark")]), _vm._v("“"), _c('br'), _vm._v("\n\t\t\t\t\t\t\tDamit erfolgt automatisches Abschalten der LED-Anzeige in dunkler Umgebung, damit sie nicht stört. \n\t\t\t\t\t\t")]), _vm._v(" "), _c('h4', {
    ref: "heading_13",
    attrs: {
      "id": "heading_13"
    }
  }, [_vm._v("Verbundene Geräte (devices)")]), _vm._v(" "), _c('p', [_vm._v("Dieses Menü ermöglicht Lüftungsgeräte anzuschließen und verwaltet die angeschlossenen Geräte. Bei der Nutzung des HAQCS-Monitors nur als Luftqualitäts-Monitor hat dieses Menu keine Bedeutung.")]), _vm._v(" "), _c('h3', {
    ref: "heading_14",
    attrs: {
      "id": "heading_14"
    }
  }, [_vm._v("Kompatible Geräte")]), _vm._v(" "), _c('p', [_vm._v("Die Liste der kompatiblen Geräte finden Sie im Internet unter der Adresse:")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.hapla.eu/angebot",
      "target": "_blank"
    }
  }, [_vm._v("www.hapla.eu/angebot")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Auch einfache 230 V Ventilatoren, eventuell bereits im Einsatz, lassen sich mit HAQCS-Monitor regeln. Dafür werden UniBox-Geräte in die Stromzuleitung zu den Ventilatoren geschaltet. Dann empfangen sie die Steuerbefehle und mittels enthaltenen Leistungsreglers verstellen Sie die Drehzahl der Ventilatoren und schalten sie ein und aus.")]), _vm._v(" "), _c('h3', {
    ref: "heading_15",
    attrs: {
      "id": "heading_15"
    }
  }, [_vm._v("Verbinden mit Geräten")]), _vm._v(" "), _c('p', [_vm._v("Der HAQCS-Monitor ist mit internen Sensoren ausgestattet und misst die Luftqualität in diesem Bereich in dem er montiert wurde. Daher soll er Lüftungsgeräte steuern, die für die Luftqualität in diesem Bereich sorgen. Er soll nicht die Lüftung in anderen Bereichen regeln, da ihm die Messdaten für andere Räume fehlen. ")]), _vm._v(" "), _c('p', [_vm._v("Soll die Lüftung mehrerer Bereiche eines Hauses automatisch geregelt werden, muss in jedem dieser Bereiche ein HAQCS-Monitor aufgestellt sein. ")]), _vm._v(" "), _c('p', [_vm._v("Ein HAQCS-Monitor kann aber auch große Räume erfassen und mehrere Geräte (bis zu 16) gleichzeitig steuern. So kann die Lüftung eines Restaurants oder eines Großraumbüros von einem HAQCS-Monitor gesteuert werden.")]), _vm._v(" "), _c('p', [_vm._v("Damit die Lüftungsgeräte geregelt werden können, müssen sie mit einem HAQCS-Monitor verbunden werden. Um die Verbindung herzustellen, gehen Sie folgendermaßen vor:")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Aktivieren Sie das Lüftungsgerät zum Verbinden. Folgen Sie dazu der Instruktion Ihres Lüftungsgeräts. ")]), _vm._v(" "), _c('li', [_vm._v("Gehen Sie in HAQCS-Monitor in die Einstellungen (Schaltfläche mit der Zahnradsymbol in der oberen linken Ecke) und dann zu „devices“")]), _vm._v(" "), _c('li', [_vm._v("Sie sehen eine (wahrscheinlich noch leere) Liste der verbundenen Geräte. Um ein weiteres Gerät hinzuzufügen klicken Sie auf das blaue „ + “ Symbol.")]), _vm._v(" "), _c('li', [_vm._v("Es erscheint eine Liste der Geräte, die verbunden werden können. Die Geräte verfügen über eine Seriennummer, die in der Liste angezeigt wird. Wählen Sie das Gerät, das Sie verbinden wollen, aus. ")]), _vm._v(" "), _c('li', [_vm._v("Eventuell müssen Sie noch ein Password eingeben, um die Verbindung zu errichten.")])]), _vm._v(" "), _c('p', [_vm._v("Auf diese Weise verbinden Sie alle Geräte, die von dem HAQCS-Monitor geregelt werden sollen.")]), _vm._v(" "), _c('p', [_vm._v("Sie können auch Geräte aus der Liste wieder entfernen. Klicken Sie dazu das Gerät in der Liste an (Zahnradsymbol) und folgen Sie den Instruktionen.")]), _vm._v(" "), _c('h3', {
    ref: "heading_16",
    attrs: {
      "id": "heading_16"
    }
  }, [_vm._v("Funktionsweise und Moduswahl")]), _vm._v(" "), _c('p', [_vm._v("Die Lüftungsgeräte können in 3 automatischen Modi arbeiten, durch den Benutzer manuell gesteuert werden, im Nachtmodus besonders laufruhig sein oder im „storm mode“ zeitgesteuert intensiv lüften. Im Sommermodus wird ein Kühleffekt erzielt. Gezielte Lüftung bei hoher Luftfeuchte verhindert Schimmelbildung.")]), _vm._v(" "), _c('p', [_vm._v("Der Betriebsmodus wird in der oberen Bildschirmleiste ausgewählt, indem man nach links oder rechts mit den Richtungspfeilen scrollt.")]), _vm._v(" "), _c('h4', {
    ref: "heading_17",
    attrs: {
      "id": "heading_17"
    }
  }, [_vm._v("Automatikmodus")]), _vm._v(" "), _c('p', [_vm._v("Es gibt 3 automatische Modi. Die Regelung der Drehzahl der Lüfter ist folgendermaßen von der Schadstoff-Konzentration abhängig:")]), _vm._v(" "), _c('img', {
    staticClass: "no-shadow",
    attrs: {
      "src": __webpack_require__(43)
    }
  }), _vm._v(" "), _c('p', [_vm._v("Bei guter Luftqualität werden die Lüftungsgeräte abgeschaltet – Lüftung ist nicht notwendig. Wird die Schwellenkonzentration C1, C2 oder C3 überschritten, starten die Lüftungsgeräte mit minimaler Drehzahl. Dann folgt ein Bereich, in dem die Drehzahl linear von der Schadstoffkonzentration abhängt. Bei noch höheren Konzentrationen bleibt die Drehzahl bei Maximum.")]), _vm._v(" "), _c('p', [_vm._v("„AUTO (fresh)“ ist auf maximale Lüftung ausgelegt, „AUTO (silent)“ auf leisen Betrieb bei Abstrichen bei dem Luftstrom. „AUTO“ ist ein Kompromiss zwischen den beiden. Bei einer gegebenen mittleren Konzentration beträgt der Abstand der Drehzahlen zwischen den Stufen 10%, also zwischen „fresh“ und „silent“ 20%.")]), _vm._v(" "), _c('p', [_vm._v("Geräte, die eine stufenlose Drehzahlregelung nicht unterstützen, schalten die Drehzahl in Stufen und bilden die Kurven so gut sie können nach.")]), _vm._v(" "), _c('h4', {
    ref: "heading_18",
    attrs: {
      "id": "heading_18"
    }
  }, [_vm._v("Manuelle Steuerung")]), _vm._v(" "), _c('p', [_vm._v("Die manuelle Steuerung ermöglicht dem Benutzer die Drehzahl der Lüftungsgeräte zwischen 0% (die Minimaldrehzahl des bestimmten Modells) und 100% (Maximaldrehzahl) in Schritten je 10% zu steuern. Die Geräte laufen dann ungeregelt. Die Steuerung erfolgt mit Hilfe der Schaltflächen „ + “ und „ - “.")]), _vm._v(" "), _c('h4', {
    ref: "heading_19",
    attrs: {
      "id": "heading_19"
    }
  }, [_vm._v("Nachtmodus")]), _vm._v(" "), _c('p', [_vm._v("Im Nachtmodus wird der Schwerpunkt auf die Laufruhe der Lüftungsgeräte gelegt. Sie laufen konstant mit der minimalen Drehzahl, also ungeregelt.")]), _vm._v(" "), _c('h4', {
    ref: "heading_20",
    attrs: {
      "id": "heading_20"
    }
  }, [_vm._v("Intensivmodus")]), _vm._v(" "), _c('p', [_vm._v("Der Intensivmodus „storm mode“ wird benutzt, um Räume intensiv zu lüften. Die verbundenen Lüftungsgeräte laufen dann eine gewisse Zeit mit voller Leistung und kehren danach in den vorherigen Modus zurück. ")]), _vm._v(" "), _c('p', [_vm._v("Es empfiehlt sich den Intensivmodus für die Dauer einer Pause in der Schule oder bei Besprechungen, in der Mittagspause zu aktivieren. Oder zu Hause, wenn man das Haus verlässt, oder nach dem Kochen, usw.")]), _vm._v(" "), _c('h4', {
    ref: "heading_21",
    attrs: {
      "id": "heading_21"
    }
  }, [_vm._v("Sommer-Modus")]), _vm._v(" "), _c('p', [_vm._v("Der Sommermodus ermöglicht eine Lüftung ohne Wärmerückgewinnung. Die Idee ist, die frische Luft von der kühleren Seite des Hauses in die Räume strömen zu lassen und in andere Richtungen zu entlassen. Dafür werden 2 Lüftungsgeräte verwendet, oder ein Lüftungsgerät und ein teilweise offenes Fenster. Dadurch wird ein gewisser natürlicher Kühleffekt erzielt.")]), _vm._v(" "), _c('p', {
    staticClass: "message"
  }, [_c('b', [_vm._v("Achtung:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\t\tNicht benutzen, wenn Sie eine Klimaanlage verwenden. "), _c('br'), _vm._v("\n\t\t\t\t\t\t\tDann ist die Kälte-Rückgewinnung obligatorisch.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("Lüftungsgeräte, die normalerweise ihre Förderrichtung periodisch wechseln, arbeiten im Sommermodus immer nur in eine Richtung (die Richtung ist einstellbar am Gerät). Bei Lüftungsgeräten, die mit 2 Lüftern ausgestattet sind und normalerweise Zuluft und Abluft gleichzeitig fördern, wird einer der Lüfter ausgeschaltet (Auswahl am Gerät).")]), _vm._v(" "), _c('h4', {
    ref: "heading_22",
    attrs: {
      "id": "heading_22"
    }
  }, [_vm._v("Entfeuchtung")]), _vm._v(" "), _c('p', [_vm._v("Die Lüftung entsorgt die überschüssige Feuchte aus den Räumen. Es sind aber Situationen möglich, bei denen die Luftqualität keine oder nur geringe Lüftung erfordert, aber die Feuchte eine intensivere Lüftung erforderlich macht. Der HAQCS-Monitor erhöht automatisch die Luftmenge, wenn die eingestellte Schwellenfeuchte überschritten wird. Dabei werden die Lüftungsgeräte davon informiert, dass sie in Entfeuchtungsmodus arbeiten, damit sie darauf reagieren können.")]), _vm._v(" "), _c('p', [_vm._v("Die Regelung erfolgt nach folgendem Algorithmus:")]), _vm._v(" "), _c('p', [_vm._v("Wird die eingestellte Schwelle für Feuchte „F“ erreicht, aktiviert sich automatisch der Entfeuchtungsmodus. Der Regler berechnet die passende Drehzahl anhand der relativen Feuchte. Ergibt sich dabei höhere Drehzahl, als aus der Qualitätsmessung, wird diese höhere Drehzahl an die Lüftungsgeräte übermittelt.")]), _vm._v(" "), _c('img', {
    staticClass: "no-shadow",
    attrs: {
      "src": __webpack_require__(46)
    }
  }), _vm._v(" "), _c('h4', {
    ref: "heading_23",
    attrs: {
      "id": "heading_23"
    }
  }, [_vm._v("Stromausfall")]), _vm._v(" "), _c('p', [_vm._v("Nach einer Änderung des Modus, wird die neue Einstellung nach 5 Minuten dauerhaft gespeichert. Wird die Stromzufuhr unterbrochen, startet der HAQCS-Monitor danach mit den gespeicherten Einstellungen und der Betriebsmodus bleibt erhalten.")])])], 1) : _vm._e(), _vm._v(" "), (_vm.language == 'pl') ? _c('div', [_c('v-container', {
    ref: "mainDoc",
    attrs: {
      "id": "mainDoc"
    }
  }, [_c('h1', [_vm._v("HAQCS — Hapla Air Quality Control System")]), _vm._v(" "), _c('h2', {
    ref: "heading_0",
    attrs: {
      "id": "heading_0"
    }
  }, [_vm._v("Zastosowanie")]), _vm._v(" "), _c('div', [_vm._v("Monitor systemu HAQCS (Hapla Air Quality Control System) określany dalej jako HAQCS-monitor spełnia dwie funkcje.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Jest monitorem jakości powietrza z możliwością alarmowania. Oprócz tego pokazuje klimat w pomieszczeniu na diagramie komfortu. Przy przekroczeniu wartości granicznych alarmuje i przypomina o potrzebie wietrzenia.")]), _vm._v(" "), _c('li', [_vm._v("W połączeniu z urządzeniami wpływającymi na jakość powietrza (wentylatory, rekuperatory, oczyszczacze powietrza), albo na klimat w pomieszczeniu (nawilżacze, klimatyzatory) steruje tymi urządzeniami odpowiednio do potrzeb.")])]), _vm._v(" "), _c('p', [_vm._v("HAQCS-monitor jest strażnikiem dobrych cech powietrza w mieszkaniu, miejscu pracy czy w szkole. Wszędzie tam, gdzie ludzie spędzają dużo czasu i przede wszystkim tam, dzie muszą oni się koncentrować. Dobra jakość powietrza jest tego warunkiem.")]), _vm._v(" "), _c('h2', {
    ref: "heading_1",
    attrs: {
      "id": "heading_1"
    }
  }, [_vm._v("Wybór miejsca")]), _vm._v(" "), _c('p', [_vm._v("Urządzenie jest przewidziane do montażu na ścianie. Oprócz tego może zostać postawione na biurku, komodzie, szafce nocnej. Nie powienien znajdować się w bezpośredniej styczności z ludźmi – lecz być w pewniej odległości. Miejsce to powinno mieć te same właściwości powietrza, jak reszta pomieszczenia (nie np. zaułek ze stającym powietrzem), ale też nie w przeciągu.")]), _vm._v(" "), _c('p', [_vm._v("Miejsce ustawienia nie powinno być narażone na bezpośrednie działanie słońca by nie zakłócić działania sensora CO"), _c('sub', [_vm._v("2")]), _vm._v(",  który działa na zasadzie optycznej.")]), _vm._v(" "), _c('p', [_vm._v("Zasilenie odbywa się za pomocą kabla z 5-Voltowego zasilacza USB. Od spodu i z boku są gniazda mikro-USB umożliwiające podłączenie od dołu przy montażu na ścianie i z boku przy ustawieniu na powierzchniach poziomych.")]), _vm._v(" "), _c('h2', {
    ref: "heading_2",
    attrs: {
      "id": "heading_2"
    }
  }, [_vm._v("Zastosowanie jako monitor jakości powietrza")]), _vm._v(" "), _c('div', {
    staticClass: "between-headings"
  }), _vm._v(" "), _c('h3', {
    ref: "heading_3",
    attrs: {
      "id": "heading_3"
    }
  }, [_vm._v("Wewnętrzne sensory")]), _vm._v(" "), _c('div', [_vm._v("HAQCS-monitor mierzy następujące parametry powietrza:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "narrow"
  }, [_vm._v("temperatuę")]), _vm._v(" "), _c('li', {
    staticClass: "narrow"
  }, [_vm._v("wilgotność względną")]), _vm._v(" "), _c('li', {
    staticClass: "narrow"
  }, [_vm._v("Poziom CO"), _c('sub', [_vm._v("2")])]), _vm._v(" "), _c('li', {
    staticClass: "narrow"
  }, [_vm._v("Poziom VOC jako ekwiwalent CO"), _c('sub', [_vm._v("2")])])]), _vm._v(" "), _c('p', [_vm._v("Dwie pierwsze wielkości mają wpływ na samopoczucie ludzi w pomieszczeniach. Zbyt niskia wilgotność może prowadzić do problemów zdrowotnych powodując wysychanie błon śluzowych, natomiast zbyt wysoka wilgotność jest niebezpieczna dla substancji budowlanej. Przy dużej wilgotności dochodzi do pojawiania się pleśni, co też jest niebezpieczne dla ludzi. Higieniści polecają by utrzymywać wilgotność względną na poziomie 40 – 60%.")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Poziom dwutlenku węgla CO"), _c('sub', [_vm._v("2")])]), _vm._v(" informuje o stopniu zużycia powietrza. W pomieszczeniach mieszkalnych, w biurach, klasach szkolnych, CO"), _c('sub', [_vm._v("2")]), _vm._v(" pochodzi z oddychania ludzi. Jego stężenie, które w świeżym powietrzu wynosi ca. 400 ppm rośnie w obecności ludzi. Stężenie 1500 ppm uznawane jest za górną granicę dla pracy umysłowej i nauce, ponieważ prowadzi do zakłóceń koncentracji. Przekroczenie drugiego progu 2500 ppm prowadzi przy dłuższej ekspozycji do bólu głowy i innych obciążeń zdrowotnych.")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("VOC lub TVOC – (Total) Volatile Organic Compounds")]), _vm._v(" jest ogólnym określeniem dla substancji organicznych w powietrzu. Powstają one częściowo jako emisję ludzkiego ciała, ale mogą mieć też inne źródło. Przykładami niech będą zapachy kuchenne, dym papierosowy, emisje mebli, farb i tworzyw sztucznych. ")]), _vm._v(" "), _c('h3', {
    ref: "heading_4",
    attrs: {
      "id": "heading_4"
    }
  }, [_vm._v("Średnia ważona CO"), _c('sub', [_vm._v("2")]), _vm._v(" i TVOC")]), _vm._v(" "), _c('p', [_vm._v("Wynik pomiaru jakości powietrza jast liczbą. Stężenie CO"), _c('sub', [_vm._v("2")]), _vm._v(" jest podawane w ppm ("), _c('b', [_vm._v("p")]), _vm._v("arts "), _c('b', [_vm._v("p")]), _vm._v("er "), _c('b', [_vm._v("m")]), _vm._v("illion). Wartość 400 ppm odpowiada czystemu, świeżemu powietrzu.")]), _vm._v(" "), _c('p', [_vm._v("Stężenie TVOC zostaje po pomiarze przeliczone na ekwiwalent CO"), _c('sub', [_vm._v("2")]), _vm._v(". HAQCS-monitor umożliwia ustawienie średniej ważonej tych dwu wielkości w zależności od własnych priorytetów. Pokazywana jest średnia ważona i jest ona podstawą sterowania i regulacji wentylacji. Możliwe są ustawienia od 100% CO"), _c('sub', [_vm._v("2")]), _vm._v(", 0% TVOC (czyli tylko CO"), _c('sub', [_vm._v("2")]), _vm._v(" jest brany pod uwagę) do 50% CO"), _c('sub', [_vm._v("2")]), _vm._v(", 50% TVOC. Stężenie CO"), _c('sub', [_vm._v("2")]), _vm._v(", jako ważniejsza wielkość jest brana pod uwagę w przynajmniej 50%.")]), _vm._v(" "), _c('p', [_vm._v("O ustawianiu średniej ważonej między CO"), _c('sub', [_vm._v("2")]), _vm._v(" i TVOC traktuje punkt "), _c('span', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#heading_11'),
      expression: "'#heading_11'"
    }],
    staticClass: "link"
  }, [_vm._v("Tryb działania (mode)")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    ref: "heading_5",
    attrs: {
      "id": "heading_5"
    }
  }, [_vm._v("Wyświetlacz")]), _vm._v(" "), _c('p', [_vm._v("Ekran dotykowy włącza się po naciśnięciu. Oprócz tego urządzenie dysponuje wyświetlaczem LED powyżej ekranu. Po 35 sekundach ekran się ściemnia a następnie wyłącza. ")]), _vm._v(" "), _c('p', [_vm._v("Jeśli chce się temu zapobiec można kliknąć na symbol lampki w górnym prawym rogu. Powtórne kliknięcie wyłącza ekran.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(17)
    }
  }), _vm._v(" "), _c('p', [_vm._v("Najpóźniej po 2 godzinach ekran się wyłącza też wtedy, gdy symbol jest aktywny.")]), _vm._v(" "), _c('h4', {
    ref: "heading_6",
    attrs: {
      "id": "heading_6"
    }
  }, [_vm._v("Aktualna jakość powietrza")]), _vm._v(" "), _c('p', [_vm._v("Po lewej stronie ekranu przedstawione są temperatura i wilgotność względna.")]), _vm._v(" "), _c('p', [_vm._v("Poniżej jakość powietrza jako liczba w ppm, przy czym jest to średnia ważona z pomiarów CO"), _c('sub', [_vm._v("2")]), _vm._v(" i TVOC z wagą ustaloną w ustawieniach (patrz punkt "), _c('span', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#heading_4'),
      expression: "'#heading_4'"
    }],
    staticClass: "link"
  }, [_vm._v("Średnia ważona CO"), _c('sub', [_vm._v("2")]), _vm._v(" i TVOC")]), _vm._v("). Na dole ekranu jest ta liczba w postaci znacznika na kolorowej skali. Oprócz tego, też przy wyłączonym ekranie, można jakość powietrza poznać po kolorze i pozycji światła na wyświetlaczu LED powyżej ekranu. Przedstawiona wartość jest średnią kroczącą z pomiarów ostatnich 2 minut.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(45)
    }
  }), _vm._v(" "), _c('h4', {
    ref: "heading_7",
    attrs: {
      "id": "heading_7"
    }
  }, [_vm._v("Aktualny klimat w opomieszczeniu")]), _vm._v(" "), _c('p', [_vm._v("Klikając na zakładkę „comfort“ wywołuje się diagram klimatu w pomieszczeniu, na którym przedstawione są aktualne wartości temperatury i wilgotności na tle diagramu samopoczucia. Żółte pole pokazuje obszar optymalnych parametrów dla ludzi. Niebieskie pole, to obszar akceptowalny. Poza nim większość ludzi skarży się na zbyt ekstremalny klimat.")]), _vm._v(" "), _c('h4', {
    ref: "heading_8",
    attrs: {
      "id": "heading_8"
    }
  }, [_vm._v("Historia")]), _vm._v(" "), _c('p', [_vm._v("Po kliknięciu na zakładkę „CO"), _c('sub', [_vm._v("2")]), _vm._v(" history“ ukazuje się przebieg parametrów powietrza w ostatnim czasie.")]), _vm._v(" "), _c('p', [_vm._v("„Short history“ pokazuje jako kolorowe pole przebieg stężenia CO"), _c('sub', [_vm._v("2")]), _vm._v(" w ciągu ostatnich 3 godzin w ppm. Czarna linia to TVOC jako ekwiwalent CO"), _c('sub', [_vm._v("2")]), _vm._v(". Po lewej stronie – aktualny pomiar. ")]), _vm._v(" "), _c('p', [_vm._v("„Long history“ pokazuje te same dane z ostatnich 12 godzin.")]), _vm._v(" "), _c('h3', {
    ref: "heading_9",
    attrs: {
      "id": "heading_9"
    }
  }, [_vm._v("Alarmy")]), _vm._v(" "), _c('p', [_vm._v("Dwa alarmy zwracają uwagę na złą jakość powietrza akustycznie i optycznie. Sygnał akustyczny jest wprawdzie głośny, ale trwa poniżej 1 sekundy i nie zakłóca lekcji czy narady.")]), _vm._v(" "), _c('p', [_vm._v("Alarmy następują przy 1500 ppm i 2500 ppm CO"), _c('sub', [_vm._v("2")]), _vm._v(". ")]), _vm._v(" "), _c('h3', {
    ref: "heading_10",
    attrs: {
      "id": "heading_10"
    }
  }, [_vm._v("Ustawienia")]), _vm._v(" "), _c('p', [_vm._v("By przejść do ustawień kliknij na symbol koła zębatego w lewym górnym rogu ekranu.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(17)
    }
  }), _vm._v(" "), _c('p', [_vm._v("Następujące tematy stoją do dyspozycji:")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(48)
    }
  }), _vm._v(" "), _c('h4', {
    ref: "heading_11",
    attrs: {
      "id": "heading_11"
    }
  }, [_vm._v("Tryb działania (mode)")]), _vm._v(" "), _c('p', [_vm._v("Tutaj można ustawić wagę między CO"), _c('sub', [_vm._v("2")]), _vm._v(" i TVOC. Wskazywana jakość powietrza, czy to jako liczba, czy za pomocą listwy LED bazuje na tym ustawieniu. Intensywność wentylacji jest też od tej wielkości zależna.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(47)
    }
  }), _vm._v(" "), _c('p', [_vm._v("Przesuń suwak w porządane miejsce. Całkiem z lewej strony tylko CO"), _c('sub', [_vm._v("2")]), _vm._v(" będzie brane pod uwagę. Skrajna prawa pozycja oznacza wagę 50:50. ")]), _vm._v(" "), _c('h4', {
    ref: "heading_12",
    attrs: {
      "id": "heading_12"
    }
  }, [_vm._v("Jasność (brightness)")]), _vm._v(" "), _c('p', [_vm._v("Tytaj można ustawić jasność listwy LED.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(44)
    }
  }), _vm._v(" "), _c('p', [_c('i', [_vm._v("„Enable CO"), _c('sub', [_vm._v("2")]), _vm._v(" indicator lights“")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\t\tUmożliwia wyłączenie listwy, jeśliby przeszkadzała.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("„LED strip brightness")]), _vm._v("“"), _c('br'), _vm._v("\n\t\t\t\t\t\t\tDopasowanie jasności LED. Umożliwia korektę automatycznie ustawionej jasności w zakresie 50% - 200%.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("„Adjust LED strip brightness automatically")]), _vm._v("“"), _c('br'), _vm._v("\n\t\t\t\t\t\t\tWłącza automatyczny dobór jasności do warunków otoczenia.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("„Disable CO"), _c('sub', [_vm._v("2")]), _vm._v(" indicator lights in the dark")]), _vm._v("“"), _c('br'), _vm._v("\n\t\t\t\t\t\t\tUmożliwia automatuczne wyłączanie listwy LED w ciemnym otoczeniu, np. w nocy, by nie przeszkadzała. \n\t\t\t\t\t\t")]), _vm._v(" "), _c('h4', {
    ref: "heading_13",
    attrs: {
      "id": "heading_13"
    }
  }, [_vm._v("Połączone urządzenia (devices)")]), _vm._v(" "), _c('p', [_vm._v("Tutaj następuje przyłączanie zewnętrznych urządzeń. Jeśli HAQCS-monitor jest używany tylko do pomiarów, to menu nie jest używane.")]), _vm._v(" "), _c('h2', {
    ref: "heading_14",
    attrs: {
      "id": "heading_14"
    }
  }, [_vm._v("Regulacja urządzeń wentylacyjnych")]), _vm._v(" "), _c('p', [_vm._v("Czytaj rozdział 4 by zapoznać się z urządzeniem. Przedstawione tam informacje mają zastosowanie także przy używaniu HAQCS-Monitora do sterowania i regulacji urządzeń wentylacyjnych. ")]), _vm._v(" "), _c('p', [_vm._v("HAQCS-monitor komunikuje się bezprzewodowo z urządzeniami wentylacyjnymi by je sterować. Sensory w jago wnętrzu umożliwiają regulację wentylacji odpowiednio do rzeczywistych aktualnych potrzeb. ")]), _vm._v(" "), _c('p', [_vm._v("Komunikacja opiera się na technologii WiFi, ale bez połączenia z internetem. HAQCS-monitor i przyłączone urządzenia tworzą izolowaną wyspę. Router nie jest potrzebny. Nie ma też dostępu z zewnątrz.")]), _vm._v(" "), _c('h3', {
    ref: "heading_15",
    attrs: {
      "id": "heading_15"
    }
  }, [_vm._v("Kompatybilne urządzenia")]), _vm._v(" "), _c('p', [_vm._v("Lista kompatybilnych urządzeń dostępna jest pod adresem:")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.hapla.eu/oferta",
      "target": "_blank"
    }
  }, [_vm._v("www.hapla.eu/oferta")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Też zwyczajne wentylatory na prąd przemienny 230 V, ewentualnie już zabudowane, można sterować za pomocą systemu HAQCS. W tym celu przyłącza się urządzenia HAQCS-Unibox do linii zasilającej dany wentylator. Unibox komunikuje się z HAQCS-Monitorem i jego sterownik mocy napędza odpowiednio wentylator regulując jego prędkość obrortową.")]), _vm._v(" "), _c('h3', {
    ref: "heading_16",
    attrs: {
      "id": "heading_16"
    }
  }, [_vm._v("Łączenie z urządzeniami")]), _vm._v(" "), _c('p', [_vm._v("HAQCS-monitor jest wyposażony w sensory, przy pomocy których mierzy jakość powietrza w obszarze, w którym został zamontowany. Powiniem więc sterować urządzeniami wentylacyjnymi w tym samym obszarze. Nie powinien sterować urządzeń w innych obszarach, bo nie dysponuje danymi pomiarowymi z innych miejsc. ")]), _vm._v(" "), _c('p', [_vm._v("Jeśli wentylacja danego domu ma być sterowana automatycznie w kilku obszarach, to w każdym z tych obszarów trzeba zamontować osobny HAQCS-monitor. ")]), _vm._v(" "), _c('p', [_vm._v("Pojedynczy HAQCS-monitor może jednak objąć regulacją duże pomieszczenia, jak np. sale restauracyjne czy biura wielkopowierzchniowe i sterować jednocześnie wieloma urządzeniami (do 16-tu). ")]), _vm._v(" "), _c('p', [_vm._v("Urządzenia, które mają być sterowane przez HAQCS-monitor muszą zostać z nim połączone. W celu połączenia należy: ")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Aktywować dane urządzenie wentylacyjne do połączenia. Proszę stosować się w tym celu do instrukcji danego urządzenia.")]), _vm._v(" "), _c('li', [_vm._v("Kliknąć symbol ustawień w górnym lewym rogu, a następnie wybrać „devices“")]), _vm._v(" "), _c('li', [_vm._v("Widać (pewnie jeszcze pustą) listę połączonych urządzeń. Żeby dodać urządzenie należy kliknąć na niebieski symbol „ + “.")]), _vm._v(" "), _c('li', [_vm._v("Pojawia się lista urządzeń, które są gotowe do połączenia. Wybierz to, które chcesz połączyć i kliknij „connect”. ")]), _vm._v(" "), _c('li', [_vm._v("Ewentualnie trzeba jeszcze podać hasło, by połączenie było możliwe.")])]), _vm._v(" "), _c('p', [_vm._v("W ten sposób należy połączyć wszystkie urządzenia, które HAQCS-monitor ma kontrolować.")]), _vm._v(" "), _c('p', [_vm._v("Można też usunąć urządzenia z listy. Kliknij na symbol ustawień danego urządzenia.")]), _vm._v(" "), _c('h3', {
    ref: "heading_17",
    attrs: {
      "id": "heading_17"
    }
  }, [_vm._v("Wybór trybu pracy")]), _vm._v(" "), _c('p', [_vm._v("Urządzenia wentylacyjne mogą pracować 3 trzech trybach automatycznych, mogą być sterowane ręcznie, w trybie nocnym być szczególnie ciche, albo w „storm mode“ intensywnie wietrzyć przez zadany czas. W trybie letnim wywołują pewien pasywny efekt chłodzenia. Specjalny tryb osuszania włącza się po przekroczeniu ustawionego progu wilgotności, by zapobiec powstawaniu pleśni.")]), _vm._v(" "), _c('p', [_vm._v("Tryb pracy ustawiany jest na listwie górnej wyświetlacza przez przewijanie za pomocą przyciskó ze strzałkami.")]), _vm._v(" "), _c('h4', {
    ref: "heading_18",
    attrs: {
      "id": "heading_18"
    }
  }, [_vm._v("Tryby automatyczne")]), _vm._v(" "), _c('p', [_vm._v("Są 3 tryby automatyczne. Regulacja prękości obrotowej wentylatorów jest w następujący sposób zależna od stężenia nieporządanych substancji w powietrzu:")]), _vm._v(" "), _c('img', {
    staticClass: "no-shadow",
    attrs: {
      "src": __webpack_require__(43)
    }
  }), _vm._v(" "), _c('p', [_vm._v("Przy dobrej jakości powietrza wentylatory pozostają wyłączone – wietrzenie nie jest potrzebne. Po przekroczeniu stężeń progowych C1, C2 albo C3, urządzenia wentylacyjne starują z minimalną prędkością obrotową. Następnie zależność intensywności wymiany powietrza od stężenia jest liniowa, aż do osiągnięcia maksymalnej wydajności.")]), _vm._v(" "), _c('p', [_vm._v("Tryb „AUTO (fresh)“ jest ustawiony na maksymalne wietrzenie, „AUTO (silent)“ na cichą pracę przy mniejszej ilości powietrza. „AUTO“ jest kompromisem między tymi dwoma trybami. Przy zadanym średnim stężeniu, odstęp strumienia powietrza między trybami wynosi 10%, czyli między „fresh“ a „silent“ 20%.")]), _vm._v(" "), _c('p', [_vm._v("Urządzenia, które nie umożliwiają bezstopniowej regulacji prędkości obrotowej wentylatora, przełączają ją skokowo i podążają za podaną charakterystyką w miarę ich możliwości.")]), _vm._v(" "), _c('h4', {
    ref: "heading_19",
    attrs: {
      "id": "heading_19"
    }
  }, [_vm._v("Sterowanie ręczne")]), _vm._v(" "), _c('p', [_vm._v("Sterowanie ręczne umożliwia sterowanie prędkości obrotowej wentylatorów w zakresie od 0% (minimalna prękość obrotowa danego modelu urządzenia wentylacyjnego) do 100% (maksimum prędości obrotowej) w krokach 10%. Sterowanie następuje za pomocą przycisków „ + “ i „ - “.")]), _vm._v(" "), _c('h4', {
    ref: "heading_20",
    attrs: {
      "id": "heading_20"
    }
  }, [_vm._v("Tryb nocny")]), _vm._v(" "), _c('p', [_vm._v("Tryb nocny wprowadzono by urządzenia pracowały najciszej. Pracują w sposób stały z najniższą prędkością obrotową, czyli bez regulacji. ")]), _vm._v(" "), _c('h4', {
    ref: "heading_21",
    attrs: {
      "id": "heading_21"
    }
  }, [_vm._v("Tryb wietrzenia (intensywny)")]), _vm._v(" "), _c('p', [_vm._v("Tryb „storm mode“ inicjuje intensywne wietrzenie pomieszczenia. Połączone urządzenia wentylacyjne działają przez zadany czas z maksymalną wydajnością, po czym wracają do poprzedniego trybu i wydajności. ")]), _vm._v(" "), _c('p', [_vm._v("Tryb jest polecany np. w czasie przerw w szkole albo w naradzie. Albo w domu wychodząc z domu, po gotowaniu itp.")]), _vm._v(" "), _c('h4', {
    ref: "heading_22",
    attrs: {
      "id": "heading_22"
    }
  }, [_vm._v("Tryb letni")]), _vm._v(" "), _c('p', [_vm._v("Tryb letni umożliwia wietrzenie bez odzysku ciepła, a nawet uzyskanie pewnego efektu pasywnego chłodzenia. Idea jest taka, by pobierać powietrze z chłodniejszej strony, np. zacienionej, północnej domu i oddawać je w innym kierunku. Stosuje się do tego 2 urządzenia, albo jedno w połączeniu z częściowio otwartym oknem.")]), _vm._v(" "), _c('p', {
    staticClass: "message"
  }, [_c('b', [_vm._v("UWAGA:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\t\tNie stosować w połączeniu z klimatyzacją. "), _c('br'), _vm._v("\n\t\t\t\t\t\t\tW tym przypadku odzysk zimna jest konieczny.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("Rekuperatory, które w innych trybach przełączają periodycznie kierunek tłoczenia powietrza, przacują w trzybie letnim tylko w jednym kierunku (ustawiamym w czasie instalacji w urządzeniach). W rekuperatorzch wyposażonych w dwa wentylatory, które jednocześnie tłoczą świeże powietrze i usuwają zużyte, jeden z tych wentylatorów zostaje wyłączony.")]), _vm._v(" "), _c('h4', {
    ref: "heading_23",
    attrs: {
      "id": "heading_23"
    }
  }, [_vm._v("Usuwanie wilgoci")]), _vm._v(" "), _c('p', [_vm._v("Wentylacja usuwa nadmierną wilgotność z pomieszczeń. Istnieją jednak sytuacje, kiedy jakość powietrza jest dobra i wentylacja nie byłaby potrzebna, ale wilgotność stwarza taką potrzebę. HAQCS-monitor zwiększa intensywność wentylacji, kiedy ustawiony przez użytkownika próg wilgotności zostanie przekroczony. Urządzenia wentylacyjne zostają o tym powiadomione i działąją w odpowiednim trybie.")]), _vm._v(" "), _c('p', [_vm._v("Regulacja następuje według poniższego algorytmu:")]), _vm._v(" "), _c('p', [_vm._v("Kiedy osiągnięty zostanie próg wilgotności „F“, aktywuje się tryb usuwania wilgoci. Regulator oblicza odpowiednią prędkość obrotową na podstawie aktualnej wilgotności. Jeśli obliczona prędkość obrotowa jest wyższa od tej wynikającej z pomiarów jakości powietrza, przekazuje do wentylatorów tę wyższą wartość.")]), _vm._v(" "), _c('img', {
    staticClass: "no-shadow",
    attrs: {
      "src": __webpack_require__(46)
    }
  }), _vm._v(" "), _c('h4', {
    ref: "heading_24",
    attrs: {
      "id": "heading_24"
    }
  }, [_vm._v("Przerwa w zasilaniu")]), _vm._v(" "), _c('p', [_vm._v("Po zmianie ustawień, zostają one po 5 min. zapisane w pamięci. W przypadku utraty i powrotu zasilania, HAQCS-monitor startuje z zapamiętanymi ustawieniami i tryb oracy zostaje odtworzony.")])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50vh"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 162:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('span', {
    attrs: {
      "id": "top"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "perspective": "100vmin",
      "width": "100vw",
      "height": "100vh",
      "overflow-x": "hidden",
      "overflow-y": "auto",
      "position": "fixed",
      "top": "0",
      "-webkit-overflow-scrolling": "touch"
    },
    attrs: {
      "id": "frame"
    }
  }, [_c('v-toolbar', {
    staticClass: "hidden-sm-and-down",
    staticStyle: {
      "backdrop-filter": "blur(12px)",
      "background-color": "rgba(255, 255, 255, 0.85)",
      "z-index": "1024",
      "position": "sticky",
      "top": "0",
      "margin-bottom": "-64px"
    },
    attrs: {
      "prominent": "",
      "flat": "",
      "fixed": ""
    }
  }, [_c('router-link', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "alt": _vm.logoAlt
    },
    on: {
      "click": _vm.scrollToTop
    }
  })]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.headerButtons), function(i) {
    return _c('v-flex', {
      key: i.path,
      on: {
        "click": _vm.scrollToTop
      }
    }, [(i.path !== undefined) ? _c('router-link', {
      attrs: {
        "to": i.path
      }
    }, [_c('v-card', {
      class: {
        transparent: true, 'header-bar-button': true, 'header-bar-button-active': _vm.selectedHeaderButton === i.text
      },
      staticStyle: {
        "padding": "8px"
      },
      attrs: {
        "flat": ""
      }
    }, [_c('span', [_vm._v(_vm._s(i.text))]), _vm._v(" "), _c('div', {
      class: _vm.colPrimary,
      style: ((_vm.selectedHeaderButton === i.text ? 'opacity: 1.0; transform: translateY(0px);' : 'opacity: 0.0; transform: translateY(5px);') + 'transition: all .3s ease; height: 3px;')
    })])], 1) : _vm._e()], 1)
  })), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.lng.shopLink,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticClass: "green--text",
    attrs: {
      "color": "green",
      "outline": "",
      "round": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lng.openShop))])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "16px"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "lang-button hidden-sm-and-down black--text",
    attrs: {
      "icon": "",
      "outline": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.focusLanguageSwitcher();
      }
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.language) + "\n\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-down",
    staticStyle: {
      "background": "linear-gradient(to bottom, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.0))",
      "position": "sticky",
      "top": "64px",
      "height": "6px",
      "margin-bottom": "-6px",
      "width": "100%",
      "z-index": "512"
    }
  }), _vm._v(" "), _c('div', {
    ref: "lang-switcher",
    staticClass: "lang-switcher-container top",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function () {
        _vm.blurLanguageSwitcher();
      }
    }
  }, [_c('div', {
    staticClass: "lang-switcher"
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _vm._l((_vm.languages), function(lang) {
    return _c('div', {
      key: lang.name
    }, [_c('div', {
      class: ['button-stripe', _vm.colPrimary, (lang.name === _vm.language) ? 'button-stripe-selected' : '']
    }), _vm._v(" "), _c('div', {
      class: ['button', 'noselect', (lang.name === _vm.language) ? 'button-selected' : ''],
      on: {
        "click": function () {
          _vm.setLanguage(lang.name, true);
          _vm.blurLanguageSwitcher();
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(lang.title) + "\n\t\t\t\t\t\t")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "bar"
  })], 2)]), _vm._v(" "), _c('v-toolbar', {
    staticClass: "hidden-xs-only",
    attrs: {
      "prominent": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('img', {
    staticClass: "hidden-md-and-up",
    attrs: {
      "src": _vm.logo,
      "alt": _vm.logoAlt
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.lng.shopLink,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticClass: "green--text",
    attrs: {
      "color": "green",
      "outline": "",
      "round": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lng.openShop))])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "16px"
    }
  }), _vm._v(" "), _c('div', [_c('v-menu', [_c('v-btn', {
    attrs: {
      "outline": "",
      "icon": ""
    },
    slot: "activator"
  }, [_vm._v(_vm._s(_vm.language))]), _vm._v(" "), _c('v-list', _vm._l((_vm.languages), function(lang) {
    return _c('span', {
      key: lang.name
    }, [(lang.name === _vm.language) ? _c('span', [_c('v-list-tile', {
      staticClass: "elevation-2",
      class: _vm.colPrimary,
      nativeOn: {
        "click": function($event) {
          _vm.setLanguage(lang.name, true)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(lang.title))])], 1)], 1) : _c('span', [_c('v-list-tile', {
      nativeOn: {
        "click": function($event) {
          _vm.setLanguage(lang.name, true)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(lang.title))])], 1)], 1)])
  }))], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "hidden-md-and-up hidden-xs-only pad-8",
    class: [_vm.colPrimary]
  }, [_c('v-spacer'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.headerButtons), function(i) {
    return _c('v-flex', {
      key: i.path,
      on: {
        "click": _vm.scrollToTop
      }
    }, [(i.path !== undefined) ? _c('router-link', {
      attrs: {
        "to": i.path
      }
    }, [(_vm.selectedHeaderButton === i.text) ? _c('v-btn', {
      attrs: {
        "block": ""
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(i.text) + "\n\t\t\t\t\t\t\t")]) : _c('v-btn', {
      attrs: {
        "flat": "",
        "block": ""
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(i.text) + "\n\t\t\t\t\t\t\t")])], 1) : _vm._e()], 1)
  })), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-up xs-toolbar-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-up xs-toolbar"
  }, [_c('div', {
    staticClass: "shadow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "8px",
      "z-index": "1025"
    }
  }, [_c('v-menu', [_c('v-btn', {
    staticStyle: {
      "text-shadow": "0 1px 2px rgba(0, 0, 0, 0.5)"
    },
    attrs: {
      "icon": "",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v(_vm._s(_vm.language))]), _vm._v(" "), _c('v-list', _vm._l((_vm.languages), function(lang) {
    return _c('span', {
      key: lang.name
    }, [(lang.name === _vm.language) ? _c('span', [_c('v-list-tile', {
      staticClass: "elevation-2",
      class: _vm.colPrimary,
      nativeOn: {
        "click": function($event) {
          _vm.setLanguage(lang.name, true)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(lang.title))])], 1)], 1) : _c('span', [_c('v-list-tile', {
      nativeOn: {
        "click": function($event) {
          _vm.setLanguage(lang.name, true)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(lang.title))])], 1)], 1)])
  }))], 1)], 1), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.siteName) + "\n\t\t\t\t")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('v-icon', {
    class: ['icon', 'icon-menu', _vm.drawer ? '' : 'icon-active']
  }, [_vm._v("menu")]), _vm._v(" "), _c('v-icon', {
    class: ['icon', 'icon-chev', _vm.drawer ? 'icon-active' : '']
  }, [_vm._v("chevron_left")])], 1)], 1), _vm._v(" "), _c('div', {
    class: ['hidden-sm-and-up', 'nav-drawer-container', _vm.drawer ? 'nav-drawer-container-open' : 'nav-drawer-container-closed']
  }, [_c('div', {
    staticClass: "bg",
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('div', {
    class: ['nav-drawer', _vm.drawer ? 'nav-drawer-open' : 'nav-drawer-closed']
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "24px"
    }
  }), _vm._v(" "), _vm._l((_vm.headerButtons), function(i) {
    return _c('div', {
      key: i.path,
      on: {
        "click": function () {
          _vm.scrollToTop();
          _vm.closeDelay(1);
        }
      }
    }, [(i.path !== undefined) ? _c('router-link', {
      attrs: {
        "to": i.path
      }
    }, [_c('div', {
      class: ['button', _vm.selectedHeaderButton === i.text ? 'button-selected' : '']
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(i.text))])])]) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "32px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "block",
      "padding": "0 64px"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.lng.shopLink,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "block": "",
      "color": "white",
      "outline": "",
      "round": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lng.openShop))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "shadow"
  })], 2)]), _vm._v(" "), (_vm.showCookie) ? _c('div', {
    staticClass: "elevation-4"
  }, [_c('v-toolbar', {
    staticClass: "warning",
    attrs: {
      "flat": "",
      "dense": ""
    }
  }, [_c('div', {
    staticClass: "long-text",
    staticStyle: {
      "opacity": "0.75"
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.lng.cookieMsg) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-sm-and-up"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.lng.cookieLink,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticClass: "hidden-xs-only",
    attrs: {
      "flat": "",
      "small": ""
    }
  }, [_c('div', {
    staticStyle: {
      "opacity": "0.65"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.lng.whatAreCookies) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("help")])], 1)], 1), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-xs-only"
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.disableCookieInfo()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pageName !== '') ? _c('div', [_c('v-toolbar', {
    class: [_vm.colAccent],
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.pageName) + "\n\t\t\t\t\t")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "language": _vm.language
    }
  }), _vm._v(" "), _c('footer', [(_vm.showFooter) ? _c('v-card', {
    class: [_vm.colSecondary],
    staticStyle: {
      "padding": "24px"
    },
    attrs: {
      "dark": "",
      "tile": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "hidden-sm-and-down"
  }, _vm._l((_vm.headerButtons), function(i) {
    return _c('div', {
      key: i.path
    }, [(i.path !== undefined) ? _c('router-link', {
      attrs: {
        "to": i.path
      }
    }, [_c('button', {
      staticClass: "white--text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(i.text) + "\n\t\t\t\t\t\t\t\t")])]) : _vm._e()], 1)
  })), _vm._v(" "), _c('v-flex', [_vm._v("\n\t\t\t\t\t\tHaplabit UG (haftungsbeschränkt)"), _c('br'), _vm._v("\n\t\t\t\t\t\tEchterstrasse 8a"), _c('br'), _vm._v("\n\t\t\t\t\t\tD-97209 Veitshoechheim"), _c('br'), _vm._v("\n\t\t\t\t\t\tDipl. – Ing. Harald Samoticha"), _c('br'), _vm._v("\n\t\t\t\t\t\t+49 1522 8619 710"), _c('br'), _vm._v("\n\t\t\t\t\t\tDE338177997"), _c('br')]), _vm._v(" "), _c('v-flex', [_vm._v("\n\t\t\t\t\t\t+49 1522 8619 710"), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": "mailto:info@hapla.eu"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tinfo@hapla.eu\n\t\t\t\t\t\t")]), _c('br')])], 1), _vm._v(" "), _c('div', [_c('v-menu', [_c('v-btn', {
    attrs: {
      "dark": "",
      "outline": ""
    },
    slot: "activator"
  }, [_vm._v(_vm._s(_vm.lng.language) + ": " + _vm._s(_vm.language))]), _vm._v(" "), _c('v-list', _vm._l((_vm.languages), function(lang) {
    return _c('span', {
      key: lang.name
    }, [(lang.name === _vm.language) ? _c('span', [_c('v-list-tile', {
      staticClass: "elevation-2",
      class: _vm.colPrimary,
      nativeOn: {
        "click": function($event) {
          _vm.setLanguage(lang.name, true)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(lang.title))])], 1)], 1) : _c('span', [_c('v-list-tile', {
      nativeOn: {
        "click": function($event) {
          _vm.setLanguage(lang.name, true)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(lang.title))])], 1)], 1)])
  }))], 1)], 1)], 1) : _vm._e()], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "max-width": "1024px"
    }
  }, [_c('v-card', {
    staticClass: "long-text grey--text text--darken-2"
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-bottom": "8px"
    }
  }, [_c('img', {
    staticClass: "center-img auto-downscale",
    attrs: {
      "src": __webpack_require__(137)
    }
  }), _c('br'), _vm._v(" "), (this.language === 'de') ? _c('div', [_c('span', {
    staticStyle: {
      "padding-right": "8px"
    }
  }, [_vm._v("Die Seite unter")]), _vm._v(" "), _c('span', {
    staticClass: "orange lighten-3 elevation-1"
  }, [_vm._v("\n                            " + _vm._s(_vm.$route.path) + "\n                        ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "8px"
    }
  }, [_vm._v("wurde nicht gefunden.")]), _vm._v(" "), _c('div', [_vm._v("\n                            Sie werden "), (_vm.redir > 0) ? _c('span', [_vm._v("in " + _vm._s(_vm.redir) + " Sekunde"), (_vm.redir > 1) ? _c('span', [_vm._v("n")]) : _vm._e()]) : _c('span', [_vm._v("jetzt")]), _vm._v(" auf die Homepage weitergeleitet.\n                        ")])]) : _vm._e()])]), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "warning": ""
    },
    model: {
      value: (_vm.prog),
      callback: function($$v) {
        _vm.prog = $$v
      },
      expression: "prog"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 164:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticStyle: {
      "max-width": "1024px"
    }
  }, [_c('v-card', {
    staticStyle: {
      "padding-left": "16px",
      "padding-right": "16px",
      "padding-top": "8px",
      "padding-bottom": "8px"
    }
  }, [_c('h1', [_vm._v(_vm._s(this.lng.title))]), _vm._v(" "), _c('p', [_vm._v("Haplabit UG (haftungsbeschränkt) built the HAQCS Remote app as a Free app. This SERVICE is provided by Haplabit UG (haftungsbeschränkt) at no cost and is intended for use as is.")]), _vm._v(" "), _c('p', [_vm._v("This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.")]), _vm._v(" "), _c('p', [_vm._v("If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Information Collection and Use")])]), _vm._v(" "), _c('p', [_vm._v("For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to Network SSID, Network password, Network IP addresses. The information that we request will be retained by us and used as described in this privacy policy.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Log Data")])]), _vm._v(" "), _c('p', [_vm._v("We want to inform you that whenever you use our Service, in a case of an error in the app we may collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Security")])]), _vm._v(" "), _c('p', [_vm._v("We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. Any and all data we collect, with the exception of Log Data, is stored locally in either your device’s local storage or in the flash memory of connected ventilation units. The data is not sent over the internet.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Changes to This Privacy Policy")])]), _vm._v(" "), _c('p', [_vm._v("We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page.")]), _vm._v(" "), _c('p', [_vm._v("This policy is effective as of 2024-03-01")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Contact Us")])]), _vm._v(" "), _c('p', [_vm._v("If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at info@hapla.eu.")])])], 1), _vm._v(" "), (!_vm.showSuccessAlert) ? _c('div', {
    staticClass: "spacing-128"
  }) : _vm._e(), _vm._v(" "), (_vm.showSuccessAlert) ? _c('div', {
    staticStyle: {
      "height": "1200px"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAeIAAAFBCAMAAACcv1zRAAAC+lBMVEX////V1dX+/f49Rsz19PS7u7tRWdHa3PVaWlrn5ubGxsaqrun9/P2iR6SgQ6H8/Pvf398br0c5Q8vJyckhsEvw+vNETc5HT85WxHb8/vz58vk4Qcq5dLrLzfLu3u/FjcaeP590zo/4+PjVq9WhRaIttVWtXq4ZrkX3+P29wO7U8Nyn4Lg4ODcesEhASc3l5eQWrUL29vassekksk4yMjL6+vr4/fmqV6vs7OyoUahubm5oaWlRUVK1bLYptFJ3d3ctLS3p6emkS6VeXl4yt1lLS0tIR0c8PDyOjY1AQEFzcnFkZGREREPX19cpKiv8+fz37vfZ2dlVXtM/vGNVVVX69fro0unAwMAmJiZ5f9zPz8/Ly8uJiYny8vzr2Oxyedqz5cKUlZXu7/rXsdm6ubmoqKhNTk7BxO+Wm+Pc3d3S0tK/f7+lTqacnJyZmZhnyoSAgIBfx357e3v6+/7h4/jx8fGfn59Fvmjo6fmMkeHDxMSyZ7OwYrGX26sgICDy8vLu7u6lpqY4uV7d3/f0+/bW2PTx4/HixeLdvd7at9taYtPC6s29vb2g3rKrq6ukpKNMwG716/XlzOaQluLY8uDO7tjI7NPRpNJOVtBKUs/IksnBhcKysrKK1qCRkZGGhoXs+fC4vOyjp+fe9OWcoeXh4eFqcdi2trbz8/PQ0/PHyfDi9ehka9ZfZtXm9+tuddjr4NG76MjEicR+0pduzIpSwnMYGBjz5/Pp+O2Aht7Ons/Kl8yvr6+E1JtUS0Pk5vi7ebzw8PC0t+uhoqJKWWry9vzS4emR2KV50JM/RE7p7fqs4rx7h5f48OY3QMq5ppGVhnj1/f+wtOuGjN+ktcqEk6Grlodmb4O50ODb29vf0MBwZmALCwuJmK+Ld2lsXE7Bx9eosLzUxrfIuam/sKKbk4vI2tqzvtNZSsCeqLSexrErHELi6e67v+0+YbY3PqhxdoBlYFswqFcjpVQbkD7Jz9ydodGeg6OCP4MLPhq9vs2TW7g3baGDro/Bd9ZUAAAbr0lEQVR42uydZ1CURxiAX75DBL3CHRcsZyyX07volSGAVCFUgcPKJViIeKIoSLFAVJQoEqOigohRVOwFS4zYG1bEgiVkElM0ibEmZhInZfIvP7IXE8UYZ76XjMPtus+MMzJz/555dr/v9mUBDofD4XA4HA6Hw+FwOBwOh8PhcDgcDofD4XA4HM6LgCAAh20yBgGHbVwygcM2Li7AYRuumHm4YubhipmHK2Yerph5uGLm4YqZhyvG0PyviAUQD1fs1FgK6gH8h1cNNwAMqkoeBTV37Wehw51vQTxcsROjuH28PxH6WYx7/NdwKyYq9vNZjVcbL8Et61kQD1fsxFyOW3vhLNTEfgofXci48TVcS7yZ8MXtnz0SbgICrtiJURiuEcV3QhugJrEo/h643iANN2bfvfQxIOCKnRqH4o/O1EPNcTv5n/b6VUtO0Z2Q2rs360E0XLFT81BxA1H8dvxZ8LlxFcASXJdQdP07EA1X7NRcSz8LtxLvwe0Lw49/CjXkn6Lx6i1rfeN9EA1X7MS4jv6m/6VvL984Yz9+SdF4wX79zI9wO6Sh5pdSXjEjXL6bkJBwHyx3E+6PAm1ZwtUfyUP27yDcSrlpANFwxXShyAcsXDGHK+a8QIqFyVJ44WFb8fbDFa+1dU5Ot5bCM+CKxbOtRKOSYDCbcR9/8EDSbHbmwTPgisU3XKJq54bi++8rMR//47ffHrg1k8oPuOL/zcslqhVti1uLp/ioLCutWPzHf/hVn3SPfL555PGF+v8yp0RjHmcA8Qhze8indwbR7E4yzR4Jzg+ziqemqiTTDIBgXoC8x1wQzdIp+rBeQAGsKp46VGKueAvVcIA8aD6IZmN7k+/q3kABjCqeOlQlqUA1/GYPeeTyAeIbbq+kxDCjih0NT8M0DJ376IKIYfENK8NWvwtUwKRi0rC5Ame4E67hidQ0zKZi0rAE1/CITvKs5VIQyyF6Vmk2FTcMlah2NQCC94hhRMPvHlMqc9cBLbCn2DCOGC7GNazDNPzSXl/TxB1ADcwpNmzyVm0pxu3DOtlRTMNqZe5GoAfWFBs2mZENl5/U6VaV4xr+ECiCMcXEsAbXcMeVMt148YZ771VTtUozp3iyY5VuDQjecBg+KN7wal99e7oMs6X4r1U6D93wQBBNr+7KpAVAFywpFja1U7ltQzV8NBLTMIyM1iftBspgSfF6s2rwq9iGV2EajlYmLQPaYEjx9hJNJc7w0Uj5SdYbZknxWDcNaRj5pDV9BIhFuBhN3z7MlOLtg69UjhUwO3dapHzGEhDNstn6aAobZkfx2MEqt58Aw/wAHcZwz/3KsMIOQCGMKN7udsUN1/D8oK4z3kQYXqz3LaTzenY2FJOGzaeRDcuxDZ+j5viQQcUvu2m8NxlwDcun4xqmdJVmRHHeLo0EN07raBhheKljH6a0YSYU5+1SeaMMA2k4YB6I5qVcvXqvAmiFfsUnUslIfD1y2DIrbQCIZd15ckBM1fEhY4rzUrENv0mGLV8RxDfcTa2m2TD1ivPQDXee3jXoFcQYz3mTaR/NhmlXTBqW4Boe0UeehWh43XlfU+4hoAtB4cDfgUC74hOpEtXQBqRhTMNwXm2ib5X2WBvyF1ZrSCblig3TNKrUE9iG08Q33KFXmH7KUqANjwlWYtdBsAvdiuvHeatS83CGdZFHEA0vilZOofFwSeGvUAgM7MWGCrME13B5H7muy0BUw4vpGwF4iGBp04oQSLNiwzizBtfwwC4vwpDH39T29TMajX0LKFaMb3jgHp0M1XB3JbUNg0+MbeGw4cOG5dOrGN9wxy4y+Z6BmDEeZRi1hsE1vYjyvdhAnrRKWuMalskwhpdNUUYvAkoh78RrQzyk5N1YSq3i02bN4LGohvfodBjD75ObPBbRevTgMclmiz+Q6E4YTqli4VUyircd+6Q1HmN4san7IloPiCEwLjgh/CG0vhevr0QaHkAM9xmBaphiww/fi6n+jnqsG3KVFtKyyJAHquEwmg070A6vLR0zZoyFSsXohqWvBMkxDe9or/eldoznH8r8/N55fUh/LxoVv+qmwjUMabhBrXXd1KZ9LwHdaEPD24SWVduG0adYWO+m8kYZHoBs+NA+tbobPTd5PIP80NGu1oUQnE2f4jnE8KbJz7PhfSYT/YZBarVrw4OrY4uoU1y8ReO9wYBpmBie8cI1TKhN8fGKHWKj7nGr9RbSsBTZcBBm2JIVw6DNF4SM5AwFZYqLieEN2JstA+ZLQSxCoVq5n7J7Hp5B3RpPAJ84yk6aWjsMo/bhJdPJ7bQCiKX3InK49D6wgGA7EFurnWkro0pxMxqeIQ9IA0TDYawYBmnUpAl+IW1sVD1ukSctCXJg2tGwFNFwmJ4Vw6Bwz4bRNr8DNCmeuksjGTrqOTbcoZCZVZogxFU7jiNiF9Kj+K1pEsnQqc+xYRhJhi2ZMQzgowAA6Ux/ahQ3x7BOdgTEs4CMAFwEdpAOe9tOGESL4remmVU4w+Wdusq6dEQMeSRRPOTxX9S9bowltKJEMb7h8lUy2cqOmIb13S/Sec/Ds44hrIMiCFo6FOMbPjheh2p4QZI+moo/yCMaRVQORSMB9cQwciR+lY40jBvF60X7AXFTv4EWjzXpBR6bN292pUGxoUKi2TkH2/DKN0A0Paco1UztwxEhxr5+Xw3pS6imQfHpFdhRvFUyzEg8HMo1qc/TPgLwBFurcnKy33ZQl+F8iqX//vl0O9XObciG5eMRq/SOiUr1Xkr+5BIKQeqce7Hw74bJoNbLgOCNLjLUkMeHpOFuTDX8kFPZ6e79ZpU5/Xmx4GgYZXjA8khdp84Yw0rfvQwahmyjtW9BvvsYJ1F8yhXA3yVD+rThyiuDt+EGtbLkfTCGmduHH7002T2iFkJCipMoXhMcobAbjXbtU09aqhLcOO3yLNRIfO9japr+qBYC/6gx+VHJ0pA4J1GcGR81Or0s2zhh5pPDlis07dbjGo6UY1bp3ud89e3pu+dBFCkxZel2u9FpvsDMjBli9YFWxkk+8JhtJZp2G6SohoNwDZ8LU+7vCWwSEe534B2/FB9nUQxfxhs9AZLjU7SPx2k/0KxoOxnZcB9cw0pWGwYI3OxVW5WpdZKXJsXoUu2gdHcLgFetfxPD3m0xDQtkJD5gLsJwYZie2YZBEexU31GXphdpwRIaOgig+Q3DkgB5j3kgnkKySjPbMAjBIaecR7Grux08CiyeoVFbmxpuhzQ8o2vAPAFEsztaP5vG+5bEUjbEmp2Tk+Mcv1+sCI4JjzHG9rPU+jxhWEAZJgPTmIZ3kxGAkcAwcUZjPKGq5RVLM5I9PSeFlA6zpTRdpVWSCgPOMK7hBbOVs5k2DFsDCRERTvBEPTomMXGMViBbcRn8w6hUjerwKNwqjW1Yz3bDoOhXVVeV6e8Ee7HFluNpjfWA5PSEWY8Mf2KWoA3j9mHSMEujeE9zKo78+viQ/uGbW16xV6ylTWipf75LVRPDKrxh2XIQT88kfdhIlga1nsb+zqSCTK9sY3BLL9ReZS4xwbYiyAyPgMeGJUjDBzvJI48ihjw2TlT7HqP1viVxzEqcoABCtdGrxRRrq5MB8q0hrnVfReUHhoT7PDJ8WCL5BGX4vZPyyCMIwzvaK31XszgC0IR+fb3AQWBoWYspLoitglnhfq3ANcXPlu7u2WScFvmkVT6ejNNiDOeaTMcYNwxeiRngwMe6psUU/8nemQZVVcZx+O+5Bkh34RyvIl4xxIuXjAuDV1kKEVCSTCTBciVIc0eIcM0tQcUVcUnFBcV9AVFxxRRTzF2TSm3RamrarLEap+VDM70XkbJy8mfAi/e8zxfHGWXGeeZ5z8Hz49zBXXtGDs/fF0OkbRyzIPIvDStJtdrw+mZyuKM3zBS3z88ZzBjbld/DxI29XDqP1ea3z/nb2FIxwUMt3SGk4XTZ8RsmGt41on0lETncFNO8fVNcyZDa/riBqslYx2Y8M7CGddCdVpM9VusexzdMBrcGsbE9GcM57qhdn412CWCO/ebRHaR27qZCrOGjev1IwHDQapucvp5UBi/F3g1jw1zcqMO8nlSFtl0em8SDHyMOTfGmrw6Xm6nOMDfFDLchf318KLFTuhAyHFcaZT46EzB82GhVX8NcFdMHLq8YqhuuQBuOW5aibwEYDlJnw/wUS8SIdKMqMh51Z4bxhqHrsDXdMd639JAo1t4tvMLdlFcATuL1R4HrMJ31sSQ47IynXiq+G894U94xCbnTAhuWkjPlhF2kSuqFYjanXd5Owk5p/USk4eRMS6ZKDdcLxVuLWMNa8C3xbbKF4YdG8dYiJa+CEGa1MTPD0Cl923AHiaY69mPEeqnY3nBFBgFkB3u1yUaGWl2qhlqGAccfYUMIlcFd8YM0jJ3SS+wf9UCVxEzpE+NNKoO34q1zFP8NeMPIjIc9PjwZRJW4Tvk4VUsqg7PiM8Um/wmJkGE2mM4m6AGx7Y5hGrFgTY9REhkce7hVrxSPP6hBDQezsSXasIHsGEbkxJIhps+ogJgGpCK4KsaHWi+0YWPLOKDhvWzkUdXwvK5T/FZJ3vlT2nePJRXBU/H4vhrNhBME0LKjOQUxvDaNjTw8qJKQzgN6dooYK0mbB6gqYp6KB9oNY0OtFthQa3oJe/Swo+of+uwzPWnLKxHTxPfFdcaZg8xwItRwC3NUaRxi2GhN2063cYve9xpRwzXtXyaVwU0xO6VNfUHD+pRlyFDr1J8NGwJp+JDuI4i2TBtBKoOXYmmxRikEp3hm6JQOKrFVjzxcn3RZEBgb3V1dF2G+in3X+SubRoMN60rjkIbZKX2AKukd3anTlDXsrGYLcvXBSTE81Np/1Gw++hzdP/Nt8ri2tKV/IFHgU2uocddUothXVfXdEk/FrGHTpixsbGk2j1wIXAee8LGMW0rUz29NIL0V9lLjsFRycyXV/eclL8XadWwwjc1pD2EjDzrbxZIwl4g65PfINxg6+Q2JMWg7vUKqhIPijHVNlU3OmGGdbuR+yLA8jhl2GxtpSI0Y4B3r12NeZH606u6leSnOYA3HZ4EN6xHD0p2GH3m6H1FqnwFS/+iI7kMeIXVS94rbNVWcCkDDupHIKZ3cRWaGGYEb+48awzqO8W6UM1iNN9N8FG+LNy1/HHmY1/yQDrrTojfsH8hDt3ktotsYGtuH3XOpl7pWvG2OsvwY1jD2Zktqyx4uTfYgO5GNaHDEqw1Zx9NIvdStYtbwBafvJQJordNPWoQ0nMsMB5Gdeb1e6iCtiuj2umGzSu+0OCjexgbTBdhQi73ZEjHcNtdyp2G3sPypRPRmj25bSM3UqWLPeGV5gQQanpSNNGw/pasnAP3dUrvleOd0DiA1U5eKWcPuWMOzWcMv0P2zY6/FdtKj+vGh3zPRYT1601RVTbV4KraPLYdl1GbDa09Z5T1NqAppxKhVIQHdj5PKqTvFZcXMMDLjkeyGFxHyJg+jcc+Bu77EmJeie5LKqTPFZX3Rt9Myw8Fow3cbppBXo1eR2qkrxWVJGv/F6Jw2tDUyxWtlM6bdbZi8+w1X5cMlDopZwxf8h0ENv9hRn9JaAk7pVlZjqwMk4KS4jI0tsYZbMsPInNZjsk3OFYa5KS5LMvkvBhv2CkUa9pgfbs19gwScFNvHlsUDsaEW2PDtkYeAk2LfCRpN8WisYehOizXsI48TDXNT7LvB31ScBV6Hdcsk0fDDoth3WFNwTjuzo1m3EhhbSvPZBEA0zEsxa1ijJEGGm+/20q1cSMh7Hhz941rqtWLfDWjDzVdEgSOPXNlnvup+Fq3eKPYd5o82/JgOOqVpKZvxzCcBJ8WsYVP8DKxhnR4znMsMB5GAk+IKd8VpKNzwQqhhWTTMUfFQJ1P8UAlsGDLcdpwcLhrmp3hovAltOMo8ERlMH0izGEs8SMBHMWv4QjxkmAbp9BOhGc8eq/HUWhLwUcwavoA1LM1mI48XkYaZ4VbCMC/FrGEFbTgUbtjaqgkJOCl+3MnUtIAAtLNDvSDDB9KMomGOimfY32wZB71hmp3SiGGPEjbUEoa5Kc7apDTd4AsZDtV3RAwHTQ6Xc5eQgJPi0UkKONSaHWxOySYAZliMPPgpdi5mDWcQwKJQffAgCWrYslc0zE3x6GLlAcaWg7RIwz6iYY6Ks+CGX5ioDx1E94+BndJ71fmRS/VC8ehN4A89MMNeoVDDu9gEQMx4uCkuS1I0fcejUzzkOkxLE6xdniABJ8WJ72qYYfSUno0YnpsgZjyoYp4jD9awWVeqhRqWRcP8FCcu1ih9B2JjS73useai4b9RbxVnLPbXYA0/t1un2/0cOPIQDXNTnDhMo2DX4YW7zVjD25tZbKvFyIOXYt/F7DpcBjW8Emx4e5rVWDKdBHwUszstU5EzZNjeMGjYViIeEHNT/Cib03qCDWOn9I50i2iYo+KC5cqcbeCdlnmlaPhfqZeKC9gUzxM0jL3Zskkam+IJw7wUs4ZNWMNUGmXuiEzxgk7aLM12kICTYmYYa1jLRh6g4XBZPCDmpliyNwwZllrDho1yM2GYm2Jm2P17rOEUuGGLMMxPsaeTyX1dBmLY3nBLxPBqm1UY5qfYmY0tIcNSa7BhOhtuSRCGuSl2LnyAhoMXEUBygpwpHi5xU8wMN12nJYBsZng2AezKtAjD/BRnFbJTGhxqMcPQUCtBFg+I+Sm2n9KPQg0vmqQPnkXQFE80zFGx8yaNMiwDHmppsZGHT7L4GXFeiscXmjQHB9Zqw0tyZZt4kwc3xYkT7EMt+DosIQ+X0mXbavHogZfixHf9NQfHYw1j7xCnJelWMeOpWcUdDHd+Cdko/efYUlEOnkHHliuep/tnPWv4sJgA1KTi8x+Vv01EHx45l3HxnO9/ndL+GnCKN1IXtaI5ZNhqOywarlHFO/16XCMyvBNRfmJnP+mtwJCNGfc2DDbMDHvpDiEN72gmG4XhmlZ85KnyE7Tzx27ll754v8PlHz6KPnfpng0rSQMJYD8bakENB5VY5XTxUQ81rvibI1fp8pXL5ZcuX/G9fvrTz5+5eq+3xCtFM7CG9VGHEMPTD9vk9O0kqGnFV69fOf/Jexftir2vn6PzR96jf0GqcDfN2Yo1bMbutKavZobXk6DmFX94Oqb8TJXi9++hWGqXpxR5Yg2zSTzWsDBcO4q7X/X4ZN81qlQ8/Z4VH8u7ULQVe0u8Xt9iJjK2FIZrS/GPV+ni6bfpiyuXLp7zfuca+y7qK/oHiUngKR1XmmJu0ZIAJrOhljBcG4oNAd7UsJGWGn5HYyKlkNfJo1Eg/QPP5XnY22mXRekhw1JypiVhLglqjNgGBNFO4+SMNLwiytxiPwEkZ8rC8P9lTECjaiJ7945sBBD5882vP428/z/eIMUreFYk8PW//OnWT99W/SYghAQPxIJeLn8SHe0CcfrGjTDgj4fduPG0C8KQ337z6+xym14DSPBAuL3mWk3jaQsauwI0vnbz5mfA39j866+/QF//21u3fq/++g1I8P+JjSWICk18FvJ8aVLUIEJY0sV2lgQ1SYPavd1q2UbXmhDa+hjFyzyEYoFQLBCKVYVQ7PAIxQ6PUOzwCMUOj1Ds8AjFDo9Q7PAIxQ6PUOzwCMUOj1Ds8AjFDo9Q7PAIxQ6PUOzwCMUOj1D8B3t0q4IwFIYBeJypySMbE0UQ/ClimROTF2EW3AUsGEwimOxmwxDjySavxBuwKSZBMGgxCMvnw6WX97mFBx6L4bEYHovhsRgei+GxGB6L4bEYHovhsRgei+GxGB6L4U1YDE5dX32J5OymiVJlS7/ihj1nx+L/DY2XGVxKYU0kdG+ffcvafKyb947AYlQ9HbbGs2U2BSRdJw/LWZCJ38e6UKorbQGtH89Iwvd70WodB7amRSBf9u5dVW04gOP4zxBBxfIPhEIpLYXMgRCIEGJKtMHExBgQLAnRpTQKWk5JhePgYHTpJPYBeqhT0Reo01mkr9Cl0NcoXZve6GUxll5S6GcI+of/3+FrLmRIwhF+vbevbp7o/oMb6d2+c+Xdo2snenHKGwOo3wz4tPlJJ07Gb/CcwYmou9dTu/v41tPHV0+WpXdCcCIAkcPPi2UKf9MPf5x/bv3frTztA+2qhzQ4gfthoMgBzcIC/2UXURpYdA0BaeTUHL7TUceA90TEvyIeMSISuyLBb1IpI0Fxmdn3iTIkGj8GOPbJpQDIgRwOGCC3DfM5gFkvXwNyTw7XDOTmvsmKwrgzGHG9waCNxb19Px/mOxTIeDl4DdC9urfM7pM9y6uuaeosMNYLxXQz6p0iAYjQWSCVzkavDuLyTNPtANlAlMZZLQS4Dd+1jB48vtuQjCKaprVvoWR0VcfDii80JKfImm+kqjzlDWkwdQoO3wmsN5Jl+TqNKa86Zoi2qQ55foyMCv2qt7L75bXBSwxSqEcmb2p1RuFr1gWF40q8EdnWy+e60ud5AZlA7Pm8D+DCv6SERhfhXlv03HvguJX7JB7ahCjDSrifJIMPkfe9Cu696ctirwPB3KDkbzlRM+hkBjm0zLi91wXG1JBNoqoeAE4mW+9hLU3iil07Y9c6W5psV4ZZT/MLxnOgnaOZMi73HjKB2K6ki6A05wA8rMmhFGA3nAAVvUvn/OrLqe7W824O5+oEM7cHPOMFALI34G0E/gyIDPqh9BzY+rl2LUS5qhNkUuAP8NlZqsTefABA5AgBlvN2ign+BT6jmm5GzlhEUVd+P+lSqABLVwilHOikJs6S1uy8oSjVJhfWRth1k8S1D4ktGVhb3cJcQ8/9mDjuWwtg5vfa0gqUoleQSVt/dlri6Jtj7TNJwFHTWgcftZ8p0j1kA1GGaM5DRGYdyUYM+U+JO2YTaLtLfLCtvUacJC59SRxbCqFVG8GnxPS01gZeukK7luXEoe+dlrjaiPFZ0ZkQHHXvy7KBXZBaRWQCUQzQLel1yZ0ES6mJrZQkHmqw5y9D9tBy8sFFHlu3g3NVQ9uP2MozUwbd0MfTuYJRTWPpyNm95lvshWUj5+ZBVQsZTRzMp18TP0+T2DjHJ7TSEHDcwGfxRSBFyITyvQkwKkyxblhO8xxsi4E4OYNmGY4SC4pjqAOwugA6GeT6fEu+VM6B/HCoVB+Ca/K68MSm4amWMymCafVAPdtk9Fy8GzpF4DAiHxKnKbapjfARiawAKYz9DQUQEQmiZuWahN4BiGNQi1GdAOS8DOxE0AtZTj5yArMoo3Iog0oGk68yxZ1TABYMzdEAKdYpMaaAmClWAHKofFwxo2au09+oEZk1u/vJ5Q7H9OYRh0pQ5PqSh1SieZ/Na8ugX+pM3TP896eVWbtb2DC4bCWaCxxDNvNCVHVK6zeSNtHSVJYjnuf1cU41LXMT478/jxI5CihXCKkQHMddKLqd51ZKoppHCmW5I3CAyOTqGTlM/3cERTJzr/m/9+3BIQEAAACAoP+vfWECAAAAAAAAAAAAAAAAAAAAgFsF+Ttcbz1lNQAAAABJRU5ErkJggg=="

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(217);
module.exports = __webpack_require__(85);


/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/brightness.c8fbdec.png";

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/comfort_screen_monitor_mode.a20a3ba.png";

/***/ }),

/***/ 46:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/settings.90ec343.png";

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Ambientika+HAQCS.1b09c89.png";

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/HW_app_moni.75c048d.jpg";

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Unibox.0b323d5.png";

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/haqcs.6bb48c5.png";

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/marley-MEnV-HAQCS-edition.e3bf397.png";

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/upgrade-marley-MEnV180.185aefd.jpg";

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/upgrade-prana150-200.fb12966.jpg";

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_meta__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_analytics__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_analytics__);

__WEBPACK_IMPORTED_MODULE_0_es6_promise___default.a.polyfill();












var VueScrollTo = __webpack_require__(169);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_meta___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_analytics___default.a, {
	id: 'UA-108901537-1'
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(VueScrollTo, {
	container: "#frame",

	duration: 500,
	easing: "ease",
	offset: -32,
	force: true,
	cancelable: true,
	onStart: false,
	onDone: false,
	onCancel: false,
	x: true,
	y: true
});
var store = new __WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* default */].Store({
	state: {
		language: 'en',
		count: 1
	},
	mutations: {
		increment: function increment(state) {
			return state.count++;
		},
		decrement: function decrement(state) {
			return state.count--;
		}
	}
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

var app = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
	computed: {
		language: function language() {
			return store.state.language;
		}
	},
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

document.addEventListener('DOMContentLoaded', function () {
	app.$mount('#app');
});

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_404__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dokumentation__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dokumentation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Dokumentation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Dokumentation_Dokumentation_HAQCS__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Dokumentation_Dokumentation_HAQCS___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Dokumentation_Dokumentation_HAQCS__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Angebot__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Angebot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Angebot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Kontakt__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Kontakt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Kontakt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PrivacyPolicy__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PrivacyPolicy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_PrivacyPolicy__);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: 'history',
	routes: [{
		path: '/dokumentation',
		name: 'de Dokumentation',
		component: __WEBPACK_IMPORTED_MODULE_4__components_Dokumentation___default.a,
		meta: { lng: 'de', name: 'Dokumentation', lngPath: { de: '/dokumentation', en: '/docs', pl: '/dokumentacja' } }
	}, {
		path: '/dokumentation/haqcs',
		name: 'de Dokumentation_HAQCS',
		component: __WEBPACK_IMPORTED_MODULE_5__components_Dokumentation_Dokumentation_HAQCS___default.a,
		meta: { lng: 'de', name: 'Dokumentation', lngPath: { de: '/dokumentation/haqcs', en: '/docs/haqcs', pl: '/dokumentacja/haqcs' } }
	}, {
		path: '/angebot/',
		name: 'de Angebot',
		component: __WEBPACK_IMPORTED_MODULE_6__components_Angebot___default.a,
		meta: { lng: 'de', name: 'Angebot', lngPath: { de: '/angebot', en: '/offer', pl: '/oferta' } }
	}, {
		path: '/angebot/:viewedDevice',
		name: 'de Angebot (viewedDevice)',
		component: __WEBPACK_IMPORTED_MODULE_6__components_Angebot___default.a,
		meta: { lng: 'de', name: 'Angebot', lngPath: { de: '/angebot/:viewedDevice', en: '/offer/:viewedDevice', pl: '/oferta/:viewedDevice' } }
	}, {
		path: '/Kontakt',
		name: 'de Kontakt',
		component: __WEBPACK_IMPORTED_MODULE_7__components_Kontakt___default.a,
		meta: { lng: 'de', name: 'Kontakt', lngPath: { de: '/kontakt', en: '/contact', pl: '/kontakt_pl' } }
	}, {
		path: '/docs',
		name: 'en Dokumentation',
		component: __WEBPACK_IMPORTED_MODULE_4__components_Dokumentation___default.a,
		meta: { lng: 'en', name: 'Documentation', lngPath: { de: '/dokumentation', en: '/docs', pl: '/dokumentacja' } }
	}, {
		path: '/docs/haqcs',
		name: 'en Dokumentation_HAQCS',
		component: __WEBPACK_IMPORTED_MODULE_5__components_Dokumentation_Dokumentation_HAQCS___default.a,
		meta: { lng: 'en', name: 'Documentation', lngPath: { de: '/dokumentation/haqcs', en: '/docs/haqcs', pl: '/dokumentacja/haqcs' } }
	}, {
		path: '/offer/',
		name: 'en Angebot',
		component: __WEBPACK_IMPORTED_MODULE_6__components_Angebot___default.a,
		meta: { lng: 'en', name: 'Offer', lngPath: { de: '/angebot', en: '/offer', pl: '/oferta' } }
	}, {
		path: '/offer/:viewedDevice',
		name: 'en Angebot (viewedDevice)',
		component: __WEBPACK_IMPORTED_MODULE_6__components_Angebot___default.a,
		meta: { lng: 'en', name: 'Offer', lngPath: { de: '/angebot/:viewedDevice', en: '/offer/:viewedDevice', pl: '/oferta/:viewedDevice' } }
	}, {
		path: '/Contact',
		name: 'en Kontakt',
		component: __WEBPACK_IMPORTED_MODULE_7__components_Kontakt___default.a,
		meta: { lng: 'en', name: 'Contact', lngPath: { de: '/kontakt', en: '/contact', pl: '/kontakt_pl' } }
	}, {
		path: '/Privacy-Policy',
		name: 'Privacy Policy',
		component: __WEBPACK_IMPORTED_MODULE_8__components_PrivacyPolicy___default.a,
		meta: { lng: 'en', name: 'Privacy Policy', lngPath: { de: '/privacy-policy', en: '/privacy-policy', pl: '/privacy-policy' } }
	}, {
		path: '/dokumentacja',
		name: 'pl Dokumentation',
		component: __WEBPACK_IMPORTED_MODULE_4__components_Dokumentation___default.a,
		meta: { lng: 'pl', name: 'Dokumentacja', lngPath: { de: '/dokumentation', en: '/docs', pl: '/dokumentacja' } }
	}, {
		path: '/dokumentacja/haqcs',
		name: 'pl Dokumentation_HAQCS',
		component: __WEBPACK_IMPORTED_MODULE_5__components_Dokumentation_Dokumentation_HAQCS___default.a,
		meta: { lng: 'pl', name: 'Dokumentacja', lngPath: { de: '/dokumentation/haqcs', en: '/docs/haqcs', pl: '/dokumentacja/haqcs' } }
	}, {
		path: '/oferta/',
		name: 'pl Angebot',
		component: __WEBPACK_IMPORTED_MODULE_6__components_Angebot___default.a,
		meta: { lng: 'pl', name: 'Oferta', lngPath: { de: '/angebot', en: '/offer', pl: '/oferta' } }
	}, {
		path: '/oferta/:viewedDevice',
		name: 'pl Angebot (viewedDevice)',
		component: __WEBPACK_IMPORTED_MODULE_6__components_Angebot___default.a,
		meta: { lng: 'pl', name: 'Oferta', lngPath: { de: '/angebot/:viewedDevice', en: '/offer/:viewedDevice', pl: '/oferta/:viewedDevice' } }
	}, {
		path: '/kontakt_pl',
		name: 'pl Kontakt',
		component: __WEBPACK_IMPORTED_MODULE_7__components_Kontakt___default.a,
		meta: { lng: 'pl', name: 'Kontakt', lngPath: { de: '/kontakt', en: '/contact', pl: '/kontakt_pl' } }
	}, {
		path: '/',
		name: 'Home',
		component: __WEBPACK_IMPORTED_MODULE_3__components_Home___default.a,
		meta: { name: 'Home' }
	}, {
		path: '/:page',
		name: '',
		component: __WEBPACK_IMPORTED_MODULE_2__components_404___default.a,
		meta: { col: 2, noFooter: true }
	}, {
		path: '/:page/:a',
		name: '',
		component: __WEBPACK_IMPORTED_MODULE_2__components_404___default.a,
		meta: { col: 2, noFooter: true }
	}, {
		path: '/:page/:a/:b',
		name: '',
		component: __WEBPACK_IMPORTED_MODULE_2__components_404___default.a,
		meta: { col: 2, noFooter: true }
	}]
}));

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(134)
__webpack_require__(133)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(162),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    var _this = this;

    this.$ga.page(this.$route.path);

    if (this.$cookie.get('cookieInfo') === null) {
      setTimeout(function () {
        _this.showCookie = true;
      }, 10);
    }

    this.update();
    this.updateLng();

    setTimeout(function () {
      _this.checkScroll();
    }, 50);
  },
  updated: function updated() {
    var _this2 = this;

    var path = this.$route.path;
    if (this.path !== path) {
      this.$ga.page(path);

      this.path = path;
      setTimeout(function () {
        _this2.update();
      }, 50);
      window.scrollTo(0, 0);
    }
  },
  data: function data() {
    return {
      path: '',
      pageName: 'no-name',
      colPrimary: 'primary',
      colAccent: 'accent',
      colSecondary: 'secondary',
      headerButtons: [],
      selectedHeaderButton: '',
      showFooter: true,
      siteName: 'Hapla',
      logo: '/static/img/logo/haplabit_header.png',
      logoAlt: 'Hapla',
      showCookie: false,
      drawer: false,
      closeDelay: function closeDelay(delay) {
        var _this3 = this;

        setTimeout(function () {
          _this3.drawer = false;
        }, delay);
      },
      getMeta: function getMeta(tag, val) {
        return this.$route.meta[tag];
      },
      update: function update() {
        var lng = this.getMeta('lng');
        if (lng === undefined) {
          lng = this.language;
        }
        this.setLanguage(lng, false);

        switch (this.getMeta('head')) {
          default:
            this.headerButtons = [];
            this.$set(this.headerButtons, 0, { text: 'Home', path: '/' });
            this.$set(this.headerButtons, 1, { text: this.lng.header_offer, path: this.lng.header_offer_path });
            this.$set(this.headerButtons, 2, { text: this.lng.header_docs, path: this.lng.header_docs_path });
            this.$set(this.headerButtons, 3, { text: this.lng.header_contact, path: this.lng.header_contact_path });
            break;
        }

        var i = 0;
        while (i < this.headerButtons.length) {
          var path = this.headerButtons[i].path;
          if (path === "/") {
            if (path === this.$route.path) {
              this.selectedHeaderButton = this.headerButtons[i].text;
              break;
            }
          } else if (this.$route.path.indexOf(path) === 0) {
            this.selectedHeaderButton = this.headerButtons[i].text;
            break;
          }

          i++;
        }

        this.pageName = this.$route.meta.name;

        switch (this.getMeta('col')) {
          default:
            this.colPrimary = 'primary';
            this.colAccent = 'accent';
            this.colSecondary = 'secondary';
            break;
          case 1:
            this.colPrimary = 'primary-one';
            this.colAccent = 'accent-one';
            this.colSecondary = 'secondary-one';
            break;
          case 2:
            this.colPrimary = 'primary-two';
            this.colAccent = 'accent-two';
            this.colSecondary = 'secondary-two';
            break;
          case 3:
            this.colPrimary = 'primary-three';
            this.colAccent = 'accent-three';
            this.colSecondary = 'secondary-three';
            break;
        }

        this.showFooter = this.getMeta('noFooter') !== true;

        switch (this.getMeta('site')) {
          default:
            this.siteName = 'Hapla';
            this.logo = '/static/img/logo/haplabit_header.png';
            this.logoAlt = 'Hapla';
            break;
        }
      },
      disableCookieInfo: function disableCookieInfo() {
        this.$cookie.set('cookieInfo', '1337', { expires: '1Y' });
        this.showCookie = false;
      },

      scrollToTop: function scrollToTop() {
        document.getElementById('frame').scrollTop = 0;
      },
      isAtTop: true,
      checkScroll: function checkScroll() {
        var _this4 = this;

        setTimeout(function () {
          _this4.checkScroll();
        }, 500);

        this.isAtTop = window.scrollY <= 512;
      },

      focusLanguageSwitcher: function focusLanguageSwitcher() {
        var el = this.$refs['lang-switcher'];
        el.focus();
      },
      blurLanguageSwitcher: function blurLanguageSwitcher() {
        var el = this.$refs['lang-switcher'];
        el.blur();
      },

      language: 'de',
      setLanguage: function setLanguage(lang, performUpdate) {
        this.language = lang;
        this.updateLng();
        if (performUpdate) {
          this.update();
        }
      },
      languages: [{ name: 'en', title: 'English' }, { name: 'de', title: 'Deutsch' }, { name: 'pl', title: 'Polski' }],
      replaceParams: function replaceParams(input) {
        var _this5 = this;

        var matches = /\/:[^/]+/g.exec(input);

        if (matches === null) return input;

        matches.forEach(function (element) {
          var param = element.substr(2, element.length - 2);
          input = input.replace(element, '/' + _this5.$route.params[param]);
        });

        return input;
      },
      updateLng: function updateLng() {
        this.lng = this.messages[this.language];

        if (this.$route.meta.lngPath !== undefined) {
          var path = this.$route.meta.lngPath[this.language];

          path = this.replaceParams(path);

          if (this.$route.path !== path) {
            this.$router.push(path);
          }
        }
      },
      lng: {},
      messages: {
        en: {
          language: 'Language',

          header_contact: 'Contact',
          header_contact_path: '/contact',
          header_docs: 'Documentation',
          header_docs_path: '/docs',
          header_offer: 'Offer',
          header_offer_path: '/offer',

          cookieMsg: 'We use Cookies.',
          whatAreCookies: 'What are Cookies?',
          cookieLink: 'https://en.wikipedia.org/wiki/HTTP_cookie',

          openShop: 'Open shop',
          shopLink: 'https://www.haplabit.shop/'
        },
        de: {
          language: 'Sprache',

          header_contact: 'Kontakt',
          header_contact_path: '/kontakt',
          header_docs: 'Dokumentation',
          header_docs_path: '/dokumentation',
          header_offer: 'Angebot',
          header_offer_path: '/angebot',

          cookieMsg: 'Diese Seite verwendet Cookies.',
          whatAreCookies: 'Was sind Cookies?',
          cookieLink: 'https://support.mozilla.org/de/kb/cookies-informationen-websites-auf-ihrem-computer',

          openShop: 'Shop öffnen',
          shopLink: 'https://www.haplabit.shop/'
        },
        pl: {
          language: 'język',

          header_contact: 'kontakt',
          header_contact_path: '/kontakt_pl',
          header_docs: 'dokumentacja',
          header_docs_path: '/dokumentacja',
          header_offer: 'oferta',
          header_offer_path: '/oferta',

          cookieMsg: 'Ta strona używa plików cookie.',
          whatAreCookies: 'Co to są pliki cookie?',
          cookieLink: 'https://support.mozilla.org/de/kb/cookies-informationen-websites-auf-ihrem-computer',

          openShop: 'do sklepu',
          shopLink: 'https://www.haplabit.shop/'
        }
      }
    };
  }
});

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Unknown',
    created: function created() {
        var _this = this;

        var path = this.$route.path;

        setTimeout(function () {
            _this.countdown();
        }, 1000);
    },
    data: function data() {
        return {
            redir: 3,
            prog: 0,
            countdown: function countdown() {
                var _this2 = this;

                this.redir -= 1;
                this.prog = 100 - this.redir / 3 * 100;

                if (this.redir === 0) {
                    setTimeout(function () {
                        _this2.$router.push('/');
                    }, 1000);
                } else {
                    setTimeout(function () {
                        _this2.countdown();
                    }, 1000);
                }
            }
        };
    },

    props: ['language']
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Angebot',
	created: function created() {
		this.updateLng();
	},
	mounted: function mounted() {
		var _this = this;

		this.unwatchLanguage = this.$watch('language', function () {
			_this.updateLng();_this.updateViewedDevice();
		});
		this.unwatchViewedDevice = this.$watch('$route.params.viewedDevice', this.updateViewedDevice);
		this.updateViewedDevice();
	},
	beforeDestroy: function beforeDestroy() {
		this.unwatchLanguage();
		this.unwatchViewedDevice();
	},
	data: function data() {
		return {
			deviceList: {
				en: {
					"HAQCS-Monitor": { title: "HAQCS-Monitor", id: 0xa778 },
					"Ambientika-AUTO": { title: "Ambientika AUTO", id: 0x1bcf },
					"HRU-WALL-WI": { title: "HRU-WALL-WI", id: 0x0f43 },
					"Marley-MEnV-HAQCS-Edition": { title: "Marley MEnV HAQCS Edition", id: 0x7b90 },
					"Upgrade-Marley-MEnV-180": { title: "Upgrade for Marley MEnV 180", id: 0x217d },
					"Upgrade-Prana-150-200": { title: "Upgrade for Prana 150 / 200", id: 0xacdc },
					"HAQCS-Unibox": { title: "HAQCS-Unibox", id: 0x75ab }
				},
				de: {
					"HAQCS-Monitor": { title: "HAQCS-Monitor", id: 0xa778 },
					"Ambientika-AUTO": { title: "Ambientika AUTO", id: 0x1bcf },
					"HRU-WALL-WI": { title: "HRU-WALL-WI", id: 0x0f43 },
					"Marley-MEnV-HAQCS-Edition": { title: "Marley MEnV HAQCS Edition", id: 0x7b90 },
					"Upgrade-Marley-MEnV-180": { title: "Upgrade für Marley MEnV 180 auf HAQCS", id: 0x217d },
					"Upgrade-Prana-150-200": { title: "Upgrade für Prana 150 / 200", id: 0xacdc },
					"HAQCS-Unibox": { title: "HAQCS-Unibox", id: 0x75ab }
				},
				pl: {
					"HAQCS-Monitor": { title: "HAQCS-Monitor", id: 0xa778 },
					"Ambientika-AUTO": { title: "Ambientika AUTO", id: 0x1bcf },
					"HRU-WALL-WI": { title: "HRU-WALL-WI", id: 0x0f43 },
					"Marley-MEnV-Edycja-HAQCS": { title: "Marley MEnV Edycja HAQCS", id: 0x7b90 },
					"Ulepszenie-Marley-MEnV-180": { title: "Ulepszenie dla Marley MEnV 180", id: 0x217d },
					"Ulepszenie-Prana-150-200": { title: "Ulepszenie dla Prana 150 / 200", id: 0xacdc },
					"HAQCS-Unibox": { title: "HAQCS-Unibox", id: 0x75ab }
				}
			},
			idList: {},
			buildIdList: function buildIdList(lang) {
				if (this.idList.hasOwnProperty(lang)) {
					return;
				}

				var idList = {};
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.deviceList[lang])), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var _ref = _step.value;

						var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

						var path = _ref2[0];
						var deviceInfo = _ref2[1];

						idList[deviceInfo.id] = path;
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				this.idList[lang] = idList;
			},
			getPathFromId: function getPathFromId(id, lang) {
				this.buildIdList(lang);
				return this.idList[lang][id];
			},
			viewedDevice: { param: '', title: '', id: 0 },
			isAlreadyViewingDevice: function isAlreadyViewingDevice() {
				return this.viewedDevice.id !== 0 && this.$route.params.viewedDevice !== undefined;
			},
			updateViewedDevice: function updateViewedDevice() {
				if (this.isAlreadyViewingDevice()) {
					var id = this.viewedDevice.id;
					var path = this.lng.listPath + '/' + this.getPathFromId(id, this.language);
					this.$router.replace(path);
				}

				var viewedDevice = this.$route.params.viewedDevice;
				if (this.deviceList[this.language].hasOwnProperty(viewedDevice)) {
					var deviceInfo = this.deviceList[this.language][viewedDevice];
					this.viewedDevice = { param: viewedDevice, title: deviceInfo.title, id: deviceInfo.id };
				} else {
					this.viewedDevice = { param: '', title: this.lng.title, id: 0 };
				}
			},
			scrollTo: function scrollTo(element) {
				var options = {
					container: '#frame',
					easing: 'ease',
					offset: -64,
					force: true,
					cancelable: false,
					onStart: false,
					onDone: false,
					onCancel: false,
					x: true,
					y: true
				};

				var duration = 700;

				this.$scrollTo(element, duration, options);
			},
			scrollToTop: function scrollToTop() {
				document.getElementById('frame').scrollTop = 0;
			},

			updateLng: function updateLng() {
				this.lng = this.messages[this.language];
			},
			lng: {},
			messages: {
				en: {
					listPath: '/offer',
					title: 'Our Offer',
					description: {
						"": "The offer of the company Haplabit.",
						"HAQCS-Monitor": 'Air quality monitor and controller for decentralized ventilation and humidification.',
						"Marley-MEnV-HAQCS-Edition": 'Successor to the popular Marley MEnV 180 model. The HAQCS edition has HAQCS compatibility.',
						"Upgrade-Marley-MEnV-180": 'Set of control boards for the popular ventilation units with heat recovery Marley MEnV 180. After replacing the boards, the devices become HAQCS-compatible and can be controlled automatically and automatically by the HAQCS-Monitor.',
						"Upgrade-Prana-150-200": 'Control board for the decentralized ventilation units with heat recovery Prana 150, 200C, 200G. After replacing the board, the devices become HAQCS-compatible and can be controlled automatically and automatically by the HAQCS-Monitor.',
						"HAQCS-Unibox": 'Power controller for simple exhaust fans for 230 V, which do not have their own regulation and control. The power supply to the fan is looped through the Unibox.'
					},
					back: 'back'
				},
				de: {
					listPath: '/angebot',
					title: 'Unser Angebot',
					description: {
						"": "Das Angebot der Firma Haplabit.",
						"HAQCS-Monitor": 'Luftqualitäts-Monitor und intelligente Lüftungssteuerung in einem Gerät. Seine Sensoren erfassen CO2, VOC und Klimawerte. Er zeigt die Luftqualität an, alarmiert und regelt bedarfsgerecht die dezentrale Lüftung.',
						"Marley-MEnV-HAQCS-Edition": 'Nachfolger des populären Modells Marley MEnV 180. Die HAQCS-Edition verfügt über HAQCS-kompatibilität.',
						"Upgrade-Marley-MEnV-180": 'Satz Steuerplatinen für die populären Lüftungsgeräte mit Wärmerückgewinnung Marley MEnV 180. Nach Austausch der Platinen werden die Geräte HAQCS-kompatibel und lassen sich bedarfsgerecht und automatisch von HAQCS-Monitor regeln.',
						"Upgrade-Prana-150-200": 'Steuerplatine für die dezentralen Lüftungsgeräte mit Wärmerückgewinnung Prana 150, 200C, 200G. Nach Austausch der Platine werden die Geräte HAQCS-kompatibel und lassen sich bedarfsgerecht und automatisch von HAQCS-Monitor regeln.',
						"HAQCS-Unibox": 'Leistungsregler für einfache Abluftventilatoren für 230 V, die keine eigene Regelung und Steuerung besitzen. Die Stromversorgung zum Ventilator wird durch die Unibox durchgeschleift.'
					},
					back: 'zurück'
				},
				pl: {
					listPath: '/oferta',
					title: 'Nasza oferta',
					description: {
						"": "Oferta firmy Haplabit.",
						"HAQCS-Monitor": 'Monitor jekości powietrza i automatyczny sterownik wentylacji i nawilżania.',
						"Marley-MEnV-Edycja-HAQCS": 'Następca popularnego modelu Marley MEnV 180. Urządzenie jest kompatybilne z HAQCS.',
						"Ulepszenie-Marley-MEnV-180": 'Zestaw płytek sterownika do popularnych urządzeń wentylacyjnych z odzyskiem ciepła Marley MEnV 180. Po wymianie płytek urządzenia stają się kompatybilne z HAQCS i mogą być sterowane automatycznie przez HAQCS-Monitor odpowiednio do rzeczywistych potrzeb.',
						"Ulepszenie-Prana-150-200": 'Centrala sterująca do zdecentralizowanych urządzeń wentylacyjnych z odzyskiem ciepła Prana 150, 200C, 200G. Po wymianie płytki urządzenia stają się kompatybilne z HAQCS i mogą być kontrolowane automatycznie w zależności od potrzeb przez HAQCS-Monitor.',
						"HAQCS-Unibox": 'Regulator wydajności dla prostych wentylatorów wyciągowych na 230 V, które nie mają własnej regulacji i sterowania. Unibox jest wpinany w przewód zasilający wentylatora.'
					},
					back: 'powrót'
				}
			},

			getMetaDescription: function getMetaDescription() {
				if (this.lng.description === undefined) {
					this.updateLng();
				}

				return this.lng.description[this.viewedDevice.param];
			}
		};
	},

	props: ['language'],
	metaInfo: function metaInfo() {
		return {
			title: this.lng.title,

			titleTemplate: '%s | Haplabit',
			htmlAttrs: {
				lang: this.language
			},
			meta: [{ name: 'description', content: this.getMetaDescription() }, { name: 'theme-color', content: '#00c853' }]
		};
	}
});

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Dokumentation',
	mounted: function mounted() {
		var _this = this;

		this.unwatchLanguage = this.$watch('language', function () {
			_this.updateLng();
		});
	},
	beforeDestroy: function beforeDestroy() {
		this.unwatchLanguage();
	},
	data: function data() {
		return {
			headings: [],

			scrollTo: function scrollTo(element) {
				var options = {
					container: '#frame',
					easing: 'ease',
					offset: -64,
					force: true,
					cancelable: false,
					onStart: false,
					onDone: false,
					onCancel: false,
					x: true,
					y: true
				};

				var duration = 700;

				this.$scrollTo(element, duration, options);
			},

			updateLng: function updateLng() {
				this.lng = this.messages[this.language];
			},
			updateLngLastLng: '',
			lng: {},
			messages: {
				en: {
					title: 'Documentation',
					description: 'Documentation of the HAQCS-Monitor, a digital device that measures the air quality and indoor climate of a room and optionally controls up to 16 ventilation units and humidifiers over an ad-hoc wireless network.',
					articlesHeading: 'Articles',
					manualsHeading: 'Manuals'
				},
				de: {
					title: 'Dokumentation',
					description: 'Dokumentation des HAQCS-Monitors, eines digitalen Geräts, das die Luftqualität und das Raumklima eines Raums misst und optional bis zu 16 Lüftungsgeräte und Luftbefeuchter über ein drahtloses Ad-hoc-Netzwerk steuert.',
					articlesHeading: 'Artikel',
					manualsHeading: 'Anleitungen'
				},
				pl: {
					title: 'Dokumentacja',
					description: 'Dokumentacja monitora HAQCS, cyfrowego urządzenia, które mierzy jakość powietrza i klimat wewnętrzny w pomieszczeniu i opcjonalnie kontroluje do 16 jednostek wentylacyjnych i nawilżaczy za pośrednictwem bezprzewodowej sieci ad-hoc.',
					articlesHeading: 'Artykuły',
					manualsHeading: 'Instrukcje'
				}
			},
			getTitle: function getTitle() {
				if (this.lng.title === undefined) {
					this.updateLng();
				}

				return this.lng.title;
			},
			getMetaDescription: function getMetaDescription() {
				if (this.lng.description === undefined) {
					this.updateLng();
				}

				return this.lng.description;
			}
		};
	},

	props: ['language'],
	metaInfo: function metaInfo() {
		return {
			title: this.getTitle(),

			titleTemplate: '%s | Haplabit',
			htmlAttrs: {
				lang: this.language
			},
			meta: [{ name: 'description', content: this.getMetaDescription() }, { name: 'theme-color', content: '#00c853' }]
		};
	}
});

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Dokumentation_HAQCS',
	mounted: function mounted() {
		var _this = this;

		this.updateHeadings();
		this.updateViewedHeading();
		this.viewedHeadingInterval = setInterval(function () {
			_this.updateViewedHeading();
		}, 50);

		setTimeout(function () {
			_this.scrollToRoutedHeading();
		}, 400);

		this.unwatchLanguage = this.$watch('language', function () {
			_this.updateHeadings();_this.updateLng();
		});
	},
	beforeDestroy: function beforeDestroy() {
		clearInterval(this.viewedHeadingInterval);
		this.unwatchLanguage();
	},
	data: function data() {
		return {
			headings: [],

			updateHeadings: function updateHeadings() {
				if (this.headings.length != 0) {
					this.headings = [];
				}

				var currentIndex = 0;
				var reference = "heading_0";
				while (this.$refs[reference] != undefined) {
					var element = {};
					element.text = this.$refs[reference].innerText;
					element.id = reference;
					element.nodeName = this.$refs[reference].nodeName;

					this.headings.push(element);

					currentIndex += 1;
					reference = "heading_" + String(currentIndex);
				}


				this.headingsLng = this.language;
			},
			viewedHeading: "heading_0",
			viewedHeadingInterval: -1,
			updateViewedHeading: function updateViewedHeading() {

				if (typeof this.updateViewedHeading.lastFromTop == 'undefined') {
					this.updateViewedHeading.lastFromTop = fromTop;
				}

				var fromTop = document.getElementById('frame').scrollTop;

				if (fromTop == this.updateViewedHeading.lastFromTop) {
					return;
				}
				this.updateHeadings.lastReference = fromTop;

				this.viewedHeading = "heading_0";

				var currentIndex = 0;
				var reference = "heading_0";
				var lastReference = "heading_0";
				while (this.$refs[reference] != undefined) {
					var pos = this.$refs[reference].offsetTop;

					if (pos > fromTop + 64) {
						this.viewedHeading = lastReference;
						return;
					}

					lastReference = reference;
					currentIndex += 1;
					reference = "heading_" + String(currentIndex);
				}

				this.viewedHeading = lastReference;
			},
			routedHeadings: {
				"Aufstellung": "heading_1",
				"Raumklima": "heading_7",
				"Geschichte": "heading_8",

				"Alarme": "heading_9",
				"Moduswahl": "heading_16",
				"Sturmmodus": "heading_20",
				"Entfeuchtung": "heading_22"
			},
			scrollToRoutedHeading: function scrollToRoutedHeading() {
				if (this.routedHeadings.hasOwnProperty(this.$route.params.heading)) {
					this.scrollTo('#' + this.routedHeadings[this.$route.params.heading]);
				}
			},
			scrollTo: function scrollTo(element) {
				var options = {
					container: '#frame',
					easing: 'ease',
					offset: -64,
					force: true,
					cancelable: false,
					onStart: false,
					onDone: false,
					onCancel: false,
					x: true,
					y: true
				};

				var duration = 700;

				this.$scrollTo(element, duration, options);
			},

			updateLng: function updateLng() {
				this.lng = this.messages[this.language];
			},
			updateLngLastLng: '',
			lng: {},
			messages: {
				en: {
					title: 'Documentation',
					description: 'Documentation of the HAQCS-Monitor, a digital device that measures the air quality and indoor climate of a room and optionally controls up to 16 ventilation units and humidifiers over an ad-hoc wireless network.',
					back: 'back',
					backRoute: '/docs'
				},
				de: {
					title: 'Dokumentation',
					description: 'Dokumentation des HAQCS-Monitors, eines digitalen Geräts, das die Luftqualität und das Raumklima eines Raums misst und optional bis zu 16 Lüftungsgeräte und Luftbefeuchter über ein drahtloses Ad-hoc-Netzwerk steuert.',
					back: 'zurück',
					backRoute: '/dokumentation'
				},
				pl: {
					title: 'Dokumentacja',
					description: 'Dokumentacja monitora HAQCS, cyfrowego urządzenia, które mierzy jakość powietrza i klimat wewnętrzny w pomieszczeniu i opcjonalnie kontroluje do 16 jednostek wentylacyjnych i nawilżaczy za pośrednictwem bezprzewodowej sieci ad-hoc.',
					back: 'powrót',
					backRoute: '/dokumentacja'
				}
			},
			getTitle: function getTitle() {
				if (this.lng.title === undefined) {
					this.updateLng();
				}

				return this.lng.title;
			},
			getMetaDescription: function getMetaDescription() {
				if (this.lng.description === undefined) {
					this.updateLng();
				}

				return this.lng.description;
			}
		};
	},

	props: ['language'],
	metaInfo: function metaInfo() {
		return {
			title: this.getTitle(),

			titleTemplate: '%s | Haplabit',
			htmlAttrs: {
				lang: this.language
			},
			meta: [{ name: 'description', content: this.getMetaDescription() }, { name: 'theme-color', content: '#00c853' }]
		};
	}
});

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Home',
	created: function created() {
		this.updateLng();
	},
	mounted: function mounted() {
		var _this = this;

		this.unwatchLanguage = this.$watch('language', this.updateLng);

		this.checkScrollPositionInterval = setInterval(function () {
			_this.checkScrollPosition();
		}, 20);
		this.handleScrollBound = this.handleScroll.bind(this);
		document.getElementById('frame').addEventListener('scroll', this.handleScrollBound);
	},
	beforeDestroy: function beforeDestroy() {
		clearInterval(this.checkScrollPositionInterval);
		document.getElementById('frame').removeEventListener('scroll', this.handleScrollBound);

		this.unwatchLanguage();
	},
	data: function data() {
		return {
			showBothModes: false,

			selectedColor: 0,
			colors: [[0, "rgb(195, 0, 0)", "rgb(123, 0, 0)"], [1, "rgb(0, 176, 0)", "rgb(0, 92, 0)"], [2, "rgb(128, 128, 128)", "rgb(64, 64, 64)"]],

			viewedHaqcsDisplay: 'comfort',
			viewedHaqcsColor: 'red',

			viewedSlide: 0,
			headerBarStickingMonitor: false,
			headerBarStickingController: false,
			haqcsOffset: 0,

			checkScrollPositionInterval: -1,
			checkScrollPosition: function checkScrollPosition() {
				if (typeof this.checkScrollPosition.lastFromTop == 'undefined') {
					this.checkScrollPosition.lastFromTop = fromTop;
				}

				var fromTop = document.getElementById('frame').scrollTop;

				if (fromTop == this.checkScrollPosition.lastFromTop) {
					return;
				}
				this.checkScrollPosition.lastReference = fromTop;

				var vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
				var vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

				this.checkViewedSlide(fromTop, vh, vw);
				this.setViewedHAQCS();
				this.checkHeaderBarSticking(fromTop, vh);
				this.checkShowBothMods(fromTop, vh);
			},
			checkViewedSlide: function checkViewedSlide(fromTop, vh, vw) {
				var prev = 0;
				for (var i = 0; i < 4; ++i) {
					var referenceString = 'slide_' + String(i);
					var ref = this.$refs[referenceString];

					if (ref.offsetTop > fromTop + 0.5 * ref.clientHeight) {
						this.viewedSlide = prev;
						return;
					}
					prev = i;
				}
			},
			setViewedHAQCS: function setViewedHAQCS() {
				this.viewedHaqcsDisplay = this.viewedSlide == 2 ? 'comfort' : 'history';
				this.viewedHaqcsColor = this.selectedColor == 0 ? 'red' : this.selectedColor == 1 ? 'green' : 'gray';
			},
			checkHeaderBarSticking: function checkHeaderBarSticking(fromTop, vh) {
				{
					var ref = this.$refs["haqcs-as-a-monitor"];
					if (ref.offsetParent == null) return;

					var pos = ref.offsetTop;
					this.headerBarStickingMonitor = pos < fromTop;
				}

				{
					var _ref = this.$refs["haqcs-as-a-controller"];
					if (_ref.offsetParent == null) return;

					var _pos = _ref.offsetTop;
					this.headerBarStickingController = _pos < fromTop;
				}
			},
			checkShowBothMods: function checkShowBothMods(fromTop, vh) {
				{
					var ref = this.$refs["haqcs-is"];
					if (ref.offsetParent == null) return;

					var pos = ref.offsetTop;
					this.showBothModes = pos < fromTop;
				}
			},
			map: function map(x, in_min, in_max, out_min, out_max) {
				return (x - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
			},
			handleScroll: function handleScroll() {
				var fromTop = document.getElementById('frame').scrollTop;

				if (typeof this.handleScrollBound.lastFromTop == 'undefined') {
					this.handleScrollBound.lastFromTop = fromTop;
				}

				var vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

				var force = Math.abs(this.handleScrollBound.lastFromTop - fromTop) > vh;

				var ref = this.$refs["haqcs-as-a-monitor"];
				if (ref.offsetParent == null) return;
				var pos = ref.offsetTop;
				if (Math.abs(pos - fromTop) > vh && !force) {
					this.handleScrollBound.lastFromTop = fromTop;
					return;
				}

				var posStart = fromTop - 0.1 * vh;
				var posEnd = fromTop + 0.5 * vh;
				this.haqcsOffset = Math.max(0, this.map(pos, posStart, posEnd, 0, 20));

				this.handleScrollBound.lastFromTop = fromTop;
			},
			handleScrollBound: null,

			scrollToTop: function scrollToTop() {
				document.getElementById('frame').scrollTop = 0;
			},

			updateLng: function updateLng() {
				this.lng = this.messages[this.language];
			},

			lng: {},
			messages: {
				en: {
					title: 'Always ventilate properly with smart ventilation',
					description: 'HAQCS is a control system for devices meant to ensure proper air quality and indoor climate. Wireless, needs-based control and regulation of ventilation devices, humidifiers, air conditioners, air cleaners, etc. Without such devices, the HAQCS monitor can monitor the air quality and remind of the ventilation.',

					haqcsIs: 'The HAQCS-Monitor is ...',
					aController: '... a control unit for ventilation and humidification.',
					aMonitor: '... a measuring device for air quality and indoor climate, as well as ...',

					haqcsAsA: 'The HAQCS monitor as a',
					measuringDevice: 'measuring device',
					controller: 'control unit',

					measuringDeviceTopParagraph: 'The HAQCS monitor can be hung on the wall or placed on a desk, bedside table or similar using the pedestal. It then measures the air quality and shows:',

					historyDisplay: "The 'CO<sub>2</sub> history' display shows you the course of the air quality over the last 3 or 12 hours.",
					comfortDisplay: "On the 'comfort' display you can see a comfort scheme on which the current temperature and relative humidity of the room climate is shown.",

					slideText: [['How exhausted is the air.', 'Important in workrooms, offices, conference rooms, classrooms – wherever intellectual work and learning, in particular, require good concentration. This decreases from 1500 ppm. A CO<sub>2</sub> sensor makes it possible.'], ['How polluted is the air.', 'If there are organic substances in the air, that is a sign of pollution. Evaporations from the human body, kitchen odors, cigarette smoke, chemicals from furniture or paints – TVOC (Total Volatile Organic Compounds) are recorded and displayed.'], ['How good is the indoor climate.', 'People feel comfortable within a certain temperature and humidity window. Insufficient moisture leads to the mucous membranes drying out and ranges from being stressful to being dangerous. Excessive humidity is harmful to the building structure (as it causes mold formation) and therefore also to humans. Measuring the temperature and relative humidity enables the HAQCS monitor to issue warnings.']],

					photoTextLED: 'Thanks to the integrated LED display, the air quality can also be viewed when the display is off.',
					photoTextAlarms: 'When certain air quality limits are exceeded, the HAQCS monitor plays alarms so that you know when you should ventilate.',

					controllerTopParagraph: 'The HAQCS monitor can not only issue warnings to remind you to ventilate your room. In conjunction with compatible ventilation units, it can control the ventilation itself. It is then ventilated as required, i.e. always fresh air without unnecessary heat loss. Even ventilation units with heat recovery do not recuperate 100% of the heat, which makes their efficient operation important.',

					explanationModes: 'The HAQCS monitor offers 3 different automatic modes, a manual mode and a night mode in which the ventilation units it controls are particularly quiet.',
					explanationWeighting: 'The automatic control is based on an adjustable weighting from the measured CO<sub>2</sub> and TVOC values.',
					explanationStormMode: 'With the help of the storm mode you can ventilate intensively in a time controlled manner, for example during a work break.',
					explanationSummerMode: 'By activating the summer mode, you can achieve a cooling effect on devices that support this function.',
					explanationHumidityThreshold: 'If the adjustable moisture limit is exceeded, the ventilation is activated automatically to protect the structure of your building.',

					pCompatible: 'Which ventilation units can be made HAQCS-compatible? The system is open, i.e. all manufacturers of ventilation devices, humidifiers, air conditioners, air purifiers, etc. can make their devices HAQCS compatible. The following options are currently available:',
					alnorHRUWALLString: 'Further development of the well-known HRU-WALL-150-60 from the manufacturer Alnor. <br><br>3 operating levels, summer mode, relatively large volume flows from 20 to 60 m³/h. <br><br>In addition to the HAQCS monitor, it can also be controlled with an app.',
					marleyMEnV180String: 'Marley MEnV 180 and upgrade kit <br> <br> The popular Marley MEnV 180 heat recovery ventilation units can be made HAQCS-compatible with a retrofit kit. Retrofitting is limited to replacing the control board and can be performed within 5 minutes.',
					prana150String: 'Prana 150 and upgrade kit <br> <br> The ventilation units with heat recovery Prana 150 and Prana 200 can quickly be made HAQCS compatible by replacing the control board.',
					simpleFans: 'Simple AC fans without heat recovery',
					simpleString: 'Such fans (even those already installed on your site) can be made compatible with the HAQCS-Unibox. The power line to the fan is simply looped through the Unibox to achieve regulated ventilation.',
					and: 'and',

					kickstarter: 'We are soon going to launch our Kickstarter campaign. Stay tuned!',
					kickstarterSupport: 'Support our project!',

					contact: 'CONTACT',
					areYouInterested: 'Are you interested?',
					contactFormNotice: 'You can also conveniently reach us using our contact form!',
					openContactFormButton: 'open contact form',

					linkContact: '/contact'
				},
				de: {
					title: 'Immer richtig lüften mit intelligent gesteuerten Lüftungsgeräten.',
					description: 'HAQCS ist ein Steuerungssystem für Geräte, die die Luftqualität und das Raumklima sicherstellen. Drahtlose, bedarfsgerechte Steuerung und Regelung von Lüftungsgeräten, Luftbefeuchtern, Klimageräten, Luftreinigern u.ä. Ohne solche Geräte kann der HAQCS-Monitor die Luftqualität überwachen und an die Lüftung erinnern.',

					haqcsIs: 'Der HAQCS-Monitor ist ...',
					aController: '... eine Steuereinheit für Lüftung und Befeuchtung.',
					aMonitor: '... ein Messgerät der Luftqualität und des Raumklimas, sowie ...',

					haqcsAsA: 'Der HAQCS-Monitor als',
					measuringDevice: 'Messgerät',
					controller: 'Steuereinheit',

					measuringDeviceTopParagraph: 'Der HAQCS-Monitor kann sowohl an der Wand aufgehängt, als auch mithilfe des Standfußes auf einem Schreibtisch, einem Nachttisch, oder ähnlichem aufgestellt werden. Daraufhin misst er die Luftqualität und zeigt an:',

					historyDisplay: "Das 'CO<sub>2</sub> history'-Display zeigt Ihnen auf Wunsch den Verlauf der Luftqualität in den letzten 3 oder 12 Stunden.",
					comfortDisplay: "Auf dem 'comfort'-Display können Sie ein Behaglichkeitsschema sehen, auf dem die momentane Temperatur und relative Feuchte des Raumklimas eingezeichnet ist.",

					slideText: [['Wie verbraucht ist die Luft.', 'Wichtig in Arbeitsräumen, Büros, Konferenzräumen, Klassenzimmern – überall dort, wo vor allem geistige Arbeit und Lernen eine gute Konzentration erfordern. Diese lässt ab 1500 ppm nach. Ein CO<sub>2</sub>-Sensor macht es möglich.'], ['Wie verschmutzt ist die Luft.', 'Wenn organische Substanzen in der Luft vorhanden sind, ist das ein Zeichen der Verschmutzung. Ob Ausdunstungen des menschlichen Körpers, Küchengerüche, Zigarettenrauch, Chemikalien aus Möbeln oder Lacken – TVOC (Total Volatile Organic Compounds) werden erfasst und dargestellt.'], ['Wie gut ist das Raumklima.', 'Der Mensch fühlt sich in einem bestimmten Temperatur- und Feuchtefenster wohl. Zu geringe Feuchte führt zum Austrocknen der Schleimhäute und ist belastend bis gefährlich. Zu hohe Feuchte ist für die Bausubstanz (Schimmelbildung) und dadurch auch für den Menschen schädlich. Die Messung der Temperatur und der relativen Feuchte ermöglicht dem HAQCS-Monitor das Warnen.']],

					photoTextLED: 'Dank der LED-Anzeige lässt sich die Luftqualität auch dann einsehen, wenn das Display aus ist.',
					photoTextAlarms: 'Bei der Überschreitung gewisser Grenzen der Luftqualität spielt der HAQCS-Monitor Alarme ab, damit Sie wissen, wann Sie lüften sollten.',

					controllerTopParagraph: 'Der HAQCS-Monitor kann nicht nur warnen um an die Lüftung zu erinnern. In Verbindung mit kompatiblen Lüftungsgeräten kann er das selbst übernehmen. Gelüftet wird dann bedarfsgerecht, d.h. immer ausreichend frische Luft ohne unnötige Wärmeverluste. Auch Lüftungsgeräte mit Wärmerückgewinnung rekuperieren die Wärme nicht zu 100%, wodurch eine energieeffiziente Steuerung wichtig ist.',

					explanationModes: 'Der HAQCS-Monitor bietet 3 verschiedene Automatikmodi, einen manuellen Modus, sowie einen Nachtmodus, in dem die von ihm gesteuerten Lüftungsgeräte besonders laufruhig sind.',
					explanationWeighting: 'Die automatische Reglung richtet sich nach einer einstellbaren Gewichtung aus den gemessenen CO<sub>2</sub>- und TVOC-Werten.',
					explanationStormMode: 'Mithilfe des Sturm-Modus können Sie z.B. während einer Arbeitspause zeitgesteuert intensiv lüften.',
					explanationSummerMode: 'Durch das Aktivieren des Sommermodus können Sie bei Geräten, die diese Funktion unterstützen, einen Kühleffekt erzielen.',
					explanationHumidityThreshold: 'Bei der Überschreitung des einstellbaren Feuchtelimits aktiviert sich die Lüftung automatisch, um die Bausubstanz Ihres Gebäudes zu schützen.',

					pCompatible: 'Welche Lüftungsgeräte können HAQCS-Kompatibel gemacht werden? Das System ist offen, d.h. alle Hersteller von Lüftungsgeräten, Befeuchtern, Klimaanlagen, Luftreinigern u.ä. können ihre Geräte HAQCS-kompatibel machen. Zurzeit bestehen folgende Möglichkeiten: ',
					alnorHRUWALLString: 'Weiterentwicklung des bekannten HRU-WALL-150-60 des Herstellers Alnor. <br><br>3 Betriebsstufen, Sommermodus, relativ große Volumenströme von 20 bis zu 60 m³/h. <br><br>Außer mit dem HAQCS-Monitor, kann alternativ mit einer App gesteuert werden.',
					marleyMEnV180String: 'Marley MEnV 180 und Aufrüstkit <br><br>Die populären Lüftungsgeräte mit Wärmerückgewinnung Marley MEnV 180 können mit einem Nachrüstkit HAQCS-kompatibel gemacht werden. Das Nachrüsten beschränkt sich auf den Austausch der Steuerplatine und ist in 5 Minuten erledigt.',
					prana150String: 'Prana 150 und Aufrüstkit <br><br>Die Lüftungsgeräte mit Wärmerückgewinnung Prana 150 und Prana 200 lassen sich schnell HAQCS-kompatibel machen. Durch den Austausch der Steuerplatine.',
					simpleFans: 'Einfache Ventilatoren für Wechselstrom ohne Wärmerückgewinnung',
					simpleString: 'Solche Ventilatoren (auch die bereits bei Ihnen montierten) können mit der HAQCS-Unibox kompatibel gemacht werden. Die Stromleitung zum Ventilator wird einfach durch die Unibox durchgeschleift und schon haben Sie eine geregelte Lüftung.',
					and: 'und',

					kickstarter: 'Wir starten bald unsere Kickstarter-Kampagnie!',
					kickstarterSupport: 'Unterstützen Sie uns!',

					contact: 'KONTAKT',
					areYouInterested: 'Sind Sie interessiert?',
					contactFormNotice: 'Sie können auch über unser Kontaktformular bequem mit uns Kontakt aufnehmen!',
					openContactFormButton: 'Kontaktformular öffnen',

					linkContact: '/kontakt'
				},
				pl: {
					title: 'Zawsze właściwa wentylacja - inteligentne rekuperatory',
					description: 'HAQCS jest systemem bezprzewodowego sterowania i regulacji urządzeń wentylacyjnych, nawilżaczy powietrza, klimatyzacji, itp. Bez takich urządzeń przypomina HAQCS-Monitor o potrzebie wietrzenia, gdy jakość powietrza się pogarsza.',

					haqcsIs: 'Monitor HAQCS jest ...',
					aController: '... jednostką sterującą urządzeń do wentylacji i nawilżania.',
					aMonitor: '... urządzeniem pomiarowym jakości powietrza i klimatu w pomieszczeniu, a także ...',

					haqcsAsA: 'Monitor HAQCS jako',
					measuringDevice: 'urządzenie pomiarowe',
					controller: 'centrum sterowania',

					measuringDeviceTopParagraph: 'Monitor HAQCS można zawiesić na ścianie lub postawić na biurku, szafce nocnej lub podobnym. Mierzy on jakość powietrza i pokazuje:',

					historyDisplay: "‘CO<sub>2</sub>-history’ przedstawia na życzenie przebieg jakości powietrza w ciągu ostatnich 3 lub 12 godzin.",
					comfortDisplay: "‘comfort’ przedstawia aktualną temperaturę i wilgotność na diagramie komfortu klimatycznego.",

					slideText: [['Na ile powietrze jest zużyte.', 'Ważne w pracowniach, biurach, salach konferencyjnych, klasach szkolnych - wszędzie tam, gdzie praca intelektualna i nauka wymagają szczególnej koncentracji. Spada ona od 1500 ppm. Umożliwia to czujnik CO<sub>2</sub>.'], ['Jak zanieczyszczone jest powietrze.', 'Jeśli w powietrzu są substancje organiczne, oznacza to zanieczyszczenie. Emisje ludzkiego ciała, zapachy kuchenne, dym papierosowy, chemikalia z mebli lub farb - TVOC (Total Volatile Organic Compounds) są rejestrowane i wyświetlane.'], ['Jak dobry jest klimat w pomieszczeniu.', 'Ludzie czują się komfortowo w określonym oknie temperatury i wilgotności. Niewystarczająca wilgotność prowadzi do wysychania błon śluzowych i jest stresująca a nawet niebezpieczna. Nadmierna wilgotność jest szkodliwa dla substancji budowlanej (tworzenie się pleśni), a więc pośrednio także dla ludzi. Pomiar temperatury i wilgotności względnej umożliwia alarmy HAQCS-monitora.']],

					photoTextLED: 'Dzięki wyświetlaczowi LED jakość powietrza można również odczytać, gdy ekran jest wyłączony.',
					photoTextAlarms: 'Po przekroczeniu pewnych limitów jakości powietrza HAQCS-monitor alarmuje przypominając o potrzebie wietrzenia.',

					controllerTopParagraph: 'HAQCS-monitor może nie tylko ostrzegać, aby przypominać o wentylacji. W połączeniu z kompatybilnymi urządzeniami wentylacyjnymi może to zrobić sam. Intensywność wentylacji odpowiada zawsze aktualnym potrzebom, tzn. zawsze świeże powietrze bez niepotrzebnych strat ciepła. Nawet urządzenia wentylacyjne z odzyskiem ciepła nie odzyskują go w 100%, więc ważne jest inteligentne sterowanie.',

					explanationModes: 'Monitor HAQCS oferuje 3 różne tryby automatyczne, tryb ręczny i tryb nocny, w którym sterowane jednostki wentylacyjne są szczególnie ciche.',
					explanationWeighting: 'Automatyczna regulacja opiera się na definiowanej przez użytkownika średniej ważonej zmierzonych wartości CO<sub>2</sub> i TVOC.',
					explanationStormMode: 'Za pomocą trybu intensywnego możesz - np. podczas przerwy - intensywnie przez zadany czas wentylować pomieszczenie.',
					explanationSummerMode: 'Aktywując tryb letni, możesz osiągnąć efekt pasywnego chłodzenia jeśli twoje urządzenia obsługują tę funkcję.',
					explanationHumidityThreshold: 'W przypadku przekroczenia ustawionego limitu wilgotności wentylacja włącza się automatycznie w celu ochrony konstrukcji budynku.',

					pCompatible: 'Które jednostki wentylacyjne są lub mogą być kompatybilne z HAQCS? System jest otwarty, tj. wszyscy producenci urządzeń wentylacyjnych, nawilżaczy, klimatyzatorów, oczyszczaczy powietrza itp. mogą dostosować swoje urządzenia do HAQCS. Obecnie dostępne są następujące opcje:',
					alnorHRUWALLString: 'Następca znanego rekuperatora ściennego HRU-WALL-150-60 od producenta Alnor. <br><br>3 poziomy pracy, tryb letni, stosunkowo duże przepływy od 20 do 60 m³/h. <br><br>Oprócz monitora HAQCS można nim również sterować za pomocą aplikacji.',
					marleyMEnV180String: 'Marley MEnV 180 z zestawem aktualizacyjnym<br><br>Popularne urządzenia wentylacyjne z odzyskiem ciepła Marley MEnV 180 mogą stać się kompatybilne z HAQCS za pomocą zestawu modernizacyjnego. Modernizacja ogranicza się do wymiany płytki sterownika i trwa 5 minut.',
					marleyMEnV180IIHAQCSEditionString: 'Następca popularnego modelu Marley MEnV 180 z licznymi udoskonaleniami.<br><br><b>Zalety to:</b> kompatybilność z HAQCS, podwójne filtrowanie powietrza, wszystkie czynnosći obsługowe od wewnątrz budynku, nowoczesna pokrywa wewnętrzna z kolorowym wskażnikiem stopnia wietrzenia.',
					prana150String: 'Prana 150 i 200 z zestawem aktualizacyjnym<br><br>Urządzenia wentylacyjne z odzyskiem ciepła Prana 150 i Prana 200 można szybko dostosować do HAQCS. Przez wymianę płytki sterownika.',
					simpleFans: 'Proste wentylatory do prądu przemiennego bez odzysku ciepła',
					simpleString: 'Takie wentylatory (nawet te już zainstalowane) mogą stać się kompatybilne dzięki HAQCS-Unibox. W przewód zasilania do wentylatora wpina się Unibox i masz regulowaną wentylację.',
					and: 'i',

					kickstarter: 'Wkrótce rozpoczniemy naszą kampanię Kickstarter. Bądźcie czujni!',
					kickstarterSupport: 'Wspieraj nas!',

					contact: 'CONTACT',
					areYouInterested: 'Jesteś zainteresowany?',
					contactFormNotice: 'Możesz również wygodnie skontaktować się z nami za pomocą naszego formularza kontaktowego!',
					openContactFormButton: 'formularz kontaktowy',

					linkContact: '/kontakt_pl'
				}
			}
		};
	},

	props: ['language'],
	metaInfo: function metaInfo() {
		return {
			title: this.lng.title,
			titleTemplate: '%s | Haplabit',
			htmlAttrs: {
				lang: this.language
			},
			meta: [{ name: 'description', content: this.lng.description }, { name: 'theme-color', content: '#00c853' }]
		};
	}
});

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Contact',
	created: function created() {
		this.checkLng();
	},
	data: function data() {
		return {
			name: '',
			nameErr: true,
			mail: '',
			mailErr: true,
			tel: '',
			telErr: true,
			pref: 'Rückruf (Telefon)',
			message: '',
			messageErr: true,
			showSuccessAlert: false,
			successAlert: '-',
			send: function send() {
				var ok = true;
				this.showSuccessAlert = false;
				this.nameErr = true;
				this.mailErr = true;
				this.telErr = true;
				this.messageErr = true;

				if (this.name === '') {
					ok = false;
					this.nameErr = this.language === 'de' ? 'Bitte geben Sie Ihren Vor- und Nachnamen ein.' : this.language === 'pl' ? 'Proszę podać swoje imię i nazwisko.' : 'Please enter your first and last name.';
				} else if (this.name.indexOf(' ') === -1) {
					ok = false;
					this.nameErr = this.language === 'de' ? 'Bitte geben Sie sowohl Ihren Vor- als auch Ihren Nachnamen ein. Ihr Vor- und Nachname muss mit einem Leerzeichen getrennt sein.' : this.language === 'pl' ? 'Podaj zarówno swoje imię, jak i nazwisko. Twoje imię i nazwisko muszą być oddzielone spacją.' : 'Please enter both your first and last name.';
				}

				if (this.pref === 'Rückruf (Telefon)') {
					this.successAlert = this.language === 'de' ? 'Ihre Nachricht wurde gesendet. Wir werden uns bald mit Ihnen über die von Ihnen angegebene Telefonnummer (' + this.tel + ') in Verbindung setzen.' : this.language === 'pl' ? 'Twoja wiadomość została wysłana. Wkrótce skontaktujemy się z Tobą za pośrednictwem podanego numeru telefonu (' + this.tel + ').' : 'Your message has been sent. We will soon get back to you via your phone nummber: ' + this.tel;
					if (this.tel === '') {
						ok = false;
						this.telErr = this.language === 'de' ? 'Bitte geben Sie eine Telefonnummer an oder wählen Sie ein anderes Kontaktmittel.' : this.language === 'pl' ? 'Podaj numer telefonu lub wybierz wybierz inny sposób kontaktu.' : 'Please enter your phone number or choose a different contact method.';
					}
				} else {
					this.successAlert = this.language === 'de' ? 'Ihre Nachricht wurde gesendet. Wir werden uns bald mit Ihnen über die von Ihnen angegebene E-Mailadresse (' + this.mail + ') in Verbindung setzen.' : this.language === 'de' ? 'Twoja wiadomość została wysłana. Wkrótce skontaktujemy się z Tobą za pośrednictwem podanego adresu e-mail (' + this.mail + ').' : 'Your message has been sent. We will soon get get back to you via your e-mail: ' + this.mail;
					if (this.mail === '') {
						ok = false;
						this.mailErr = this.language === 'de' ? 'Bitte geben Sie Ihre E-Mailadresse an oder wählen Sie ein anderes Kontaktmittel.' : this.language === 'pl' ? 'Podaj swój adres e-mail lub wybierz inny sposób kontaktu.' : 'Please enter your e-mail address or choose a different contact method.';
					} else {
						var atPos = this.mail.indexOf('@');
						var dotPos = this.mail.indexOf('.', atPos);
						if (atPos === -1) {
							ok = false;
							this.mailErr = this.language === 'de' ? 'Bitte geben Sie eine gültige E-Mailadresse an. Berücksichtigen Sie, dass eine E-Mailadresse ein @-Zeichen enthält.' : this.language === 'pl' ? 'Proszę podać poprawny adres e-mail. Pamiętaj, że adres e-mail zawiera znak @.' : 'Please enter a valid e-mail address. Note that an e-mail address contains an @-symbol.';
						} else if (dotPos < atPos) {
							ok = false;
							this.mailErr = this.language === 'de' ? 'Bitte geben Sie eine gültige E-Mailadresse an. Berücksichtigen Sie, dass sich bei einer E-Mail ein Punkt hinter dem @-Zeichen befindet. Beispiel: Max.Mustermann@gmail.com' : this.language === 'pl' ? 'Proszę podać poprawny adres e-mail. Weź pod uwagę, że za znakiem @ w e-mailu znajduje się kropka. Przykład: Max.Mustermann@gmail.com' : 'Please enter a valid e-mail address. Note that e-mail addresses contain a dot after their @-symbol. Example: Joel.Miller@gmail.com';
						}
					}
				}

				if (this.message === '') {
					ok = false;
					this.messageErr = this.language === 'de' ? 'Bitte tippen Sie hier ihre Nachricht ein.' : this.language === 'pl' ? 'Wpisz tutaj swoją wiadomość.' : 'Please enter your message here.';
				}

				if (ok) {
					if (this.tel === '') {
						this.tel = this.language === 'de' ? '(keine Angabe)' : this.language === 'pl' ? '(nieokreślony)' : '(not specified)';
					}
					if (this.mail === '') {
						this.mail = this.language === 'de' ? '(keine Angabe)' : this.language === 'pl' ? '(nieokreślony)' : '(not specified)';
					}

					emailjs.send("default_service", "contact", {
						website: "Hapla",
						name: this.name,
						mail: this.mail,
						tel: this.tel,
						pref: this.pref,
						message: this.message
					});
					this.showSuccessAlert = true;
				}
			},

			checkLng: function checkLng() {
				var _this = this;

				if (this.$route.path.startsWith('/kontakt') || this.$route.path.startsWith('/contact')) {
					setTimeout(function () {
						_this.checkLng();
					}, 500);
					if (this.language !== this.updateLngLastLng) {
						this.updateLng();
					}
				}
			},
			updateLng: function updateLng() {
				this.lng = this.messages[this.language];
				this.updateLngLastLng = this.language;
			},
			updateLngLastLng: '',
			lng: {},
			messages: {
				en: {
					title: 'Contact',
					description: 'Contact formular for Haplabit, our company specializing in the development of the "Hapla Air Quality Control System", a system meant to ensure good air quality and a comfortable indoor climate by controlling ventilation units and humidifiers over a wireless network.',

					contact: 'Contact',
					imprint: 'Imprint',
					send: 'send',

					name: 'First and last name',
					mail: 'E-Mail',
					phonenumber: 'Phone number',
					preference: 'What do you prefer?',
					phone: 'Phone',
					message: 'Message',

					prefContact: 'Preference',
					yourMessage: 'Your message:'
				},
				de: {
					title: 'Kontakt',
					description: 'Kontaktformular für Haplabit, unser Unternehmen, das auf die Entwicklung des „Hapla Air Quality Control System” spezialisiert ist, eines Systems, das durch die Steuerung von Lüftungsgeräten und Luftbefeuchtern über ein drahtloses Netzwerk eine gute Luftqualität und ein angenehmes Raumklima gewährleisten soll.',

					contact: 'Kontakt',
					imprint: 'Impressum',
					send: 'senden',

					name: 'Vor- und Nachname',
					mail: 'E-Mail',
					phonenumber: 'Telefonnummer',
					preference: 'Was ist Ihnen lieber?',
					phone: 'Rückruf',
					message: 'Nachricht',

					prefContact: 'Bevorzugtes Kontaktmittel',
					yourMessage: 'Ihre Nachricht:'
				},
				pl: {
					title: 'Kontakt',
					description: 'Formularz kontaktowy dla Haplabit, naszej firmy specjalizującej się w opracowywaniu „Hapla Air Quality Control System”, systemu mającego na celu zapewnienie dobrej jakości powietrza i komfortowego klimatu w pomieszczeniu poprzez sterowanie urządzeniami wentylacyjnymi i nawilżaczami za pośrednictwem sieci bezprzewodowej.',

					contact: 'Kontakt',
					imprint: 'Impressum',
					send: 'wyślij',

					name: 'Imię i nazwisko',
					mail: 'E-Mail',
					phonenumber: 'Numer telefonu',
					preference: 'Co wolisz?',
					phone: 'Oddzwonić',
					message: 'Wiadomość',

					prefContact: 'Preferowane medium kontaktowe',
					yourMessage: 'Twoja wiadomość:'
				}
			}
		};
	},

	props: ['language'],
	metaInfo: function metaInfo() {
		return {
			title: this.lng.title,
			titleTemplate: '%s | Haplabit',
			htmlAttrs: {
				lang: this.language
			},
			meta: [{ name: 'description', content: this.lng.description }, { name: 'theme-color', content: '#00c853' }]
		};
	}
});

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Contact',
	created: function created() {
		this.checkLng();
	},
	data: function data() {
		return {
			checkLng: function checkLng() {
				var _this = this;

				if (this.$route.path.startsWith('/privacy-policy')) {
					setTimeout(function () {
						_this.checkLng();
					}, 500);
					if (this.language !== this.updateLngLastLng) {
						this.updateLng();
					}
				}
			},
			updateLng: function updateLng() {
				this.lng = this.messages[this.language];
				this.updateLngLastLng = this.language;
			},
			updateLngLastLng: '',
			lng: {},
			messages: {
				en: {
					title: 'Privacy Policy',
					description: 'Privacy Policy of the HAQCS Remote app.'
				},
				de: {
					title: 'Privacy Policy',
					description: 'Privacy Policy of the HAQCS Remote app.'
				},
				pl: {
					title: 'Privacy Policy',
					description: 'Privacy Policy of the HAQCS Remote app.'
				}
			}
		};
	},

	props: ['language'],
	metaInfo: function metaInfo() {
		return {
			title: this.lng.title,
			titleTemplate: '%s | Haplabit',
			htmlAttrs: {
				lang: this.language
			},
			meta: [{ name: 'description', content: this.lng.description }, { name: 'theme-color', content: '#00c853' }]
		};
	}
});

/***/ })

},[438]);


// WEBPACK FOOTER //
// static/js/polyfill.c9d53a1180c1d87cf51f.js